// This file is auto-generated. Do not edit!

export default [
  {
    id: "0xED0A7A49f2228E01a3169C4A5a72a2EbFE8756Dc",
    version: "v1",
    name: "MetaMorpho Test",
    symbol: "MMT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeF010f9cb27031ad51e3333f9aF9C6B1228183",
    version: "v1",
    name: "Steakhouse USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61",
    version: "v1",
    name: "Gauntlet USDC Prime",
    symbol: "gtUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc0c5689e6f4D256E861F65465b691aeEcC0dEb12",
    version: "v1",
    name: "Gauntlet USDC Core",
    symbol: "gtUSDCc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6b13c060F13Af1fdB319F52315BbbF3fb1D88844",
    version: "v1",
    name: "Gauntlet WETH Core",
    symbol: "gtWETHc",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xcf0d2c68cde60C8827Ad901BA5Bfa3C6b42525ee",
    version: "v1",
    name: "prodtest",
    symbol: "prodtest",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9E9a74Ef35b74dfb61B778250304F4Fcb446f268",
    version: "v1",
    name: "Storm USDC",
    symbol: "stormUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc1256Ae5FF1cf2719D4937adb3bbCCab2E00A2Ca",
    version: "v1",
    name: "Moonwell Flagship USDC",
    symbol: "mwUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa0E430870c4604CcfC7B38Ca7845B1FF653D0ff1",
    version: "v1",
    name: "Moonwell Flagship ETH",
    symbol: "mwETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xA2Cac0023a4797b4729Db94783405189a4203AFc",
    version: "v1",
    name: "Re7 WETH",
    symbol: "Re7WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x12AFDeFb2237a5963e7BAb3e2D46ad0eee70406e",
    version: "v1",
    name: "Re7 USDC",
    symbol: "Re7USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEf050a7485865A7a8d8Ca0CC5f7536b7a3443e",
    version: "v1",
    name: "Steakhouse ETH",
    symbol: "steakETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4df778b23A6E4d1E3D15b68ee6AC0E0cc5A2DB93",
    version: "v1",
    name: "aUSDC Test Vault 1",
    symbol: "aUSDC-TV1",
    asset: {
      address: "0xAB8debaEC1eF6Ae0D8B6c20076D1cc47AE3d62F3",
      symbol: "aUSDC",
    },
  },
  {
    id: "0xBEef03f0BF3cb2e348393008a826538AaDD7d183",
    version: "v1",
    name: "Steakhouse USDM",
    symbol: "steakUSDM",
    asset: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xbEEfa1aBfEbE621DF50ceaEF9f54FdB73648c92C",
    version: "v1",
    name: "Steakhouse USDA",
    symbol: "steakUSDA",
    asset: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
  },
  {
    id: "0xBEeFA28D5e56d41D35df760AB53B94D9FfD7051F",
    version: "v1",
    name: "Steakhouse EURA",
    symbol: "steakEURA",
    asset: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
  },
  {
    id: "0xdB90A4e973B7663ce0Ccc32B6FbD37ffb19BfA83",
    version: "v1",
    name: "Degen USDC",
    symbol: "degenUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8c3A6B12332a6354805Eb4b72ef619aEdd22BcdD",
    version: "v1",
    name: "Morpho Degen",
    symbol: "mDEGEN",
    asset: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
  },
  {
    id: "0x30B8A2c8E7Fa41e77b54b8FaF45c610e7aD909E3",
    version: "v1",
    name: "Morpho MAI",
    symbol: "mMAI",
    asset: {
      address: "0xbf1aeA8670D2528E08334083616dD9C5F3B087aE",
      symbol: "MAI",
    },
  },
  {
    id: "0xDd195bc052f172a996d721B25d587A1ea5B8385D",
    version: "v1",
    name: "Re7 USDA",
    symbol: "Re7USDA",
    asset: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
  },
  {
    id: "0xBD596239F71ce6BA9993100fbD5Aff366C9366a1",
    version: "v1",
    name: "Re7 eUSD",
    symbol: "Re7eUSD",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0x578Bf478A3Cf39eCd32bD6f78C784c13b12c865C",
    version: "v1",
    name: "Test verUSDC",
    symbol: "testverUSDC",
    asset: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
  },
  {
    id: "0x6e37C95b43566E538D8C278eb69B00FC717a001b",
    version: "v1",
    name: "Re7 RWA",
    symbol: "Re7RWA",
    asset: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
  },
  {
    id: "0xFE333f2c3c55138fAD556B6C1F1D9103c7268071",
    version: "v1",
    name: "mmTestUSDC",
    symbol: "mmTestUSDC",
    asset: {
      address: "0x5449eCE0580A8287FC42d2634e848eBe8Dc97c07",
      symbol: "testUSDC",
    },
  },
  {
    id: "0x1Dd5e4a1bBD6105bf9F75a963Df2b928c2Aa5391",
    version: "v1",
    name: "mmTestUSDC",
    symbol: "mmTestUSDC",
    asset: {
      address: "0xBC77067f829979812d795d516E523C4033b66409",
      symbol: "testUSDC",
    },
  },
  {
    id: "0xbEefc4aDBE58173FCa2C042097Fe33095E68C3D6",
    version: "v1",
    name: "Steakhouse USDC RWA",
    symbol: "steakUSDCrwa",
    asset: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
  },
  {
    id: "0xbb819D845b573B5D7C538F5b85057160cfb5f313",
    version: "v1",
    name: "Morpho eUSD",
    symbol: "meUSD",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0x6C0d2A9194f00d0121f21253268683644D3d267D",
    version: "v1",
    name: "jEURMetaMorpho",
    symbol: "jEURMM",
    asset: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
  },
  {
    id: "0x4DbD80F8029d5264fAC0b57A16Ac54de512be45A",
    version: "v1",
    name: "EuroMetaMorpho",
    symbol: "EURMM",
    asset: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
  },
  {
    id: "0x305a22602d0f6BCd14aDcC59555A36b0c9c3d76d",
    version: "v1",
    name: "testMetaMorphoUSDC",
    symbol: "testMMUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0FaBfEAcedf47e890c50C8120177fff69C6a1d9B",
    version: "v1",
    name: "Pyth USDC",
    symbol: "pythUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x80D9964fEb4A507dD697b4437Fc5b25b618CE446",
    version: "v1",
    name: "Pyth ETH",
    symbol: "pythETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6FFEe92E508D39A4b3edeB054E8a8B5e0F4BcdD9",
    version: "v1",
    name: "testusdc",
    symbol: "testusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE576EB9DA26c608217729C656c5B2eB3E4278af0",
    version: "v1",
    name: "MAHA.xyz Vault",
    symbol: "MAHAxyz",
    asset: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
  },
  {
    id: "0xBdD1a02e0042ee4B6a89856A8521f78A43Ef6A8C",
    version: "v1",
    name: "MAHA.xyz ZAI Vault",
    symbol: "MAHAxyz-ZAI",
    asset: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
  },
  {
    id: "0xAdcb88C776b97BC9F11f38729409fEe407a44BD9",
    version: "v1",
    name: "Moonwell Flagship EURC",
    symbol: "mwEURC",
    asset: {
      address: "0xa0E430870c4604CcfC7B38Ca7845B1FF653D0ff1",
      symbol: "mwETH",
    },
  },
  {
    id: "0xf24608E0CCb972b0b0f4A6446a0BBf58c701a026",
    version: "v1",
    name: "Moonwell Flagship EURC",
    symbol: "mwEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x1c155be6bC51F2c37d472d4C2Eba7a637806e122",
    version: "v1",
    name: "Gauntlet EURC Core",
    symbol: "gtEURCc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xBeEF086b8807Dc5E5A1740C5E3a7C4c366eA6ab5",
    version: "v1",
    name: "Steakhouse EURC",
    symbol: "steakEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x0E95a6571c39A0f707ED89fb2791F64E57F900C7",
    version: "v1",
    name: "TestUSDCsnARS",
    symbol: "TestUSDCsnARS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x34959fE3F07aBCFD6A159c09e2443E151526078a",
    version: "v1",
    name: "LayerZero vault by fran6.eth",
    symbol: "ZRO | fran6.eth",
    asset: {
      address: "0x6985884C4392D348587B19cb9eAAf157F13271cd",
      symbol: "ZRO",
    },
  },
  {
    id: "0x532A3fB6E00A5DBC2c40b10dec5793538D2E4BF8",
    version: "v1",
    name: "LayerZero vault by fran6.eth",
    symbol: "ZRO | fran6.eth",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1a2970daC83a3Ce5A8c6ecaA4Fe0616724717c82",
    version: "v1",
    name: "Glocusent WETHWEETH",
    symbol: "glocWETHWEETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xc28ca6bFA6C1dfEF94989DC0D0A862eff8d71065",
    version: "v1",
    name: "Glocusent WETH ezETH",
    symbol: "glocWETHezETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x8D1c8b59947E144cad164831a9b12d1030AFCa5A",
    version: "v1",
    name: "Glocusent USDC ezETH",
    symbol: "glocUSDCezETH",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0EeE72D8229c7973b6924A42954287d0d2A1e0e8",
    version: "v1",
    name: "Glocusent USDC weETH",
    symbol: "glocUSDCweETH",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x477966A2AFe996dFC40BFEDd7f5F8A3DedeA5af2",
    version: "v1",
    name: "wUSDR Market",
    symbol: "morpho-WUSDR_USDbC",
    asset: {
      address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
      symbol: "USDbC",
    },
  },
  {
    id: "0x9AC43Dc33f7F60ffd874152Dff7C852c83f662A6",
    version: "v1",
    name: "TestVaultEvix",
    symbol: "TVE",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x70F796946eD919E4Bc6cD506F8dACC45E4539771",
    version: "v1",
    name: "Relend ETH",
    symbol: "reETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xB7890CEE6CF4792cdCC13489D36D9d42726ab863",
    version: "v1",
    name: "Universal USDC",
    symbol: "uUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x98b178F2495F58aA4A285ad363A97782B8EcfCEf",
    version: "v1",
    name: "testOhnoVault",
    symbol: "OhNoMorphoVault",
    asset: {
      address: "0x1fE265dB428Ec5dbCd69e4AECFc47791a4e5F0Bd",
      symbol: "OHNO",
    },
  },
  {
    id: "0x13f9e48e5240bA49F1f1838c81c6eB79c27FD467",
    version: "v1",
    name: "Jarvis jEUR",
    symbol: "mjEUR",
    asset: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
  },
  {
    id: "0xD8a8daD19B1C804dF17D85809f8Fc39286a79938",
    version: "v1",
    name: "testVault 961",
    symbol: "$",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4B7aED325fA8a7e469157b8449Afe5cdd7f87dC6",
    version: "v1",
    name: "MT",
    symbol: "MT",
    asset: {
      address: "0xEC7De4956A4569C2a1D171e4dD115a611c8e9eE5",
      symbol: "ntUSDC",
    },
  },
  {
    id: "0x07eac93b30187093e3c3f654047924cc760C9669",
    version: "v1",
    name: "Kvass ETH",
    symbol: "kETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xdFF60F336a115aade8d9051E068FD4aeeeCCa901",
    version: "v1",
    name: "Kvass USDC",
    symbol: "kUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x586D8a1a7254607E79be7BE81e0E17b83BB1aF69",
    version: "v1",
    name: "Anzen Boosted USDC",
    symbol: "AnzenUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc43f5F199a055F38de4629dd14d18e69dAe9f29D",
    version: "v1",
    name: "Anzen Boosted USDC",
    symbol: "AnzenUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x43Cd00De63485618A5CEEBE0de364cD6cBeB26E7",
    version: "v1",
    name: "Metronome msETH Vault",
    symbol: "gtmsETHc",
    asset: {
      address: "0x7Ba6F01772924a82D9626c126347A28299E98c98",
      symbol: "msETH",
    },
  },
  {
    id: "0xeCE20f4083E043d16afA78451067ef3dAd201F9F",
    version: "v1",
    name: "Krypital USDC Vault",
    symbol: "KGUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6770216aC60F634483Ec073cBABC4011c94307Cb",
    version: "v1",
    name: "Gauntlet cbBTC Core",
    symbol: "gtcbBTCc",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xf0D346E56c037F9933EAbCA0621A875DFEe97339",
    version: "v1",
    name: "Spark USDS Vault",
    symbol: "sparkUSDS",
    asset: {
      address: "0x820C137fa70C8691f0e44Dc420a5e53c168921Dc",
      symbol: "USDS",
    },
  },
  {
    id: "0x32ed54E24F0B00F2de08b9c34E50Db8Aef4A6706",
    version: "v1",
    name: "Spark USDC Vault",
    symbol: "sparkUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0fFDeCe791C5a2cb947F8ddBab489E5C02c6d4F7",
    version: "v1",
    name: "Spark USDS Vault",
    symbol: "sparkUSDS",
    asset: {
      address: "0x820C137fa70C8691f0e44Dc420a5e53c168921Dc",
      symbol: "USDS",
    },
  },
  {
    id: "0x305E03Ed9ADaAB22F4A58c24515D79f2B1E2FD5D",
    version: "v1",
    name: "Spark USDC Vault",
    symbol: "sparkUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x543257eF2161176D7C8cD90BA65C2d4CaEF5a796",
    version: "v1",
    name: "Moonwell Frontier cbBTC",
    symbol: "mwcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe51F91e68D01530fbbCd3D2c9724E841C06ec827",
    version: "v1",
    name: "Re7 cbBTC",
    symbol: "Re7cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xF540D790413FCFAedAC93518Ae99EdDacE82cb78",
    version: "v1",
    name: "9Summits WETH Core",
    symbol: "9SETHc",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x634AEB2e230E6D22cce80f4572436B0bc381103D",
    version: "v1",
    name: "v0",
    symbol: "vZERO",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1108bA213483911F063E5a649199c87fA7BA8429",
    version: "v1",
    name: "MEV Capital USDC",
    symbol: "MCUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8dC4D84F58CcD12c2cadE1823ef320ED48187790",
    version: "v1",
    name: "MEV Capital wETH",
    symbol: "MCwETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x562A128A696b32E942A4b3915055E3ceFE615489",
    version: "v1",
    name: "Ionic Ecosystem WETH",
    symbol: "ionWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0D05e6ec0A10f9fFE9229EAA785c11606a1d13Fb",
    version: "v1",
    name: "Gauntlet LBTC Core",
    symbol: "gtLBTCc",
    asset: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x9aB2d181E4b87ba57D5eD564D3eF652C4E710707",
    version: "v1",
    name: "Ionic Ecosystem WETH",
    symbol: "ionicWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xCd347c1e7d600a9A3e403497562eDd0A7Bc3Ef21",
    version: "v1",
    name: "Ionic Ecosystem USDC",
    symbol: "ionicUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x004Ff85F887aA612CfdAf4B7A19B10eAcfAb32f2",
    version: "v1",
    name: "Re7 cdxUSD",
    symbol: "Re7cdxUSD",
    asset: {
      address: "0xC0D3700000987C99b3C9009069E4f8413fD22330",
      symbol: "cdxUSD",
    },
  },
  {
    id: "0x291D8050ab47E81204bf380EC9C40780c0cACe11",
    version: "v1",
    name: "Basils Vault",
    symbol: "BASIL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDc993d6A15123D094a63194C3f4DAc6e29F0dd50",
    version: "v1",
    name: "Basil Test 2",
    symbol: "BASILS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc5059dF8bEA8531f56546BFe5b32E0ceA56aE800",
    version: "v1",
    name: "Test cbBTC Vault",
    symbol: "test cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x59c09Bc0a4F77cFCEF9FB5Ece1da1cC5516fa7F5",
    version: "v1",
    name: "Test XEQ  Vault",
    symbol: "testRUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd0cfaaB6F33Cc4b13Fc5e25b6c14d86E658E24D4",
    version: "v1",
    name: "BONSAI",
    symbol: "BONSAI",
    asset: {
      address: "0x474f4cb764df9da079D94052fED39625c147C12C",
      symbol: "BONSAI",
    },
  },
  {
    id: "0x5990B44027B248A5902082A5f3280F6a627EB8B4",
    version: "v1",
    name: "0xequity RWA USDC",
    symbol: "rUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x410Eb011542FE96A822c29FB0d4A26D8135b5084",
    version: "v1",
    name: "Yearn USDC",
    symbol: "ymUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x76238B005Dcd48460C2dCce51C92049065702605",
    version: "v1",
    name: "Elixir Capital USDC",
    symbol: "EXRUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x35f49B9443862d667c39673258a7F026F511C5f5",
    version: "v1",
    name: "TestUSDcVault2",
    symbol: "XXtestUSDc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x13B6441f276255b0125D06Aa934079cA8A3c2557",
    version: "v1",
    name: "Testmbr",
    symbol: "tmbr",
    asset: {
      address: "0xFD5D4dca18d565CaD0Fb1064d61c3dd4D9f286aa",
      symbol: "MBR",
    },
  },
  {
    id: "0x60f410c7D3783Dba1C5e840346A86adE8bAA086F",
    version: "v1",
    name: "Sberex WETH Core",
    symbol: "sbxWETHc",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf634F82D21db8F54F4Fc76395Da54a948CF5F16A",
    version: "v1",
    name: "testMetaMorpho",
    symbol: "tmmUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x236919F11ff9eA9550A4287696C2FC9e18E6e890",
    version: "v1",
    name: "Gauntlet USDC Frontier",
    symbol: "gtUSDCf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcC54cf626C133983224ED4c78140Aa1b27Ce58E0",
    version: "v1",
    name: "BadDebtRealizorTest",
    symbol: "BDRT",
    asset: {
      address: "0xFE6cf90Bebfb5578ED415a09028241bc93CA31c3",
      symbol: "TEST",
    },
  },
  {
    id: "0xCBeeF01994E24a60f7DCB8De98e75AD8BD4Ad60d",
    version: "v1",
    name: "Steakhouse High Yield USDC",
    symbol: "sirloinUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0e9C2c54f8B7a6eD18bC543135B0a3ffAE72848A",
    version: "v1",
    name: "Keelat USDC Vault",
    symbol: "kUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2d0bcFEBb18dA6F8AAfDA654dc4113D7492088AE",
    version: "v1",
    name: "Keelat USDC Vault V2",
    symbol: "kUSDCv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6613941C57F33F8B189162071185Bd1ED0d3BbCd",
    version: "v1",
    name: "Aragon Managed USDC Vault",
    symbol: "amUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x55Eb45a07fD7677c6eD6F8fA83a081608dAdE2a8",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x035A66b077B4503968a17fb47AadB1e1512bD3b0",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xca852a984787268f17feae7507aeD0C39804EF50",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCC5881676a6BdcEd2bbDb98f103e87e51630E135",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb9A7f5B8387f0c96525E266Da7ad0301949B4727",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x65A3496756C169D68a81d33cA8aB0CdC514Eb78a",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x492a8287CC32110e1cCB0c8A41c1cCC29c657C36",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc34AD861Ebe7486AdFC965ea2104175E774ac76B",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7023a13aefdd9169f1C162ae2779A215f1cff1c0",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9d6710ce3D883da33A0Eb88d7415E1759344f0e8",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb0D31647D251FEF6A49F934ABf841470e3cb714E",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc0F5F0a07bc4825f18200BbDc5aA1FbD58cC7473",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x64418b3D2c8514488F6aB47f47416AE6D44b008d",
    version: "v1",
    name: "Base Vault Token",
    symbol: "BVT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE531dA9BeE2965aC06Ca4ce93ef514a0D0200D29",
    version: "v1",
    name: "Vault-Tec Live Demo",
    symbol: "vtLIVE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3217b17847c8005f3c68d02f64D2a64370D35B3c",
    version: "v1",
    name: "UnblockEquity TLC — Standard",
    symbol: "ueTLC-STD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9971Cc1eA379AA030f930e8FB62888f245E0a71b",
    version: "v1",
    name: "UnblockEquity TLC — Breathing Room 3",
    symbol: "ueTLC-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x244C7Aa5224aB2344bAb3CBCa150438FAE3f78F0",
    version: "v1",
    name: "UnblockEquity TLC — Breathing Room 6",
    symbol: "ueTLC-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdc427d67e937640EEc4Cc5ccA74895Ff2D3DA577",
    version: "v1",
    name: "UnblockEquity TLC — Breathing Room 12",
    symbol: "ueTLC-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB9dDDCDB1850d54127D61479c0BF24e2cC1C9234",
    version: "v1",
    name: "Sovereign Treasury Yield Vault",
    symbol: "styvUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x58574DB83B5a8427Ef579CE4364Cc0d63A8fbb2A",
    version: "v1",
    name: "Twin ARGt Vault",
    symbol: "tARGt",
    asset: {
      address: "0xf016413834E6D1A14F3D628B11D6Ef725a6bdbDD",
      symbol: "ARGt",
    },
  },
  {
    id: "0x50e038007302fC1655697522B7bCAEd5422003DA",
    version: "v1",
    name: "Spine RWA Potential Vault",
    symbol: "sprwaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7B9A6d04c440fe5E148cbd89924c48BAb09D35de",
    version: "v1",
    name: "wUTXO BTC Yield Vault",
    symbol: "wBTCvUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBbEAb58fF0fB74371eFc6126C6935271D3744145",
    version: "v1.1",
    name: "Elixir Capital USDC",
    symbol: "EXRUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3ea3Bf1A1e543D1d5D17e145e870c9efD3f9F283",
    version: "v1.1",
    name: "do not use",
    symbol: "degenWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5A32099837D89E3a794a44fb131CBbAD41f87a8C",
    version: "v1.1",
    name: "Extrafi XLend WETH",
    symbol: "exmWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x23479229e52Ab6aaD312D0B03DF9F33B46753B5e",
    version: "v1.1",
    name: "Extrafi XLend USDC",
    symbol: "exmUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7BfA7C4f149E7415b73bdeDfe609237e29CBF34A",
    version: "v1.1",
    name: "Spark USDC Vault",
    symbol: "sparkUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x74B6EA9BFee07C3756969b0139CFacBBa5845969",
    version: "v1.1",
    name: "Re7 cdxUSD",
    symbol: "Re7cdxUSD1.1",
    asset: {
      address: "0xC0D3700000987C99b3C9009069E4f8413fD22330",
      symbol: "cdxUSD",
    },
  },
  {
    id: "0x621AF7955e6DaC25D789b115f790666A30D748b8",
    version: "v1.1",
    name: "THOMASCMF VAULT ",
    symbol: "DNT",
    asset: {
      address: "0xBAa5CC21fd487B8Fcc2F632f3F4E8D37262a0842",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x1491CBA488bcF3dC3762558323806a005D009A36",
    version: "v1.1",
    name: "Nekodex USDC Morpho Vault",
    symbol: "nekoUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5496b42ad0deCebFab0db944D83260e60D54f667",
    version: "v1.1",
    name: "9Summits WETH Core 1.1",
    symbol: "9SETHcore",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xC9332Df2fE5461d2E147702cc80068546bBd9214",
    version: "v1.1",
    name: "EarnFAI WETH",
    symbol: "earnfaiWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x616a4E1db48e22028f6bbf20444Cd3b8e3273738",
    version: "v1.1",
    name: "Seamless USDC Vault",
    symbol: "smUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x43338Cc9C514952eBC9c36A842AcEC986EC7CeDB",
    version: "v1.1",
    name: "Re7 wstETH",
    symbol: "Re7wstETH",
    asset: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x9F90A9d1D1a1dEe6ADf16Bb958ED4Dd6107321fa",
    version: "v1.1",
    name: "MaxEarn USDC",
    symbol: "meUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA4e4eC662CA8AA3d759123670CeB6918209e1EDe",
    version: "v1.1",
    name: "OP USDC 2",
    symbol: "opUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x69E02db044bE72386F6eA013E0C599582d954d62",
    version: "v1.1",
    name: "testingW",
    symbol: "TTTW",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5a47C803488FE2BB0A0EAaf346b420e4dF22F3C7",
    version: "v1.1",
    name: "Seamless cbBTC Vault",
    symbol: "smcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x346AAC1E83239dB6a6cb760e95E13258AD3d1A6d",
    version: "v1.1",
    name: "Monarch M1",
    symbol: "M1USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3849EE776BdE7b20b6b09E519136A256e6d25474",
    version: "v1.1",
    name: "testdnu",
    symbol: "testdn",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7Fd62B11654F0DD41AD30EdDa8174366e225E712",
    version: "v1.1",
    name: "Lumetra Opportunistic USDC",
    symbol: "lumenUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x968f3548ed4F96cf11A907848506934A8F42A945",
    version: "v1.1",
    name: "Lumetra Opportunistic WETH",
    symbol: "lumenETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9B7f929f65a103d6dD554D32a00061d523eF29ca",
    version: "v1.1",
    name: "Yoginth",
    symbol: "YOGI",
    asset: {
      address: "0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB",
      symbol: "aBasUSDC",
    },
  },
  {
    id: "0x553b4860242c0BF78a42668Bd296A18dfFba527a",
    version: "v1.1",
    name: "Yoginth's Vault",
    symbol: "YOGI",
    asset: {
      address: "0x0555E30da8f98308EdB960aa94C0Db47230d2B9c",
      symbol: "WBTC",
    },
  },
  {
    id: "0x4Acf04037dBC98Ea0823a8a79467408034740Ecb",
    version: "v1.1",
    name: "TEST DTF Vault",
    symbol: "TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x27D8c7273fd3fcC6956a0B370cE5Fd4A7fc65c18",
    version: "v1.1",
    name: "Seamless WETH Vault",
    symbol: "smWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaEBCeE4B481A724b0C9792e280071386B31a233D",
    version: "v1.1",
    name: "YoYo WBTC Vault",
    symbol: "yoyoWBTC",
    asset: {
      address: "0x0555E30da8f98308EdB960aa94C0Db47230d2B9c",
      symbol: "WBTC",
    },
  },
  {
    id: "0x834821D5f0363932faEF5af4cdE8d4678398CF24",
    version: "v1.1",
    name: "YoYo WETH Vault",
    symbol: "yoyoWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xF8Dc175D96469552182EfAAe8F7c1cdb46726212",
    version: "v1.1",
    name: "Laxmi Chit Fund - WETH",
    symbol: "LCF-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xef417a2512C5a41f69AE4e021648b69a7CdE5D03",
    version: "v1.1",
    name: "Yearn OG USDC",
    symbol: "ymvOG-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7Ce5F356a10BBF528618259404543BB1e6412B69",
    version: "v1.1",
    name: "Test USDC 2",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x00dfDb8C7295a03DCf1ADfF4D21eB5D9D19FB330",
    version: "v1.1",
    name: "Re7 Resolv USR",
    symbol: "Re7USR",
    asset: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0xB17B070A56043e1a5a1AB7443AfAFDEbcc1168D7",
    version: "v1.1",
    name: "Steakhouse sUSDS",
    symbol: "steakSUSDS",
    asset: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xC484D83F667b779cc9907248101214235642258B",
    version: "v1.1",
    name: "Apostro Resolv USR",
    symbol: "aprUSR",
    asset: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0xcdDCDd18A16ED441F6CB10c3909e5e7ec2B9e8f3",
    version: "v1.1",
    name: "Apostro Resolv USDC",
    symbol: "aprUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x50b5b81Fc8B1f1873Ec7F31B0E98186ba008814D",
    version: "v1.1",
    name: "IndeFi USDC",
    symbol: "indeUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF07D7E384D60591BA97611a0CE3CEA3ACE0EFf71",
    version: "v1.1",
    name: "SageFlow Flagship USDC",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x93BB46b3abd806F57273F2bEabCa6E9665DA63CE",
    version: "v1.1",
    name: "test USDC Vault",
    symbol: "test-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE93Dc1151B9aC046F6F6d6f73834cd53dDFA530E",
    version: "v1.1",
    name: "SageFlow Frontier USDC",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xADCAfd0824dfd928d15797239348de95445257bf",
    version: "v1.1",
    name: "SageFlow Frontier ETH",
    symbol: "sfETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf56Fc94C8E43AfD4209c9Ca9ED95190C83F7A424",
    version: "v1.1",
    name: "SageFlow Flagship ETH",
    symbol: "sfETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf488838bFCD9943DFD58670B8f53Be2ff6153b37",
    version: "v1.1",
    name: "Quake USDC",
    symbol: "qUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeA47a35aAa60302B4816D920856DDC708Ad181f6",
    version: "v1.1",
    name: "Alpha wETH Core",
    symbol: "aWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x487F87327Bbb0f6Bc58D8f1F28308D3F16014377",
    version: "v1.1",
    name: "Balloon Morpho Strategy 1 ",
    symbol: "BalloonUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9F71292c1d8dbaC1Be75D7A8b198443eC28140f1",
    version: "v1.1",
    name: "SageFlow USDC Prime",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe4f42F0d30704f9828561800c1E6b613618d59c1",
    version: "v1.1",
    name: "SageFlow USDC Core",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x61A8F695a70006b68575f8807be23D4f8b3216df",
    version: "v1.1",
    name: "SageFlow USDC Lite",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE841098de0e2E4956D486af137acdB5bBdd3e238",
    version: "v1.1",
    name: "SageFlow USDC Vault",
    symbol: "sfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1D3b1Cd0a0f242d598834b3F2d126dC6bd774657",
    version: "v1.1",
    name: "Clearstar USDC Reactor",
    symbol: "CSUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x893c4FbF409Eb6CdB56834309761f9997Ac2Df9F",
    version: "v1.1",
    name: "Managed Yield Vault",
    symbol: "MYV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0FE5b4aF0337Fd5b2E1675D5f5E8c9101E4D3c7e",
    version: "v1.1",
    name: "Gauntlet sUSDS Core",
    symbol: "gtSUSDSc",
    asset: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xBeeFa74640a5f7c28966cbA82466EED5609444E0",
    version: "v1.1",
    name: "Smokehouse USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x37E6C71c64163f2C343d5eF8eecbe6C9EA1B09Ec",
    version: "v1.1",
    name: "Balloon Direct Morpho Vault",
    symbol: "BalloonUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0ab57222865631b6c921F5bE8cE9A9588dE3e326",
    version: "v1.1",
    name: "Balloon Morpho Strategy 2",
    symbol: "BalloonUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD7F3671eAcA86Af5faC017d353C3C80ECE4B199d",
    version: "v1.1",
    name: "TestUSDcVault3",
    symbol: "3testUSDc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE6840572fA4d1DB9f85A80b6Ff7e198DEa5466Fb",
    version: "v1.1",
    name: "base-test",
    symbol: "base-test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x95F3F0C5e53B325b7E5eB342df9C508fC384c35d",
    version: "v1.1",
    name: "Blend USDC",
    symbol: "bUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x687DfeCD7950a17236C51b517FaE2F9279FFC88d",
    version: "v1.1",
    name: "Not Gauntlet",
    symbol: "AUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xECC01B64dbB1E6DA6F2c431207B71768A2d3754a",
    version: "v1.1",
    name: "testMetaUSDC",
    symbol: "testMUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeef2dc30633221Fa51A1C3e5299BFf8C69fc0A8",
    version: "v1.1",
    name: "Safe x Steakhouse ETH",
    symbol: "safe-steakETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xbeEFe1372c0A384aCEcBe8a0Adf3c94c389F6704",
    version: "v1.1",
    name: "Safe x Steakhouse USDC",
    symbol: "safe-steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x01F0383414a50804D4E43Df6Cc99962EEd78A9DE",
    version: "v1.1",
    name: "sus",
    symbol: "sus",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x77d9703D9582af8F204DDd005613dff70396c733",
    version: "v1.1",
    name: "WETH TEST DA",
    symbol: "DTEST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xb2B5FB2849BcaF6E40FC8a2b8Dc8adeb32EF5490",
    version: "v1.1",
    name: "Balloon Morpho Vault",
    symbol: "Balloon",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa657e58d8530e9727a8241C6991be4790d0Ea470",
    version: "v1.1",
    name: "Magic Genie USDC",
    symbol: "mgUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb89b0b01e892a98775DE8ae110b01A59E796F34F",
    version: "v1.1",
    name: "sus1",
    symbol: "sus1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x730a8F9c875695692FE6BaBBf86AD8fAF457688B",
    version: "v1.1",
    name: "esabtset",
    symbol: "ATB",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1D795E29044A62Da42D927c4b179269139A28A6B",
    version: "v1.1",
    name: "Yearn OG WETH",
    symbol: "ymvOG-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x523bce930C50D45beBdB78ffA4eCc0D2D6AfB989",
    version: "v1.1",
    name: "Nummus USDC",
    symbol: "nUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x829232B6DfC70E529e8268c42E656EE35b448922",
    version: "v1.1",
    name: "yldr test vault",
    symbol: "ytUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbfFb7d0c4E6a9a1264B458671E266af01a4B86e6",
    version: "v1.1",
    name: "Magic Genie cbBTC",
    symbol: "mgBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x8398bc2D9A04BFc8865EF14139544220163be038",
    version: "v1.1",
    name: "Magic Genie WETH",
    symbol: "mgETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xE74c499fA461AF1844fCa84204490877787cED56",
    version: "v1.1",
    name: "Yield Clearstar USDC",
    symbol: "YCSUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA341Cc6028d87b50E2A09BfD7e205C231bbA9adc",
    version: "v1.1",
    name: "Max Yield USDC",
    symbol: "myUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x997ad9EB11B397a2B082A3ab0BA36B798b81A287",
    version: "v1.1",
    name: "Poindexter",
    symbol: "PD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9810Ad4E48E0fe1533fE9f35F6BB1237339167e1",
    version: "v1.1",
    name: "Test-vault",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x65e273a37dcDd310170E580883Ac9148AE6C03dD",
    version: "v1.1",
    name: "Ceres USDC Vault",
    symbol: "ceresUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3aC2bBD41D7A92326dA602f072D40255Dd8D23a2",
    version: "v1.1",
    name: "Morpho Base wETH",
    symbol: "aT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9d58a6c81d5ed6eE64BcF3D2d74E2CCf476dAb55",
    version: "v1.1",
    name: "Morpho Base cbETH",
    symbol: "aTcbEth",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6e6E070EeAeca296D797083F2Bf3F207Cce91DFA",
    version: "v1.1",
    name: "0xf99 Prudent",
    symbol: "PrudentUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x43132f06F14358F8c180b61D2F0CF33Dc539aE5D",
    version: "v1.1",
    name: "god mode USDC",
    symbol: "gmUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x190b70dC5453E09763692315498D4eaD1E37CaA4",
    version: "v1.1",
    name: "yieldUSDC",
    symbol: "ydUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA2E10FF0bD30Ea830a12cA68Cb91e35711024Fb8",
    version: "v1.1",
    name: "Cygnus USD Vault",
    symbol: "wcgUSDm",
    asset: {
      address: "0x5AE84075F0E34946821A8015dAB5299A00992721",
      symbol: "wcgUSD",
    },
  },
  {
    id: "0x9fd4Ff2A703f87E075f01186b8a6a1c22B158F01",
    version: "v1.1",
    name: "test1",
    symbol: "test1",
    asset: {
      address: "0x5AE84075F0E34946821A8015dAB5299A00992721",
      symbol: "wcgUSD",
    },
  },
  {
    id: "0x2bd8E864b7E3c29bDED0Ba72f17Cc9f328fc861D",
    version: "v1.1",
    name: "aaa",
    symbol: "bbbb",
    asset: {
      address: "0x5AE84075F0E34946821A8015dAB5299A00992721",
      symbol: "wcgUSD",
    },
  },
  {
    id: "0x2f6b643468A025F8Ae0F81A9615737c3Ff61E14F",
    version: "v1.1",
    name: "testusdc",
    symbol: "testusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa62a3b5F3BC3A861964284d597e796B6f987E015",
    version: "v1.1",
    name: "Natural Intelligence USDC",
    symbol: "NAUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x57be8d288a47644Df1aa6F25DCb788F0bF420B7a",
    version: "v1.1",
    name: "VAULT-TST",
    symbol: "TVLT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1023a5d3E3e7E1010d8444E67e6A50DC341fdd8F",
    version: "v1.1",
    name: "Vaulter White",
    symbol: "VWT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe771e7284C06624423967f8BE86280404Ad93015",
    version: "v1.1",
    name: "esabtsetu",
    symbol: "ATBU",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB8174209a3cDBdf1Be3324A8999E852c27C21831",
    version: "v1.1",
    name: "BRZ Lending",
    symbol: "BRZL",
    asset: {
      address: "0xE9185Ee218cae427aF7B9764A011bb89FeA761B4",
      symbol: "BRZ",
    },
  },
  {
    id: "0x21424d444cf1A5Cd3934928429C704bDc2263550",
    version: "v1.1",
    name: "BRZ Borrow",
    symbol: "BRZB",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC0ef2905ad0Ac423D5434ce89Eafe1F2C5bD6030",
    version: "v1.1",
    name: "Testing with Frens",
    symbol: "dTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe4e956f8f1C4D72114731184Fdc8a26238eB9351",
    version: "v1.1",
    name: "Seamless USDC Vault",
    symbol: "cp-smUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xde9efc355A78DfEBE386E15A2923b23f59ED2eD9",
    version: "v1.1",
    name: "Nonce WETH Vault",
    symbol: "nonceWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x61643dc4E31E14Eb7dd61F748aBbc445Cc55F5c4",
    version: "v1.1",
    name: "dForce Stablecoin Yield Vault",
    symbol: "dUSX",
    asset: {
      address: "0xc142171B138DB17a1B7Cb999C44526094a4dae05",
      symbol: "USX",
    },
  },
  {
    id: "0xcDa25c2f8a15173CE35680975D5388A4dBb0f33D",
    version: "v1.1",
    name: "NTT Vault",
    symbol: "NTTVAULT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x363Ab339d660504842A73C7EafD136BE2EfE9F9a",
    version: "v1.1",
    name: "Test Api3 USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcb924BFaCBfa9401129Cb89A2093cd8a5a4Abd62",
    version: "v1.1",
    name: "Notional USDC",
    symbol: "notional-base-usdc-test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x28c428F3a2FAa33E83B5D95A73E924868bdA6272",
    version: "v1.1",
    name: "Starta FX: Staked BRZ",
    symbol: "STBRZ",
    asset: {
      address: "0xe2A82e35AdB51c9A5a49c0a516C48741868C5060",
      symbol: "stBRZ",
    },
  },
  {
    id: "0x6649D46529De661Ec1E4eB5a18866f15888d7D88",
    version: "v1.1",
    name: "Secure USDC",
    symbol: "Secure_USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd94E1f298B38F96f45005A048551339c0Fffef5f",
    version: "v1.1",
    name: "Dream Charity - USDC",
    symbol: "dreamUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF6190F97f7AE540234f5924B8992b9C3FD8381b9",
    version: "v1.1",
    name: "Jarvis USDC",
    symbol: "mjUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBaa2CB1EC94a03758B924561b89aC5BcCb970161",
    version: "v1.1",
    name: "Starta FX: USDC",
    symbol: "SFXU",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6814F557Ee4A3C875B91BC5623be5e489425F689",
    version: "v1.1",
    name: "Kula",
    symbol: "Kula",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x167B3A4cb0a026b90558303fAD3AFF1AD90a8FC5",
    version: "v1.1",
    name: "Enter_The_Loop",
    symbol: "AiSTR.L",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x2484baadCE88942CF9d683686A35fa41B3EEEA75",
    version: "v1.1",
    name: "Talentir EURC",
    symbol: "talentirEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xb45832f5FD63dD9fBEAa85eFDed05ccf034f35e5",
    version: "v1.1",
    name: "Test Vault USDC 1",
    symbol: "tv1USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x81478F129D5E034E4dF0F17a67c98242A4951020",
    version: "v1.1",
    name: "Jarvis USDC",
    symbol: "mjUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc35384E639951D52a938ee585BEfE12120eAaE31",
    version: "v1.1",
    name: "TurkeyCash2",
    symbol: "TKS2",
    asset: {
      address: "0x75B578f5566117E1c845B23C33F52b92e3821826",
      symbol: "TKS2",
    },
  },
  {
    id: "0xFdf351AADD626F6A816bdAE815ECAc065048b075",
    version: "v1.1",
    name: "TurkeyCash",
    symbol: "TCSH",
    asset: {
      address: "0x75B578f5566117E1c845B23C33F52b92e3821826",
      symbol: "TKS2",
    },
  },
  {
    id: "0xf7e26Fa48A568b8b0038e104DfD8ABdf0f99074F",
    version: "v1.1",
    name: "Muscadine USDC Vault",
    symbol: "mvUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC552d3c402942fb0FeC50d0544E70a7C77778d45",
    version: "v1.1",
    name: "Elara-Test-Vault",
    symbol: "Elara-TV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a9d02219Be7dEF2d4a324CBA3449911c28D3999",
    version: "v1.1",
    name: "Supersafe USDC",
    symbol: "IDLE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFfedad42083E2Eb8Ca401F09c0038A9DeD7eF8e5",
    version: "v1.1",
    name: "Allez USDC",
    symbol: "AllezUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAeCc8113a7bD0CFAF7000EA7A31afFD4691ff3E9",
    version: "v1.1",
    name: "Muscadine cbBTC Vault",
    symbol: "mvcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x21e0d366272798da3A977FEBA699FCB91959d120",
    version: "v1.1",
    name: "Muscadine WETH Vault",
    symbol: "mvWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe49101A8Aed751522feeA378DC793077Cf06208F",
    version: "v1.1",
    name: "New USDC T",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8AC6BB3c998C63a8D2a718a6C1affb3069543257",
    version: "v1.1",
    name: "TFT USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3E3Cbfd1046C9D1863F83879cc5541B0B789Ec03",
    version: "v1.1",
    name: "Genius Vault",
    symbol: "wstETHgen",
    asset: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x41C539f7Ae746312b9BDf6C875dbF95A8299E722",
    version: "v1.1",
    name: "Yakov's Dream Charity",
    symbol: "DREAM",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1D322633f0af9e37e3A709d8Fd4eB59684231576",
    version: "v1.1",
    name: "Starta USDC Pre-Deposit Vault",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x61D857488519cDF78E2640FAb86fC731F991015E",
    version: "v1.1",
    name: "Fundion EURC Base",
    symbol: "fEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x9524Ecbec4c22417cbCb08a4fc98eAC9CE75A6A1",
    version: "v1.1",
    name: "Clearstar ETH Ground State",
    symbol: "CSETHGS",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x39B62ebF77e839aFB986aE96AD7D6f00806fD4E2",
    version: "v1.1",
    name: "Prime Testing USDC",
    symbol: "TPUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x17A24f6F632C0ac8D278539224341d34641D7e9C",
    version: "v1.1",
    name: "Prime Testing USDbC",
    symbol: "TPUSDbC",
    asset: {
      address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
      symbol: "USDbC",
    },
  },
  {
    id: "0x03d6afcE8f842590A4f16FCD3127Da8C4B2909F5",
    version: "v1.1",
    name: "SW USDC vault",
    symbol: "SWUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE56EfFDaCBA30CF13F62DF55146E079d07EBd48a",
    version: "v1.1",
    name: "RIMU USDC",
    symbol: "RIMUusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2b402E91DEC397e5fB9Fa857EDA6558Fe7CA5D67",
    version: "v1.1",
    name: "Landforge Premier USDC",
    symbol: "lfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x994F1E780f9ac0Dc72ad3C27dd4270A4B5350c19",
    version: "v1.1",
    name: "maxeymum",
    symbol: "mym",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x26c9Fa1A5E95D249a099dB46df12437EE762c457",
    version: "v1.1",
    name: "USDC Test Vault",
    symbol: "USDCtv",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x460Fc07e23c731424B2eCF6264C50dE5C164519b",
    version: "v1.1",
    name: "Idle Liquidity",
    symbol: "IDLE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB75242035e7389128e6dC7059c6084d691b4CDC6",
    version: "v1.1",
    name: "TEST-BASE-1",
    symbol: "tbtb1",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x30b5b9D6F143C5FDBBB5b73cd6d88A798Eb50E36",
    version: "v1.1",
    name: '"Test Term USDC 1"',
    symbol: '"testTermUSDC1"',
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x239f77CaFfF6d2E5F2FCd2E616b1a299FF161Fa6",
    version: "v1.1",
    name: '"Test Term USDC 2"',
    symbol: '"testTUSDC2"',
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x708e07409393269b255750559A305624c89c25cF",
    version: "v1.1",
    name: "演唱会",
    symbol: "p1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb82BDf1c637A7039684D27A4485Cc5458DAB60df",
    version: "v1.1",
    name: "Landforge Foundry ETH",
    symbol: "lfETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1BFaC80c1FBdD865951FaF256c56F2fC0f456b8f",
    version: "v1.1",
    name: "Landforge Boost EURC",
    symbol: "lfEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x2365975ca06f99d5da5Acfc70f2581B8D194f8aa",
    version: "v1.1",
    name: "Alpha USDC Core",
    symbol: "aUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4A4dE4757d2A04D1E12BCC21068288CAAD6e19a7",
    version: "v1.1",
    name: "Alpha cbBTC Core",
    symbol: "acbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xDDD64e2EF73b0741BdB1e2813a1115FD150aef36",
    version: "v1.1",
    name: "TestMS5",
    symbol: "TMS5",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4d0c02edE624bFAD1eDe4b27A8871C8BDf648D5A",
    version: "v1.1",
    name: "Valentine Grok Companion",
    symbol: "Valentine",
    asset: {
      address: "0x275709545d5Be92f7f44E649ab161304F72a68DA",
      symbol: "Valentine",
    },
  },
  {
    id: "0x68d5D791C976ec87bb0b3f0347A0a42D39559F3A",
    version: "v1.1",
    name: "Valentine",
    symbol: "Valentine",
    asset: {
      address: "0x275709545d5Be92f7f44E649ab161304F72a68DA",
      symbol: "Valentine",
    },
  },
  {
    id: "0x931Ef586AC15E7ecC5d761FDf609b11Cd218076E",
    version: "v1.1",
    name: "Super USDC Vault",
    symbol: "SUV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFE94c8aD530842bfE7d8B397938fFc1cb83b2",
    version: "v1.1",
    name: "Steakhouse Prime USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFA7B88064FeEF0cEe02AAeBBd95D30df3878F",
    version: "v1.1",
    name: "Steakhouse High Yield USDC v1.1",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x31b9378B03959f262c77BC8D138a95BAF12d242b",
    version: "v1.1",
    name: "VeloForge Vault USDC (Base)",
    symbol: "vfUSDC-B",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x85901E44FB8Bff7d777333b4376bED463678e3a5",
    version: "v1.1",
    name: "Idle USDC Vault",
    symbol: "IDLEVAULT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x851f93e38214f345747Ea63CB7B115c9Cb30C4d9",
    version: "v1.1",
    name: "Testing USDC",
    symbol: "TesUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x09832347586E238841F49149C84d121Bc2191C53",
    version: "v1.1",
    name: "Clearstar ETH Reactor",
    symbol: "CSETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x50611C24A518a0b19Bde4f4C5f9Fd1Ca0678C38f",
    version: "v1.1",
    name: "TESTUSDX-BC",
    symbol: "TUSDC-BC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAaC37E1FF0ba2dd84d3e3Db813F72fe13Ec66e63",
    version: "v1.1",
    name: "Master Vault",
    symbol: "MVault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x68AA3790A192e46810a8b423980b96924662BBA8",
    version: "v1.1",
    name: "Macro USDC Vault",
    symbol: "mcUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x42000000377415b0A59953E22ad945fE047479Fe",
    version: "v1.1",
    name: "Morph WETH",
    symbol: "MWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x639cFB7f543ae9820a3B63e88838fE9570ad4D72",
    version: "v1.1",
    name: "Basta Vault",
    symbol: "BS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9FDe43beC7be489a6D6833a383EF1df3852AF701",
    version: "v1.1",
    name: "test usdc vault",
    symbol: "TESTUSDC1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8333dCCcfB6F76dD1AFB03ED0f8c46954aaCC304",
    version: "v1.1",
    name: "Morph USDC",
    symbol: "MUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA6e6546b50b6b1b7e0cF97fA6C2636901B447cB2",
    version: "v1.1",
    name: "Testing vault",
    symbol: "TE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF4C76665312ad43DB5BA748DEC049d20123A6183",
    version: "v1.1",
    name: "Goatlend USDC Core",
    symbol: "GUC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD5e139AC7231925776d629b666D9b88940Ca53a9",
    version: "v1.1",
    name: "Elixir Capital ETH",
    symbol: "EXRWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4432Db42062A338aA17553D5AB828C1D8BD8d3e7",
    version: "v1.1",
    name: "test-v1-vault-usdc",
    symbol: "test-v1-vault-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE2647d21612A7ba3C9b61825C2e28c0796226ae6",
    version: "v1.1",
    name: "Snow USDC",
    symbol: "wUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x106f41EF60eE31C61162B0b4ba565C54E548cE42",
    version: "v1.1",
    name: "AI Balance USDC Vault",
    symbol: "AIUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9440a44E6658F52B20095e641dc00a7DA37983FF",
    version: "v1.1",
    name: "Henk Industries",
    symbol: "Henk",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE007b1C90A5FB7527F47db7d450b8bD31d793205",
    version: "v1.1",
    name: "Statera Frontier USDC",
    symbol: "stfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfc8a325A2403CD940649B48ffcDfC250e084A27C",
    version: "v1.1",
    name: "dForce USDC",
    symbol: "dForce USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBf1E66A36646Bb589199aa24e67EbDcDBEb452A1",
    version: "v1.1",
    name: "dForce WETH",
    symbol: "dForce WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x76987f469C0fEf310e233378f061471D7d1Ca224",
    version: "v1.1",
    name: "test vault grim",
    symbol: "tstgr",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2C6F29324b0D915Fa2b0875633b018263113F54E",
    version: "v1.1",
    name: "dForce WETH Prime",
    symbol: "dForce WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x29A2573CE2Ee8fD75a99Cf78eD773D12596a9115",
    version: "v1.1",
    name: "Test USDC Vault",
    symbol: "tUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD37F32464461B51a739e0D8F7A4AB99Be6d4fa36",
    version: "v1.1",
    name: "ABRC",
    symbol: "abrc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x00002286c5f786544f938af4282D0deD9236db8f",
    version: "v1.1",
    name: "Jason The Whale",
    symbol: "JTW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x00000C4529222293D4C3c1d0d9bdBfc8DBf37E5c",
    version: "v1.1",
    name: "Jason The Whale Test",
    symbol: "JTWT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0000F0bCf156ec9Fca2510b3200f87609e34cF5D",
    version: "v1.1",
    name: "Goatlet USDC Frontier",
    symbol: "gotUSDCf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFdA6d373932414666aFC0dBd23d6857D43465cD9",
    version: "v1.1",
    name: "Safe Test",
    symbol: "SAFETEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8773447e6369472D9B72f064Ea62e405216E9084",
    version: "v1.1",
    name: "MEV Frontier USDC Vault",
    symbol: "mevfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa953a8Dae111dEeDFFbF0Eeaf1e52efeC00869D8",
    version: "v1.1",
    name: "DEMO",
    symbol: "DEMO",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0F63Cb6Bd9fE2a03197631b4Fd4E1EFACDE610D4",
    version: "v1.1",
    name: "Mesa aUSDC",
    symbol: "mesa-aUsdc",
    asset: {
      address: "0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB",
      symbol: "aBasUSDC",
    },
  },
  {
    id: "0x9a1e1cB58Db7a70d58DcF1352F3D56d392BE7d8C",
    version: "v1.1",
    name: "1",
    symbol: "1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5Ec9b876ADCb676887393573801e0A8d0E283C12",
    version: "v1.1",
    name: "Moonwell Growth/Outperform USDC",
    symbol: "vWELL",
    asset: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0x45F8712D3E24B6cd20791B326736413aBC8393FD",
    version: "v1.1",
    name: "V1",
    symbol: "V1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x13FC9e5456c5A272636f1cdb6d2E17524CD1c703",
    version: "v1.1",
    name: "Moonwell Growth/Underperform USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCc8862573Cf12A919FbD33182eA3C4D6F9a96945",
    version: "v1.1",
    name: "Moonwell Growth/Underperform USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0EEb777caD5af7A0820ca7eEDe4483280E91074D",
    version: "v1.1",
    name: "Moonwell Growth/Underperform USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF4d4fCDdE388408C7A295E1C34C7B204bC0b4BAC",
    version: "v1.1",
    name: "Lunar Labs Treasury USDC Vault",
    symbol: "llUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC30b13a402E4552bF9b37dDc329a10187a9bd368",
    version: "v1.1",
    name: "test USDC",
    symbol: "ttUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x858d76b324A99698F4b323650364163195a97869",
    version: "v1.1",
    name: "USDC",
    symbol: "ttUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x08fF490aC96eDE9649f8b02bb743FE9573720acB",
    version: "v1.1",
    name: "USDCA",
    symbol: "ttUSDCA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBfD43829aBAC6482658Bd2A8099a0fAC787937eA",
    version: "v1.1",
    name: "USCA",
    symbol: "ttUSCA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x966108C8Bf93f1Ed0D6a0F70804D0fE2Cb7056be",
    version: "v1.1",
    name: "USA",
    symbol: "ttUCA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc8964c47f7284d61DEf2124DcfEA8faC63c519F2",
    version: "v1.1",
    name: "SA",
    symbol: "tUCA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa44898cC162570a7Fd7F35DB8B4F6ED937e71784",
    version: "v1.1",
    name: "SA",
    symbol: "tUA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x219124581eD32b1722D7069509D6e28e2A9CF25A",
    version: "v1.1",
    name: "S",
    symbol: "tUA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf3e8C172ff76fAd9bD5225E23a198556888e6911",
    version: "v1.1",
    name: "SK",
    symbol: "xUA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x30a2eF7b48a20ee21401B064c3817b1e82711BA3",
    version: "v1.1",
    name: "xK",
    symbol: "xUA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7dB0AF29CE0b830419B1E3bE191afcaE35109C8C",
    version: "v1.1",
    name: "xs",
    symbol: "xsUA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0F362D1cf351CcFB2ac6D1AD9ac7a75bE24B2454",
    version: "v1.1",
    name: "xsd",
    symbol: "xsUdA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeC8F9fbA803Fd25e3E7E850874A63Bb7cC2b5dF4",
    version: "v1.1",
    name: "xsds",
    symbol: "xsUdA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x22F5F455BCab721539A624DDa93F2ccbC7F428F6",
    version: "v1.1",
    name: "xxjsds",
    symbol: "xsUddA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x584b9C250d05B85155CA80155a4B5335422543D9",
    version: "v1.1",
    name: "xxjsdss",
    symbol: "xsUddAs",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2d219a3701690ba7F9C75A31041dca1b0a66815c",
    version: "v1.1",
    name: "testvault",
    symbol: "tv",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0e6f4BEF3785f746Cddb9fe8Db70ce9b0a25A02F",
    version: "v1.1",
    name: "My Cool USDC Vault on Base",
    symbol: "MyCool-Usdc-Base",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5849310f7Bf3B5212B097FA2E3ae783C197E8DE5",
    version: "v1.1",
    name: "vTAO USDC",
    symbol: "vTAOUSDC",
    asset: {
      address: "0xe9f6D9898f9269B519E1435E6ebafF766c7f46BF",
      symbol: "vTAO",
    },
  },
  {
    id: "0x2fa8259754Cf99aA14C1B2EAC252e6B6dcBF213e",
    version: "v1.1",
    name: "test-vault-xyz",
    symbol: "TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x02f0f39E72574cA6cD3bF724E6A5d1b334C36257",
    version: "v1.1",
    name: "tv",
    symbol: "tv",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0cF39718D5E9b60548fD43fcC4D95b9f9c6a1698",
    version: "v1.1",
    name: "tv2",
    symbol: "tv",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x05CF55f4FDd7aB59c9521D1777a1943aEDB77195",
    version: "v1.1",
    name: "tv2",
    symbol: "tv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x32285fc9182e7548D3A465fEFc210cbd831BEDd8",
    version: "v1.1",
    name: "tvzku3s3d4lg",
    symbol: "tvzku3s3d4lg",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCA46b019e4e0F94Fa9A10658Bfc7bf8284A822c1",
    version: "v1.1",
    name: "tv1yslj37c4hji",
    symbol: "tv1yslj37c4hji",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE418FCa87f28F3C1bd30dFeb4422B20a12850A8f",
    version: "v1.1",
    name: "tvbkkzpt505pp",
    symbol: "tvbkkzpt505pp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAC942A21aFf1632dFfE1CD7F51423cB9ff57c3D6",
    version: "v1.1",
    name: "tviytm6o5wf5h",
    symbol: "tviytm6o5wf5h",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2d6fF0c99DE372f00Cb78f91Ae251d39906F19c6",
    version: "v1.1",
    name: "tv2hr5o0xrals",
    symbol: "tv2hr5o0xrals",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0442F2566BA8563DE6A92c8088188041a7eEf567",
    version: "v1.1",
    name: "tvo0mni5kue4c",
    symbol: "tvo0mni5kue4c",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFCc42Ca564BD21283571a6FA6549E612D7ca8269",
    version: "v1.1",
    name: "tvbp0fnnv8m0i",
    symbol: "tvbp0fnnv8m0i",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1333cFD34A7dd43E02676F81E1887da373307C44",
    version: "v1.1",
    name: "tvgi1mlw6idbw",
    symbol: "tvgi1mlw6idbw",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe80dFECea45b9FF399F6b9Dd0c01B430c62e988d",
    version: "v1.1",
    name: "tv6wvymheuhfb",
    symbol: "tv6wvymheuhfb",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x82D8d67a2227708eeA0f553F55865C74Eb99eBAc",
    version: "v1.1",
    name: "tv4wf1spjzg88",
    symbol: "tv4wf1spjzg88",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x50393daFf5d36B32EF7c43039a361148d0D2b454",
    version: "v1.1",
    name: "tvq5ocq29xd0r",
    symbol: "tvq5ocq29xd0r",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xec0Db3e0653fa2B804aB5Ba0eF55bf4F2A1af69C",
    version: "v1.1",
    name: "tvb55hrwgya6",
    symbol: "tvb55hrwgya6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x668bBD1efaa6A53AeD3f4D55403D0870FAb251b5",
    version: "v1.1",
    name: "tvz6ks8cfxw4",
    symbol: "tvz6ks8cfxw4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x16238A6532AC271B41C481dBF0DE6E334d8603E1",
    version: "v1.1",
    name: "tvcn81bs0v54",
    symbol: "tvcn81bs0v54",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x54a11912610243039E37ea5BA564C13628433D24",
    version: "v1.1",
    name: "tv3",
    symbol: "tv3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x349F63945c089f1c53075D14d8c451D52ac26299",
    version: "v1.1",
    name: "tv4",
    symbol: "tv4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb8917cE9374e33ef8e0399F10481392d51884A9f",
    version: "v1.1",
    name: "vault37",
    symbol: "vault37",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7Ee501D69fA416Fe8281335EAB3677ee4AAAb3Ec",
    version: "v1.1",
    name: "vault38",
    symbol: "vault38",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDce900b928551AB3436A67501cF9Be88E0D7BDEa",
    version: "v1.1",
    name: "vault39",
    symbol: "vault39",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x60220D455323eC226a22932f88c7E8918b214218",
    version: "v1.1",
    name: "vault40",
    symbol: "vault40",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE1bA476304255353aEF290e6474A417D06e7b773",
    version: "v1.1",
    name: "Moonwell Ecosystem USDC Vault",
    symbol: "meUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3E3D0C3eFeB1617255D38B02E8eDdA7fAe69d601",
    version: "v1.1",
    name: "USDCvault",
    symbol: "USDVA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x60AFBd4B5BA4Abb6d3341a91eaD3Ed1857800353",
    version: "v1.1",
    name: "Mesa USDC",
    symbol: "mesa-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5C5bf79298A550dA3fCA596CD020F1300b0A0E70",
    version: "v1.1",
    name: "ARCHITECT Benchmark I",
    symbol: "ARCHITECT Benchmark",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2c8e1e0a03c1c2277E2b24A798728CB30599FF59",
    version: "v1.1",
    name: "Virtual TAO USDC Test",
    symbol: "VTAOUSDCt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3498db8AB73dab97F88dECAF95aEf2e899b42e49",
    version: "v1.1",
    name: "AA Quad USDC Vault",
    symbol: "aaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8A034f069D59d62a4643ad42E49b846d036468D7",
    version: "v1.1",
    name: "Blue Chip USDC Vault (Prime)",
    symbol: "PRIME",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6e6fcac197ee06d0164c0fBA218c7BcB878f9B5C",
    version: "v1.1",
    name: "Apostro VNX Swiss Franc VCHF",
    symbol: "apVCHF",
    asset: {
      address: "0x1fcA74D9ef54a6AC80ffE7D3b14e76c4330Fd5D8",
      symbol: "VCHF",
    },
  },
  {
    id: "0x75e1A1f9535C01CDcE25E51ea4aFF0d171337E1F",
    version: "v1.1",
    name: "Apostro USDC",
    symbol: "apUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa11856491C5B587503bb1d65C8fd087438fB1bEb",
    version: "v1.1",
    name: "Test Base USDC",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcF21679d85dc6588203FF576fc799b78957B451b",
    version: "v1.1",
    name: "ElFlanUSDC",
    symbol: "EFUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3094b241AaDe60F91f1c82b0628A10d9501462F9",
    version: "v1.1",
    name: "Earn Max USDC by Mo Wallet",
    symbol: "maxUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEf2d50B428675a1921bC6bBF4bfb9D8cF1461A",
    version: "v1.1",
    name: "Grove x Steakhouse USDC High Yield",
    symbol: "grove-bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x43e623Ff7D14d5b105F7bE9c488F36dbF11D1F46",
    version: "v1.1",
    name: "Clearstar Boring USDC",
    symbol: "CSBORUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x45f8Cc9a58285B7e7000EB14738346569963179d",
    version: "v1.1",
    name: "MEV Capital LCAP Vault",
    symbol: "mLCAP",
    asset: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
  },
  {
    id: "0xDfeA29A801772cEbDE8B04eb8309BF66d95e3E69",
    version: "v1.1",
    name: "USD Coin",
    symbol: "vUSDC",
    asset: {
      address: "0xb48bcF35acD74E69BBDeF17cdBEa9DE9983e786b",
      symbol: "USDC",
    },
  },
  {
    id: "0xEbC997B855B9a4E0b6cd06E4758801E6Ff068e07",
    version: "v1.1",
    name: "Pocky's High Yield USDC",
    symbol: "PUSDCHY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfd03b1890D6c31Bf1e15346b9B0b16daf6f2Ba36",
    version: "v1.1",
    name: "Test_1",
    symbol: "CT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBdd964eC8c11f352a2119f855ED7E8984340B77C",
    version: "v1.1",
    name: "Test_2",
    symbol: "CT2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x35303300E2d9D2A3b2b822f72480496b0CC391Ba",
    version: "v1.1",
    name: "v1 usdc",
    symbol: "bUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x21D183bE31f4A99979495482137EFd1EEb710Cc6",
    version: "v1.1",
    name: "CPT48",
    symbol: "CPT48",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC8adBFCFaC975583c8684C4e12633907315Ca610",
    version: "v1.1",
    name: "CPT48 Selection",
    symbol: "CPT48",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1DeD0EB527308e96eddC8000604B4960b96680EB",
    version: "v1.1",
    name: "Dune USDC v1",
    symbol: "duneUSDCv1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb34F36Cf0bdfd88e3ccDc45f9f9B7c4842905683",
    version: "v1.1",
    name: "ZARP High Yield Vault",
    symbol: "ZARP",
    asset: {
      address: "0xb755506531786C8aC63B756BaB1ac387bACB0C04",
      symbol: "ZARP",
    },
  },
  {
    id: "0x74Ff7A3a769b1E4FdEDBfe871D27762C83324fc4",
    version: "v1.1",
    name: "test-gx",
    symbol: "textgx",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0bE13349DE30ac208b1AC5f68c14Ce53CEf19a25",
    version: "v1.1",
    name: "Rezerve USDC",
    symbol: "USDCr",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE40AE949b2fdA4185D72DCf48718cA463800AC41",
    version: "v1.1",
    name: "USDC Stable Vault",
    symbol: "USDCs",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x34E405d672f17bD5Cd2E54c6CeEF2DCf51CAb7AE",
    version: "v1.1",
    name: "Safe USDC",
    symbol: "SUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0f7A0B454Dc4071F3C94C97798d5f74366C3C1d7",
    version: "v1.1",
    name: "Longtail Strategy USDC",
    symbol: "LTSTRAT-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2C6D169782bF18Cc634D076Fe639092227B82fdA",
    version: "v1.1",
    name: "Froge's USDC",
    symbol: "frUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7b08aD94eBa21172c9D857eB19Ee8808Fa2BDd0a",
    version: "v1.1",
    name: "VL",
    symbol: "VL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9D1BE4c1f4e93C8Dc620D26e16614706dB0fB108",
    version: "v1.1",
    name: "testVault",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x363089a33336Da246aF7fEeD5f2F1158Ce2cf552",
    version: "v1.1",
    name: "testVault",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0FD9B4f66956647B14c864dA3FDf4f142B9d4830",
    version: "v1.1",
    name: "Core USDC",
    symbol: "coreUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC87867f3c757C5c481F755443fEf1410E0910c47",
    version: "v1.1",
    name: "test",
    symbol: "test-test",
    asset: {
      address: "0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61",
      symbol: "gtUSDCp",
    },
  },
  {
    id: "0x5A2E9a8C16558D81A690e5Dd262063E654C2497D",
    version: "v1.1",
    name: "vvv-usdc",
    symbol: "vvusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcd5B9e6EC27A2359770DcD2CAbBf03b5719dF199",
    version: "v1.1",
    name: "test-455",
    symbol: "TEST455",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0091B6bD63F24D9cd3B64DaEB9e51302fF720C95",
    version: "v1.1",
    name: "test-913",
    symbol: "TEST913",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5435BC53f2C61298167cdB11Cdf0Db2BFa259ca0",
    version: "v1.1",
    name: "UltraYield USDC",
    symbol: "edgeUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x92A075CdB294c79e7A2C50826a14B99597c5C016",
    version: "v1.1",
    name: "S&P500 for USDC",
    symbol: "SNP500",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x58EfA4A930F06b04Ea9b1F1Cf6b7C620b5c93Ea1",
    version: "v1.1",
    name: "Pocky's High Yield WETH",
    symbol: "PHYWETHBASE",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x2C945DfC6D32c8A8158510F81A0d0d0001d110b4",
    version: "v1.1",
    name: "USDC Test",
    symbol: "USDCT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4B145097A3AC22C091E4091Eae66Ec97f20E9247",
    version: "v1.1",
    name: "Ring Prime USDC",
    symbol: "USDR",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x953C779E41464eC312148c4c52835AcAA22216F0",
    version: "v1.1",
    name: "USDC-kyoyo",
    symbol: "USDC_KYOYO",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2Ae07Cb4C3242B3f09526FC92AA3F4Aa1c9922f",
    version: "v1.1",
    name: "USDC Madness",
    symbol: "USDCmad",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x80291A3BA3D48D003c6939a383FCF37755662f60",
    version: "v1.1",
    name: "lamavault01",
    symbol: "lv1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE94f40E91015f60B12F354C700e682f15E7F436C",
    version: "v1.1",
    name: "Iron USDC ",
    symbol: "iUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1BEC367bCD37Ab757Ef063c90EA8F7C784875b66",
    version: "v1.1",
    name: "donnoh's vault",
    symbol: "DNNH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0Da99875dCF41d9EFbde27362405c73D6568e03F",
    version: "v1.1",
    name: "donnoh's vault",
    symbol: "DNNH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5478b47841D48b0DEc33b3d26ac8d7cB65C82e45",
    version: "v1.1",
    name: "LR USDC Base",
    symbol: "LR.USDC.B",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3299734E76534bD0b57F4FC45c86d7FB7B928fDa",
    version: "v1.1",
    name: "Low Risk USDC Base",
    symbol: "LRUSDCB",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x39265eB55e915789Ccd106A8AEa3aBBD411d8407",
    version: "v1.1",
    name: "0xDataWolf PeePeePooPoo",
    symbol: "AWOO V1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x397e1fc06D87fa47D681b672d22000A67F002c17",
    version: "v1.1",
    name: "Bond cbBTC/USDC Morpho Vault",
    symbol: "BOND-CBBTCUSDC-VAULT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe4a339542E6579fCFF022a1bdDe467c5AC93A62d",
    version: "v1.1",
    name: "Crypto Fi",
    symbol: "CryptoFi",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA4D73200beC697Ba2B4d1b04e337c510f038d8fB",
    version: "v1.1",
    name: "BTC-ETH-SOL MEGA3",
    symbol: "MEGA3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x26D3b0FB8dA2d81F53DEeE9BF9A4Ae7039feFeCB",
    version: "v1.1",
    name: "BlockNG WETH Vibe",
    symbol: "BNGWETHV",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1401d1271C47648AC70cBcdfA3776D4A87CE006B",
    version: "v1.1",
    name: "Pangolins USDC",
    symbol: "pUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaC0fF485e31C70CA0ac8E348a2F898Ba25D9Eea8",
    version: "v1.1",
    name: "LucidlyFi USDC",
    symbol: "lcdUSDCV1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9Ec9DD27f328A728ED6b2668681B4C3445fED4f7",
    version: "v1.1",
    name: "KedaoUsdc",
    symbol: "KedaoUsdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb7b4e1F7086820a02f9d630AB013596115574710",
    version: "v1.1",
    name: "Kedao USDC Vault",
    symbol: "KdUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9CBF0184036048895e69aAFb4D0A1598085bFc82",
    version: "v1.1",
    name: "Pofu Base USDC",
    symbol: "pofuBaseUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x947E5B92367a9Df5C369Ec5fB310FB2054f5053C",
    version: "v1.1",
    name: "BTC maxi",
    symbol: "btcmaxi",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xD5ECD0e19126ADA97aC09F5a19Fe1844979dd71c",
    version: "v1.1",
    name: "Remi's Test (Long Title Name)",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x15dEf17d02C4a5eB3bC51f58cb799369ebb217aF",
    version: "v1.1",
    name: "PaperHands USDC Yield",
    symbol: "pUSDCy",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAd0A683977d026B78cC3097e2d0F38A14d77BF91",
    version: "v1.1",
    name: "Hodler USDC Yield",
    symbol: "hUSDCy",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0d94620380b71Ec57878e3Cc7af205cD6eCe0638",
    version: "v1.1",
    name: "TRUMP USDC",
    symbol: "TRUMP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeeF0c8333b3De8F0450565834db4EB05dEf7A5F",
    version: "v1.1",
    name: "Steakhouse Prime XSGD",
    symbol: "steakXSGD",
    asset: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
  },
  {
    id: "0xFfD3D9fc55ffC0F5234c24ee22C8a2EB7b1fbC50",
    version: "v1.1",
    name: "tstcntrct",
    symbol: "tstcntrct",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDD9a7D78c264b11E73f521E0607Ea392aaCdF2A9",
    version: "v1.1",
    name: "worthless test token",
    symbol: "worthlessTokenTestViamorpho",
    asset: {
      address: "0x20173a75d8Ae180D64704eE162E5f97a2CF7Da77",
      symbol: "WorthlessToken",
    },
  },
  {
    id: "0x3618a5A1B88E3e66cdAbBBb614eDCd590f8D0D29",
    version: "v1.1",
    name: "DELETE",
    symbol: "DELETE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x42Cecd40ACd47E7e68e67F82415b6f3DaBB0D445",
    version: "v1.1",
    name: "Architect F Cap Tactical N",
    symbol: "Architect F Cap Tactical N",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x861F47d8dA4a23d36D70CDDD775c4fbaF9Dd2c40",
    version: "v1.1",
    name: "Lightning USDC",
    symbol: "LightningUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6AdaF5D4EB094Dc70e6F2c888AC411b05e1635E6",
    version: "v1.1",
    name: "Cozy USDC",
    symbol: "cozyUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9dEB8a31b87908C7fba0C730Db59F369C05c126f",
    version: "v1.1",
    name: "Cozy USDC",
    symbol: "cozyUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaB6fA0BD814075E8966D3045368e005812DDe4dF",
    version: "v1.1",
    name: "test vault",
    symbol: "TV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x73d1F2AcfF53e55D1b10ee3fcEbd1B668d978CF2",
    version: "v1.1",
    name: "Sidelined Capital Piggy Bank USDC",
    symbol: "SC_PIGGYBANK",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE0dcb5fCBA60F60a74041081D8401a55cdcc4795",
    version: "v1.1",
    name: "bf test",
    symbol: "tbfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa2cea40909F29028f2F6a2ca1d0305b6f52a3312",
    version: "v1.1",
    name: "Brrrstr USDC",
    symbol: "brrrUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5C5Df7380960a01EC05E71D2d3a30E5177102263",
    version: "v1.1",
    name: "Carpathian cbXRP",
    symbol: "cbXRPx",
    asset: {
      address: "0xcb585250f852C6c6bf90434AB21A00f02833a4af",
      symbol: "cbXRP",
    },
  },
  {
    id: "0xC7A278B9F2716051BD8724fa3e9dF3759adA6FCf",
    version: "v1.1",
    name: "Only Trust",
    symbol: "onlyTrust",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC440d9CFC9A75300A93AC8544d307A1484Aff0e7",
    version: "v1.1",
    name: "HavenFi Yield",
    symbol: "hfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa1D946656a06bB0E6eE6172d96d33DF7f340Cb4B",
    version: "v1.1",
    name: "Cash Carti v2",
    symbol: "CC3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x18f85dadCc1AeEbf4a25455C2d92610f0153ED29",
    version: "v1.1",
    name: "Blue Chip Degen",
    symbol: "bluedegen",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7BAcBF01aac9D327060CFBF9B6Ae9e4ea40132be",
    version: "v1.1",
    name: "My Vault",
    symbol: "myvault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6DA32b4086e0f2Fa8462513060A65c498b29e0BF",
    version: "v1.1",
    name: "Kedao SUSDS Vault",
    symbol: "KdSUSDS",
    asset: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xBEEf0069cfEC71fCc928049fbEefeD8A9f5B9ffb",
    version: "v1.1",
    name: "Tron x Steakhouse USDC V1.1",
    symbol: "steakUSDCtron",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAB661be33FC1fb6cBFd1BB6f3b8Dad4950b57b6d",
    version: "v1.1",
    name: "Vaulter",
    symbol: "$Vaulter",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0bd320Eb6F5f29623efE90c9C71a198F415e9551",
    version: "v1.1",
    name: "GUD",
    symbol: "GUD",
    asset: {
      address: "0xA608512BBC9934E4b1DDeCF0F5Fb38b6Ad93308D",
      symbol: "GUD",
    },
  },
  {
    id: "0xb2a61553B3b5fDd22E23ccD5d0DB897a5a763ae0",
    version: "v1.1",
    name: "jvaTestv1",
    symbol: "jva1USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x632258ae696196E4c5629690f5572ff0aeBcb47A",
    version: "v1.1",
    name: "test-yingli",
    symbol: "TEST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x096442b35624556E138C8070770f0069767e818F",
    version: "v1.1",
    name: "Test USDC",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x95aAC81D2d5a32Ca66e37A888Aa820932DB4C5E3",
    version: "v1.1",
    name: "SCL_Destroyer",
    symbol: "$SCListheshit",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe7E0FC1F9d1fA6f176BCbb5F89465A03fa3fF75a",
    version: "v1.1",
    name: "Paper Yield",
    symbol: "paperUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC140F79d6757ce71f1fBcc01596D9E34312636aA",
    version: "v1.1",
    name: "eskUSDC",
    symbol: "eskUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x874aab24BC783a386275D796699CD8A7772A78B9",
    version: "v1.1",
    name: "SCL",
    symbol: "SCL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE34FfeE09ba49645654513EAC6FDaCcDa14f2d6C",
    version: "v1.1",
    name: "Volatility",
    symbol: "(w)eth",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3CD9EAC7A7D38793a919b3dCc35502788e74538b",
    version: "v1.1",
    name: "Philly Philly v1",
    symbol: "PPv1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x176244332E03a3fd0AfeE0089D523eA737A9Ffc7",
    version: "v1.1",
    name: "dest2",
    symbol: "DEST2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9368970e33414b1Ec1E22c326b41adDA629DB4FD",
    version: "v1.1",
    name: "Bloom Real Estate Private Credit",
    symbol: "org-blusdc-vault",
    asset: {
      address: "0x5d81E33bf04162c8fDe897F543b265F3c5B51712",
      symbol: "BLC",
    },
  },
  {
    id: "0xD5C0A1e576A70078Cd394221C80cE54596D2654A",
    version: "v1.1",
    name: "Oak EURC",
    symbol: "OAKEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x9e531432DFCD09Dad1Ab24a6fd1896c11CDa6A66",
    version: "v1.1",
    name: "Baguette Euro Yield",
    symbol: "BAG",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x5132017227beb383783085d94Ca43Fb5F188a7d7",
    version: "v1.1",
    name: "Term Prime USDC",
    symbol: "termUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8B99ba81053b58262E165CA4BD347A4395E48f2E",
    version: "v1.1",
    name: "test_11_v1",
    symbol: "test_11_v1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe5C2C2124218b43dBFE7127CF7e596a6C563b046",
    version: "v1.1",
    name: "Anvil Test Vault 1",
    symbol: "ATV1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8833cB53E449665274B6EAF0e19Ffa9d529D69B0",
    version: "v1.1",
    name: "ccVaulty",
    symbol: "ccVUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x793356B1C6120Fdf24Ee80FB76959675E99fBb2a",
    version: "v1.1",
    name: "Baguette USDC Yield",
    symbol: "BUY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x49104e0325f613eB372D11F3DE7E9B804FdDC1Be",
    version: "v1.1",
    name: "test_kg_v1",
    symbol: "test_kg",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x546d66d1b8C95a3e2459a9D93989Aa57910801aD",
    version: "v1.1",
    name: "Rafael Vault v1",
    symbol: "RAFUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1d972E9ed4e1280BB8f7eB30Df40dFD1B266D51a",
    version: "v1.1",
    name: "Zircuit Finance USDC Base",
    symbol: "zf-usdc-base",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0171D2faF0F90072f2E549c2F5A36A3DC591565B",
    version: "v1.1",
    name: "Clearstar",
    symbol: "csMPH",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x26e377DBF0C8C76C050be7F362153D03cd947C62",
    version: "v1.1",
    name: "Clearstar",
    symbol: "csMPH",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb724948d4D2CCFEaAB3E39809a9D34039133b731",
    version: "v1.1",
    name: "USDC-Micho",
    symbol: "USDMCH",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x25e5c0700F553b0741B2283DD5A868976951ab13",
    version: "v1.1",
    name: "V1VaultYTest",
    symbol: "V1VYT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x581Cc9a73Ec7431723A4a80699B8f801205841F1",
    version: "v1.1",
    name: "OUSD Vault V1",
    symbol: "OUSDb-V1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE64373a2bbD4D925C266140D1e064EDf9EB4bAEf",
    version: "v1.1",
    name: "Rafael No Timelock",
    symbol: "NTLOCK",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x407fb14610d1de1B55DDa28FA914dB39f53A6dDe",
    version: "v1.1",
    name: "Rafael Fresh",
    symbol: "fresh",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x327946Cea4762e81F9fC9e4fFDDA6cede120b4B9",
    version: "v1.1",
    name: "Ledgity EURC",
    symbol: "lymeurc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3a7036585619e70FFb0585060B4Ef40e567c7058",
    version: "v1.1",
    name: "usdc staging",
    symbol: "gtstgusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x060D9678BC1B58a499135B12fcA8ed25BCdD5E4A",
    version: "v1.1",
    name: "test spine base1",
    symbol: "spinebasetest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x70060915c9e1332E3D133e36Ed2B59FE1B18B501",
    version: "v1.1",
    name: "Pocky's High Yield USDC 2",
    symbol: "PUSDCHY2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1262623fcCc820B947f883496269c272cF990d1E",
    version: "v1.1",
    name: "Zircuit Finance USDC on Base",
    symbol: "zf-mbUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9fA6f161D1e530591E6f6BA04372204F0373aAFb",
    version: "v1.1",
    name: "GVault",
    symbol: "GVUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8156ade784Fe5a49d9E1C8069562149E1B088eeB",
    version: "v1.1",
    name: "quirky test usdc vault",
    symbol: "qtusdvc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x607400098f7b9BcE8dFDbb80054bD9d6137BF3C2",
    version: "v1.1",
    name: "Personal USDC Vault",
    symbol: "pUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD493705CaF2EDA2A1fc670243847BFB8D8ed7439",
    version: "v1.1",
    name: "test vault",
    symbol: "teusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x813862F7276D673a5079Ef174bc1A35e4b970F95",
    version: "v1.1",
    name: "Julian Capital USDC Liquid",
    symbol: "JULIANUSDCLIQ",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3743a36acdCAb10A08Dda6418131cD3Bf4a1b368",
    version: "v1.1",
    name: "RWA RWA RWA",
    symbol: "rwaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x429b4d4eEEda1de0efe0B676297B849430cEb2C4",
    version: "v1.1",
    name: "Prosharky Security-Audited USDC",
    symbol: "psAUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x50Ac4Fb6e5fB12F6be8C6057fad2c53Cfb6a181D",
    version: "v1.1",
    name: "Pocky's High Yield WETH V2",
    symbol: "PYHYWETH2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x12Df50fff722358Ce0d842cED9a670D8eb8Cf586",
    version: "v1.1",
    name: "Gneiss Pioneer USDC",
    symbol: "gnpiUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb9Becf2f5264b3fE8517CA1f847c8eD72aa29D10",
    version: "v1.1",
    name: "cbBTC-wstETH WETH Vault",
    symbol: "cbwV",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xCC4ed4425Df7966AA080F56d287279c0a4f73323",
    version: "v1.1",
    name: "Northlake USDC 406118",
    symbol: "NLUSDC406",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4c1503Ac248c7e7227eED7fe871090AE43773E72",
    version: "v1.1",
    name: "REIT Ciclo Nova USDC Vault",
    symbol: "rcnUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5887D05d500bFFa0B7C2b946748bD9FbF8efE9E4",
    version: "v2",
    name: "Peaty cbBTC",
    symbol: "ptCBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x44D3468643073f82dB3C545408f8aA265cFf903d",
    version: "v2",
    name: "Peaty cbBTC",
    symbol: "ptCBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x76F974fAF155de0F74145aBA7E1aF85859d78B45",
    version: "v2",
    name: "Peaty cbBTC",
    symbol: "ptCBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x6177D2C141768aE2D29d51Ea65FEf75AC2e7f556",
    version: "v2",
    name: "Peaty cbBTC",
    symbol: "ptCBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xA9b2427d37fE5CFD39d433Fa6C8454681742a3c0",
    version: "v2",
    name: "Peaty cbBTC",
    symbol: "ptCBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xfDE48B9B8568189f629Bc5209bf5FA826336557a",
    version: "v2",
    name: "test Vault USDC",
    symbol: "tvUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x93e1F03c254A0f2A4CAFD119e1aFf2D73b04eeCB",
    version: "v2",
    name: "Test Vault WETH",
    symbol: "tvWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x894C10E3Ad4655dF2d275b5cAC6c00aC82475d98",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA042Dca62774cD296943afE0F45000Bc719f2FEd",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x26295Ecd66C563b4b065916401A4c985D0eeFe42",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC31185576C0Ed84C3E8a231C80Df4FBb41404D3d",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x62ADd0fEdF3f24EA581E0Bb627aC8cA4B04Cb726",
    version: "v2",
    name: "New B",
    symbol: "nbUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x426C9Ce7f4A09C2A7da6AA7C68e71243c1504501",
    version: "v2",
    name: "Vaulty",
    symbol: "vvUSDCtest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0C1687b8349db4288cd0899A355c6eEF478f6870",
    version: "v2",
    name: "Rafael USDC Vault",
    symbol: "rUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x69a4941cDAadb861940f2e318cE28EAC600ac65C",
    version: "v2",
    name: "cbBTC v2",
    symbol: "Mv2",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x99bA73126486584d03363a92D44E80ED983c9B2F",
    version: "v2",
    name: "Test vault 3",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x53Bd5E81F094f52b9c91191CD9154D5F523248f1",
    version: "v2",
    name: "Yolo Vault",
    symbol: "yoloUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4AE4FB344CeD876bddCeaB2A2A7a8a63089444b3",
    version: "v2",
    name: "frfrfr",
    symbol: "frfrfr",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x18419e217233A027583b9099755F43B71F0f6Ea0",
    version: "v2",
    name: "Test USDC",
    symbol: "TUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x648ecFAD2D7aa5400aB937002EE26C7e5a61EAE1",
    version: "v2",
    name: "Yet Another Vault USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9abfeABEe3bE3969Eb9B7b189934926bD4090745",
    version: "v2",
    name: "Some Vault name",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7Ad5Ea0B1Ac540Cc0800731Cf1Eed17b1D6E1211",
    version: "v2",
    name: "test registry Jean",
    symbol: "trj",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1e4353f85b7d1153D9a2A74533bCC680DC981C6F",
    version: "v2",
    name: "Test",
    symbol: "tst5",
    asset: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xeF915679d4976A79490090eaB5a6Db83250e14B4",
    version: "v2",
    name: "do not use",
    symbol: "dumb",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xF8385696cC3Ff2dfA04C742AFB4f9AC568184D01",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4a6c5BBdbFdd523b21dbEe74E37e47a9c62dbDF0",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x42e809c885D155fC644DB94e06eEc900ef699f02",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a545De5Aee8643228b17D27F4675E1B2d82bEc0",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa8Bc99Db639774Ed2B68d691C6ADEfECa4CC2592",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x572e39C2f4414bd0CAb55F396869903E6573c4a7",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x07335a6346aac9dAED3a930FbE7c50ed343d5B07",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6ba1d5eEEcea7838bf6164DD8d8e070034c97948",
    version: "v2",
    name: "Not Gauntlet USDC v2",
    symbol: "AUSDV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x550F5C3F5aC75828a821A3d58925d9Bf6Fcac275",
    version: "v2",
    name: "Mesa USDC",
    symbol: "mesa-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x678b8851DFcA08E40F3e31C8ABd08dE3E8E14b64",
    version: "v2",
    name: "Monarch Auto Vault",
    symbol: "mUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x15264BB54b1978cb331F50693653Ccc05B0EF7b6",
    version: "v2",
    name: "Ligma USDC",
    symbol: "LigUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE548fFFbc18E5485b64aA1dCF3C1D50983163C7b",
    version: "v2",
    name: "Based EURC",
    symbol: "bEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xC0EBDCAe7a8bc2120b0d418D9D221311E3A13d12",
    version: "v2",
    name: "newww",
    symbol: "newg",
    asset: {
      address: "0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61",
      symbol: "gtUSDCp",
    },
  },
  {
    id: "0x13Bc597D249f00Ae47026e80B094fd703c88D4C3",
    version: "v2",
    name: "Tank USDC Pioneer",
    symbol: "Tank USDC Pioneer",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1fb843d7E1b2f108d3211F98CBE11E2660B2e6d5",
    version: "v2",
    name: "TEST3",
    symbol: "TEST3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x218c1B304d4Bd1C03e153f30427D816847B4ab79",
    version: "v2",
    name: "Prime USDC",
    symbol: "pUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa7b192f3B0BF444e5CB60005fE29cB55Aa3124dd",
    version: "v2",
    name: "natural intelligence v2",
    symbol: "naturintv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x686079112F66Db9D1f50b3A0A99F9E07a7C1271e",
    version: "v2",
    name: "gunit",
    symbol: "gunitv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x44823C32f62b3A56420044511523704E48142696",
    version: "v2",
    name: "testing1",
    symbol: "testing1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xebcB0B755e291851f8c3a6dd564f689Cb2b92dc4",
    version: "v2",
    name: "Abdicated",
    symbol: "testABDUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbC37Ec3B73E8B8d58C343C2a5CD974984320c915",
    version: "v2",
    name: "esabm2",
    symbol: "esabm2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2137692a0f6CEb2Be645448870009ac45B0d968d",
    version: "v2",
    name: "VTAO <> USDC Test Vault",
    symbol: "VTAOUSDCt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x08077Ad8ddcA0aA4F91922d9397d48877257fDD7",
    version: "v2",
    name: "My Test Vault",
    symbol: "mvUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0863cf361eA7F92Fd53223a2FA1e58F799544e82",
    version: "v2",
    name: "Byzantine Prime USD",
    symbol: "byzUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfe2421f30a009555FD4a9098E51f9961276237d9",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEff07050Ddb7c62182D51496cb3c015E4F001D",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x48473C1c77D09Bf664D3bEB4f1D0E5fC6Fd1B423",
    version: "v2",
    name: "Blue Chip USDC Vault (Prime)",
    symbol: "PRIME",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6A291a71d8B5Eb5d147c334949064c26Ba00E459",
    version: "v2",
    name: "Mesa Test",
    symbol: "mesaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xec7d866579D3DE50955A9bD5a7C4bd0044620e69",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xee8B3450df927F232BBcaE42D254686c7E6B007E",
    version: "v2",
    name: "Elixir Capital USDC V2",
    symbol: "eUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4a80756Eda9E5D2b5AA66E7666FA7C90BEd4f33b",
    version: "v2",
    name: "Max USD",
    symbol: "maxUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf44839C10DC1e86A945Fa70A58607703fd1441CB",
    version: "v2",
    name: "TestVault",
    symbol: "TVault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5Ee2aD1e41678137C49B137D1bfCB628028Fae78",
    version: "v2",
    name: "Rafael USDC Vault 2",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2cBaDdc84222d8C714B6D34d341569c2d40A74a5",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA894d94c0fC8313d2170523c80208d8acd038110",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x199A092362BbA569c4dAF851e8A835E41fa4EB00",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcd8b60f18d2B598535224a852dCc72b7C797A745",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3417Db67Bd951892Cc437E17917eDb016355e2dF",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x59429eB8c79223FC05aa08E09240152605Ad601f",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x00Cc39b44f74ad55fcb958925e2F4978C1466f7c",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B2672556b2210886EC607b61A7B1b06B3aded2C",
    version: "v2",
    name: "USDC Max",
    symbol: "USDCM",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAc7D82f2FD136651899Bd6d68aAA8DCa6fb72836",
    version: "v2",
    name: "kUSDC",
    symbol: "KinUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD453183Fa087112986833a3d166A66Db8718fCcE",
    version: "v2",
    name: "Vaulty 2",
    symbol: "vvUSDCtest2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6Eec890592D362A193094A59e45124FdC197a9Da",
    version: "v2",
    name: "Demo Vault",
    symbol: "dvUSDCtest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf55beC6Fe3891a2BE3968F2a608D79e008DbfEf9",
    version: "v2",
    name: "base usdc",
    symbol: "base usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x26f85C629D508C42091816EAF8f749A9b6FDA52B",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBA06873378B6630d1Bfcc9A98ce14d27BFEdCe78",
    version: "v2",
    name: "Dune USDC",
    symbol: "duneUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2cBb9ECFa448116B1d3b3FC7ccaFdc4688dC489f",
    version: "v2",
    name: "STK-Test-Vault",
    symbol: "STK-Test-Vault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xEbd0862f1d0F5bA8C5272D0De983072DB2982024",
    version: "v2",
    name: "JUSDC",
    symbol: "Ju' USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x618495ccC4e751178C4914b1E939C0fe0FB07b9b",
    version: "v2",
    name: "Re7 USDC",
    symbol: "Re7USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3543cEa9d69f6F4895De6eA41a4e290492eAbb02",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE03AB4feD1e4Ab0Bc12B2892af2f11DF17d46992",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd8659d18244ED458406360F393142aF8f297b5e9",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe8ad35A5d8Ee327F34d6502AdD9652F8A8B97bF8",
    version: "v2",
    name: "TestG",
    symbol: "testg",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x81A272a79EF4e25E345C8c8080783C4d844303F3",
    version: "v2",
    name: "TestG",
    symbol: "testg",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeaA2124FB8B6597e759697c786C1Eb9d411E78f4",
    version: "v2",
    name: "USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x050cE30b927Da55177A4914EC73480238BAD56f0",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1deEfABEe758AAbdC29a542B24ca3b75aFD56765",
    version: "v2",
    name: "Gauntlet USDC Frontier",
    symbol: "gtusdcf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFeFeC33668E22677c4762d0853d56245a800ff08",
    version: "v2",
    name: "Gauntlet WETH Balanced",
    symbol: "gtwethb",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x759C38aD55ef790E9e67822fAC44869deb7A7DF0",
    version: "v2",
    name: "esabtset2",
    symbol: "esabtset2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x00a028FeF752f66De5359aF2689451D401c338bE",
    version: "v2",
    name: "kpk test",
    symbol: "kpk_USDC_Morpho",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2820cc56cb1fdEff42B989997AF0d2f9b6e4a764",
    version: "v2",
    name: "Rafael Test 1",
    symbol: "RT1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf09AA7A80bAb76CC3be1714B79Bc703F7afE43B1",
    version: "v2",
    name: "Test2",
    symbol: "Test2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa6bf9AB4CED4e5E67Cd6C695048E0801D3b60E21",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x872Cca9182A67Cd28EFA1942D0937572f8036EeE",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE2F697A34B837F0F52d099E26CE4883fbB9aec2E",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdeCA9EB40074eb4EB0cE0eB20ab63d79B882a05D",
    version: "v2",
    name: "TesteUSD",
    symbol: "TesteUSD123",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0xc9C474C6Aa0E930ED42fD1f40be5b1d6A5eAD645",
    version: "v2",
    name: "Re7 eUSD",
    symbol: "Re7 eUSD",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0x822933a6d9b13B9B639B2a8619E7676C7843b8C9",
    version: "v2",
    name: "TestUSDCu",
    symbol: "TestUSDCu",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0B7ee82ad75B2D3fc7f3A110A51ba68714171D25",
    version: "v2",
    name: "Universal USDC",
    symbol: "UniversalUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCa120dCc42F45427eD0d0f060d56104c4a8EDEC4",
    version: "v2",
    name: "Re7 WETH",
    symbol: "Re7WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xBCa958077726631Fb4fe95Dc2C7f625997742ab9",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD20fab4aefc87e688F5598F6ceDd27ef032b9B38",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9f07Bb10D4239890DFcE7F2C4286Dd6CD6255653",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3912a477F8988c37e387ACddb80AD04D4D8a3Fd2",
    version: "v2",
    name: "Zarp Test",
    symbol: "ZARPT",
    asset: {
      address: "0xb755506531786C8aC63B756BaB1ac387bACB0C04",
      symbol: "ZARP",
    },
  },
  {
    id: "0x3045221404CeFe7feDbc9aCF598B05185FeAADc5",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCE08DD72896b1CA8cEEee198429Eb17d3aa0B3F3",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEff95092EACE78Fe1921A39d8Ac6aCD2D849C6",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef00b4ebc8094A60006D75B277d30480e0a6D8",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff0bbd340ceBA22d216A4F6a92a383cAaeA82",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7EeA99bae96dD294A83D8Ce19fAC66B62cF26799",
    version: "v2",
    name: "USDC  Rezerve Vault",
    symbol: "USDCr",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x57753039CA99Cf5715EE204dDCdF2134f10EEe1e",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdE335d9701747FE5265C1c245f9D1A7bADCbc011",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0a5c5Db85a9c329326101D73069957A7Ca1a56a7",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFfD8Efc5bf38EfAd0693b55C4db1bE8c9a675dc0",
    version: "v2",
    name: "Bluechips",
    symbol: "BCPS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa51c03Be5Fd01f8E869Dff17085360c793823277",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x054F6824862B2614a580F572088e9629a5bba66F",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef0c0D1F92FC23bfbf5aB27FB3F26c0d838ad2",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeffC20438041816C931cd8A296261CD235d78a",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE3A7152A0b500b5c4C3375f17D9fBdC572C10107",
    version: "v2",
    name: "Safe USDC",
    symbol: "SUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef043e099d76a1EB8D3095DcFD7aF8F66a3D9B",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff7aE5E00Aae3Db302e4B0d8C883810a58100",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef0e0834849aCC03f0089F01f4F1Eeb06873C9",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0Cb802a213f5A2A60b9f8Afa872f3617c4Dfa502",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2A45D1f3Ab6Ea96B254710F584672004e5F27297",
    version: "v2",
    name: "Arch Test2",
    symbol: "Arch Test2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD878c94Ea5d74F99006672c5613569C65AD8b6C3",
    version: "v2",
    name: "Adapter New",
    symbol: "testAN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x33674D1DAA6F3efeA3341E377384E6083B1a86D2",
    version: "v2",
    name: "ZB USDC",
    symbol: "zbeezyUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1E24C2A8029E0f952669561e59cB4CCFD5aF51f8",
    version: "v2",
    name: "albist USDC",
    symbol: "albistUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x25286737bcb698afB5180392988b6E2405B7f5FF",
    version: "v2",
    name: "MyVaultTesting",
    symbol: "MVT",
    asset: {
      address: "0xB7890CEE6CF4792cdCC13489D36D9d42726ab863",
      symbol: "uUSDC",
    },
  },
  {
    id: "0x05D8fcC9aD3538C55B1045f1aFaE34B807F092bA",
    version: "v2",
    name: "SFTest",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa481A5036d84eCFB1c207c8A4d735d87fAC22132",
    version: "v2",
    name: "Goblin USDC",
    symbol: "gobUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6b7952b22F825a54fec88a0F8f11F7654465d408",
    version: "v2",
    name: "test vvv",
    symbol: "vvvvv",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0A5D83c2798841A656D5Ef0028bf587CeAA1140e",
    version: "v2",
    name: "Ring Prime USDC",
    symbol: "USDR",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x70D6Bc7C58ACD78c40c9871130eddF6A42Ca18b8",
    version: "v2",
    name: "USDC Bob vault",
    symbol: "bobUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDd8678B7FB7586e4836095C494395B7027D0cE20",
    version: "v2",
    name: "Edge UltraYield USDC",
    symbol: "edgeUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE90730e2986Ad22872761df87E58730D13BfEC82",
    version: "v2",
    name: "DeFi AM USDC Prime",
    symbol: "daUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xED04BA29c7db2F7Dc86Ae282E91f4F128860fD6C",
    version: "v2",
    name: "S&P500 on USDC",
    symbol: "SNP500",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x65B66A025Ff32A6De4Ef68D87A64FEECb4E4d396",
    version: "v2",
    name: "Bee USDC",
    symbol: "beeUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB35f7e4171a8Ce0B7fBb147b128b0D3eE216D77e",
    version: "v2",
    name: "Pamir Capital",
    symbol: "PC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x966A02A13875Be223Da3210EACeeAa774A18C5c1",
    version: "v2",
    name: "LR USDC Base ",
    symbol: "LRUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdB6561902A84b96b9df0ce6AA22a48464b3fCAD1",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9bd9EfA5c25e46661DFeDeaD704Be72f8175786c",
    version: "v2",
    name: "t1 USDC A Rating",
    symbol: "t1USDCA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x625a43bE8d6B0Ffbb0B5C6437587A2dC2BCC03B0",
    version: "v2",
    name: "USDC Sanctuary",
    symbol: "USDCs",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6a240db5737955D125923accB11AF740138268d5",
    version: "v2",
    name: "MERKLE VAULT",
    symbol: "MKV",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x59b4939719dbb564ec07ae92d888b21977c84036",
    version: "v2",
    name: "donnoh's vault",
    symbol: "DNNH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD37a26bC43A75EE5083392c8dEEC2739B6b6e51B",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb89C27665Db2041082e002e2607e568729800caA",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x80b032817F7B38A878a465C3b3a9bC376226f9bE",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBE570C885C2C9f0C2B9F4437Fc5572a006eEc38F",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x33802b87Aa9687516758F1711e6b72F9ae62d4D4",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1C1428F11C27aDfD3D6736c80C7A2EF241222dD8",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x48F34fA413eE669400E8F8EB427713532766959c",
    version: "v2",
    name: "0xDataWolf Test Vault",
    symbol: "AWOO",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x89712980Cb434eF5aE4AB29349419eb976B0b496",
    version: "v2",
    name: "Muscadine USDC Prime",
    symbol: "mpUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB15a51F46a53CF7dBB378A459A552F342bC54815",
    version: "v2",
    name: "cbbtc-testing",
    symbol: "cbbtc-testing",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xD6DCAd2f7Da91FBb27BdA471540d9770c97a5a43",
    version: "v2",
    name: "Muscadine WETH Prime",
    symbol: "mpWETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x99dcd0D75822BA398F13B2A8852B07c7e137EC70",
    version: "v2",
    name: "Muscadine cbBTC Prime",
    symbol: "mpcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xba5D277bb23A593Cca343Cc58f340f86fA51D729",
    version: "v2",
    name: "Test V1",
    symbol: "TV1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x32719771e65e8C087b191aaF1FAB6556Cef44F3D",
    version: "v2",
    name: "BullThesis",
    symbol: "BullTC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6642Fe75DF0172135eF999cb1Ef1f8F1EDAE8297",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x362C86F515029e73F926B1358ffBb5C318e14009",
    version: "v2",
    name: "Partner A vault",
    symbol: "steakUSDCa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb509e21369D16AedeE91C8C4cC604D5B6601a937",
    version: "v2",
    name: "Crypto Fi",
    symbol: "CyptoFi",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3459df2C5890513D439A9e35A10C222c04F4788B",
    version: "v2",
    name: "Mega3",
    symbol: "vMEGA3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbe1f489c7877672b89f89a0CE3d013776CBe8C7c",
    version: "v2",
    name: "Ramp Network x Steakhouse",
    symbol: "rampnetwork-steakhouseUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEf00A6F754ae2cd593E7665C304B7d8204a6e3",
    version: "v2",
    name: "Ramp Network x Steakhouse",
    symbol: "rampnetwork-steakhouseUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x638fce18aEe6784bB006FE2D6fAC82d361a86B8E",
    version: "v2",
    name: "ARCH DIRECT",
    symbol: "ARCH DIRECT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAB69221057C80364AAe7eae22B5288426286694c",
    version: "v2",
    name: "KedaoTest",
    symbol: "KeDaoTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x67Ee90c3757d41dd273d209f1B30cc3532876844",
    version: "v2",
    name: "Pofu USDC",
    symbol: "pofuUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8effa741061aaA2d8A5012a9B09A2d31d8B628d7",
    version: "v2",
    name: "ARCHITECT Global Value",
    symbol: "ARCHITECT GVI",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6022Cbf61352618053d89FD9eEfe78Cb725B3c9d",
    version: "v2",
    name: "ARCHITECT Global Value II",
    symbol: "ARCHITECT II",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9f6283cf32CeFB06d8ec6aCc9141cF860253a2e4",
    version: "v2",
    name: "blowjob.finance",
    symbol: "BLOWJOB",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdB755C2FE9760C956CCaDBAE5b207DF3E518e00B",
    version: "v2",
    name: "Strategic USDC Yield Vault",
    symbol: "sUSDCy",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x675743C56d570D9Bb9Ca96f31e06c78d6CcceEb9",
    version: "v2",
    name: "Lucas Test ",
    symbol: "Lucas",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaeFC8658FF6335D26a6CdfD5a2a65114f36b55C9",
    version: "v2",
    name: "Foo",
    symbol: "foo",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x530595fF26148dF969A9c3c14aEd5F05FF1aaC17",
    version: "v2",
    name: "Cube",
    symbol: "cube",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a8eC1417ddBe075ff1b48D121ca8551D760C27D",
    version: "v2",
    name: "square",
    symbol: "square",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa4690b89656979F20f2C8614448b0ca0b23E2ED6",
    version: "v2",
    name: "Arsum",
    symbol: "arsum",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3f0E2Ed079e1f9991DFC99027aa2304Deb5D84fb",
    version: "v2",
    name: "Remi's Vault V2",
    symbol: "RV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x66959B970c99beDd51f938cb85F55A51d2303eAa",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcf11075A03a9Bb6987fd6d91dB1828f6A16b69C4",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDF36aBD2716735137DeB1F9f06B4d5861b3f0976",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCb9Da8eC9675CB19E8494cd69df81aFc658b4306",
    version: "v2",
    name: "Steakhouse Prime XSGD",
    symbol: "steakXSGD",
    asset: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
  },
  {
    id: "0xbeef00A299ae1784Fb7740d2d469F60a1E015fe9",
    version: "v2",
    name: "Steakhouse Prime XSGD",
    symbol: "steakXSGD",
    asset: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
  },
  {
    id: "0x072796a00aaf655fA3bddCa04E29dDb98E90d902",
    version: "v2",
    name: "testoto",
    symbol: "ttt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa04A0A2587a8307F40E1c181BC1dc880aAeD088e",
    version: "v2",
    name: "DELETE",
    symbol: "DELETE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5ABecC90CdAD38385d1D0F2D78dD7453e25BC387",
    version: "v2",
    name: "ARCHITECT F-Cap Tactical I",
    symbol: "ARCHITECT F-Cap ",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE1968ef8905CBc482fCf26D0349DcA27A79fC1bb",
    version: "v2",
    name: "LukaTest",
    symbol: "LUKAT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3deDcEcF0246474246a8C5e89dEa35170023071D",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x01afD5fa7E69Ce5f506C166D2fcbfb12488412AF",
    version: "v2",
    name: "Steakhouse USDC High Yield",
    symbol: "SUHY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3Cf1831208BA4Da37697df4d7e890540Aa6D8A24",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x74F772719D87269049d2BC27660032FeD6f093d7",
    version: "v2",
    name: "CADC Yield",
    symbol: "CADCY",
    asset: {
      address: "0x043eB4B75d0805c43D7C834902E335621983Cf03",
      symbol: "CADC",
    },
  },
  {
    id: "0xA90CB29e60e0aE2caC324F963F3D4597934D2DE0",
    version: "v2",
    name: "hex",
    symbol: "hex",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd2D51E6c73CCFA86947D2a50c4a131a514C8AA52",
    version: "v2",
    name: "hex",
    symbol: "hex",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE0a80921e782f6aCbaF91142Fc7c9D695CB0cf7a",
    version: "v2",
    name: "hex",
    symbol: "hex",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1C7836bb7EA75feE0EeE721dB4ac90bdE4C15203",
    version: "v2",
    name: "Jesse Yield",
    symbol: "J",
    asset: {
      address: "0x50F88fe97f72CD3E75b9Eb4f747F59BcEBA80d59",
      symbol: "jesse",
    },
  },
  {
    id: "0xE43EF557D6Cb1cBcDfc406C19b3917C4AF38ca21",
    version: "v2",
    name: "eskUSDC Testing",
    symbol: "eskUSDCv1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7894A2C60Ba649003e6f9FD7F96e4EcDb59DA08B",
    version: "v2",
    name: "MaxTest",
    symbol: "MTEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD76C6FFBb4d4d05518ECde5ac8B51735f7508040",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0xcb585250f852C6c6bf90434AB21A00f02833a4af",
      symbol: "cbXRP",
    },
  },
  {
    id: "0x3524DFbfF6314f6A6B58980a3eA96c384F335500",
    version: "v2",
    name: "Blf Test",
    symbol: "tbfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x188B80F5899670d7fE48FE0ee64Cf6dd414b29fB",
    version: "v2",
    name: "Carpathian cbXRP ",
    symbol: "cbXRPx",
    asset: {
      address: "0xcb585250f852C6c6bf90434AB21A00f02833a4af",
      symbol: "cbXRP",
    },
  },
  {
    id: "0x4B6E2EC1229dcf124dfCe2e559B4B61Ab3998176",
    version: "v2",
    name: "Sidelined Capital Piggy Bank USDC",
    symbol: "SC_PIGGYBANK",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA66F8EaA24B90fe53c7548f78c2e8ed430d55425",
    version: "v2",
    name: "kengo",
    symbol: "k usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B985c0ff11604E9FF6100e80D7b38B0afcc507b",
    version: "v2",
    name: "Only Trust",
    symbol: "only-trust",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3Da8Be659674062253B0f1EF9E765C7a6AF8C8d0",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3f6842a004214dcD070E10e590d704e0b4c46c58",
    version: "v2",
    name: "Brrrstr USDC v2",
    symbol: "brrrUSDCv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x138006a8a8E2588122B290e9B3366453E9021cF5",
    version: "v2",
    name: "Roissingue EURC",
    symbol: "roiEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x0990B5d4cbc87b471b2b906eD8f50703FEf5424a",
    version: "v2",
    name: "EDIT",
    symbol: "EDIT2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8AC9550265dB03981197d24cd6E575ac955E6Cad",
    version: "v2",
    name: "Best Vault!",
    symbol: "JON",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3456C0DDAd11C806882acdB8581de1b8E1C59695",
    version: "v2",
    name: "THANKS",
    symbol: "THANKS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x79e20266EC94fCEFE52F61886BC72d29B1a99954",
    version: "v2",
    name: "Cash Carti",
    symbol: "CC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x769f76c0F5B9E83a0d109b501EEEd9f43F988e93",
    version: "v2",
    name: "ready",
    symbol: "ready",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x737615F1a1E0d89a82eD5eaA1Dd066468737920F",
    version: "v2",
    name: "tt",
    symbol: "tt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x183747E1A123b6310EF39f449BFBBEb049e5c54A",
    version: "v2",
    name: "Sovra USDC",
    symbol: "svUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x155860F2cF64510e50A6c4571BB0261276797459",
    version: "v2",
    name: "Moonwell Ecosystem USDC Vault",
    symbol: "meUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3233bc50d86af38ffBb89Cb4a5aE42C93294C698",
    version: "v2",
    name: "testooor",
    symbol: "tooor",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef00b05AaFCf3caF27484Eea919E0AE7c7D048",
    version: "v2",
    name: "Ramp Network x Steakhouse",
    symbol: "rampnetwork-steakhouseUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3B960E08bdfBbf916b863F715ec38E9e0Bd3a148",
    version: "v2",
    name: "test USDC",
    symbol: "tUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAAEefCE93CF99850d0cC719B331b7ffb6bab99F1",
    version: "v2",
    name: "L2's Test Vault",
    symbol: "L2_Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x99048A858243e846aD38834800a3045b5bF5AB67",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x82d90bC8FAD2478aB599037C4E334fc4531bcdfd",
    version: "v2",
    name: "L2's Test Vault",
    symbol: "L2_Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x83faBD47F012D76E66ba95C58db96BE9A5c47cbA",
    version: "v2",
    name: "IoannisVault",
    symbol: "IOA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x948bD58861CbD368A5eb8F0236c0CC48b9782d45",
    version: "v2",
    name: "USDC Low risk arbitrage",
    symbol: "USDCLRA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4Fe103d05704E8d85D5E03B5D3b41FDB73D53061",
    version: "v2",
    name: "test2",
    symbol: "test2USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdA6c99752A7b50981e5643A81eaF4a076743bC00",
    version: "v2",
    name: "[DEPRECATED] Rebind x ByzPrime USD",
    symbol: "reByzUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x297E12055C247068118475d7891286B05d5700e2",
    version: "v2",
    name: "Tron x Steakhouse USDC",
    symbol: "steakUSDCtron",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7c79D249ae2ab32FCcA0fb1aaB6A04890989D800",
    version: "v2",
    name: "Vault 69420",
    symbol: "YEET42069",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x471854BD594FE7B1C6bB8902A98815352b7dF1f6",
    version: "v2",
    name: "testing1232",
    symbol: "test12321",
    asset: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x7E16BDe2275335271a7a5478Cb7A5F9f509bcd4F",
    version: "v2",
    name: "Blend USDC Reserve",
    symbol: "blend-usdc-reserve",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x95467234a4Ff0f0A693eBBcb0C0a05B2b1469445",
    version: "v2",
    name: "Blend USDC",
    symbol: "blend-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0eE5835f955AdC193aD3fa908cc41e97807173F2",
    version: "v2",
    name: "yeeet",
    symbol: "yeet",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x89dA228130835c654C2EF203F6Cc3343b2FdD456",
    version: "v2",
    name: "Vaulto",
    symbol: "$vaulter",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4f4A62Cd648e0249114e04f4Eefb628936Ee754a",
    version: "v2",
    name: "DeTrade Serenity USDC",
    symbol: "dtsUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x62b71098B4c7e91f904B580B9a2Ab7Fc27710F84",
    version: "v2",
    name: "Tron x Steakhouse USDC",
    symbol: "steakUSDCtron",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x83597517E34a2ca0902c2E6fecad863BB251a5Ce",
    version: "v2",
    name: "Tron x Steakhouse USDC",
    symbol: "steakUSDCtron",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x27467933d20728DcA7ea59f1a1804e377d771D71",
    version: "v2",
    name: "Test2",
    symbol: "testy2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5907A288F6C1840B687020Fc824382232102b083",
    version: "v2",
    name: "Staked iAero",
    symbol: "stiAero",
    asset: {
      address: "0x72C135B8eEBC57A3823f0920233e1A90FF4D683D",
      symbol: "stiAERO",
    },
  },
  {
    id: "0xbd43A9E7D44838868d2bE0717958BeDcA63bc88e",
    version: "v2",
    name: "LTtestvaul",
    symbol: "LTTT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x03258A2b73e6532CbE3ba4460DefdFF8782C08C1",
    version: "v2",
    name: "@LTtestvault",
    symbol: "LTT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x62B2B27A53aA052eF31D5996b651A347EcB73343",
    version: "v2",
    name: "Rebind x ByzPrime USD",
    symbol: "reByzUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6D0ce10Ce319d77a1d44993C033fd914a44806A5",
    version: "v2",
    name: "ltvaultt",
    symbol: "LTV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE217C79748f8D582728c1C954fEED460fcec8872",
    version: "v2",
    name: "Test_C",
    symbol: "TC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x071865d307D70C0E1AbB828C660701EcbD88d9F2",
    version: "v2",
    name: "LTTest",
    symbol: "LTT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE9a5C25c3921d0EE92d6554F848ac481fa24fDE8",
    version: "v2",
    name: "InitTestIKRename",
    symbol: "TIKRen",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x67946f004DaD4A815e3361D64E8E184E4E4C23F2",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x927c86BFDafC7Ec4646648bC80257A2b5339d702",
    version: "v2",
    name: "Farcaster x Steakhouse Prime",
    symbol: "steakUSDCfarcaster",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEF00fc6e87dE086A0e29169A2f6e25cF5C11a9",
    version: "v2",
    name: "Farcaster x Steakhouse Prime",
    symbol: "steakUSDCfarcaster",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEff02DE231f8B08c627C769edC73e7AcE47264",
    version: "v2",
    name: "Tron x Steakhouse USDC",
    symbol: "steakUSDCtron",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbB2F06CeAE42CBcF5559Ed0713538c8892D977c9",
    version: "v2",
    name: "Moonwell Ecosystem USDC",
    symbol: "meUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD14A0D3565b75a28dDbA9267Df9BFbbceF1e4EE6",
    version: "v2",
    name: "scuba",
    symbol: "scuba",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0E661dAa31f2c4c0AE6f28e125D418D056562598",
    version: "v2",
    name: "scuba",
    symbol: "scuba",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa20eecB97d0f70e1D9f9008db4CbF2239b9c922B",
    version: "v2",
    name: "Test USDC",
    symbol: "tUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7491dAe5f29ca0C99c03D1254abFDaFda562baC3",
    version: "v2",
    name: "Blend EURC Reserve",
    symbol: "blend-eurc-reserve",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xC57Eaa3A14E8087B5e6c00AD7569b6147b117958",
    version: "v2",
    name: "Blend EURC Reserve",
    symbol: "blend-eurc-reserve",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x73436278D94198b01d9de89Bab770394f1022E98",
    version: "v2",
    name: "Blend EURC",
    symbol: "blend-eurc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x7Fca8b4F8a63E1F496E284A4cF9D7ce013b996Be",
    version: "v2",
    name: "edit",
    symbol: "name",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE01fC648B69718087Bc8BFBB410c3f334ac9ae41",
    version: "v2",
    name: "yeet",
    symbol: "yeeet",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x34c98aceb10a11F4B5A951487d31f0A363eF1675",
    version: "v2",
    name: "marius vault",
    symbol: "MVV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x12E61620Dd1e16d36a7a97cD48a9dcaB6b471c7f",
    version: "v2",
    name: "edit name",
    symbol: "vault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDb101fb4689Be317a950F7F059915B159cEC30D5",
    version: "v2",
    name: "edit name 2",
    symbol: "edit",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x682B5e8c957249E2694c7975909A3aFDD6E4c1B9",
    version: "v2",
    name: "SudoUSDCVault",
    symbol: "sdUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0f7bAF9977C20c4Bc331c7394cfCC13c3e40a9C4",
    version: "v2",
    name: "V2 SS Test Vault",
    symbol: "V2SS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB2d2bfdF380aB653B99E46d345A8086eeC4AB37f",
    version: "v2",
    name: "Yearn OG WETH V2",
    symbol: "yOG-WETH-V2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xeAA2657dB82229e241e0c972306c0e75324b2947",
    version: "v2",
    name: "Yearn OG WETH V2",
    symbol: "yOG-WETH-V2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3FbD8c8E123ce473482933be4B3A292bbCDB2360",
    version: "v2",
    name: "Yearn OG USDC V2",
    symbol: "yOG-USDC-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1F113af19BB2407822C4f28663b62cC0DeEAb976",
    version: "v2",
    name: "Yearn OG USDC V2",
    symbol: "yOG-USDC-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x49deC2B14F637A1055553A6513fEEF505cCEA084",
    version: "v2",
    name: "a",
    symbol: "b ",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xB16595bABf6191bdDF75b4420591b1EF9C001d75",
    version: "v2",
    name: "sdf",
    symbol: "jlksdjflksd",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3f3fd887F72b0593923d1F8751e2e0A1D01B98d2",
    version: "v2",
    name: "test3",
    symbol: "test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa0B97f44158B11ba8E82D6d626b5dC90D8e9a9C5",
    version: "v2",
    name: "Hello World 2",
    symbol: "Hello World 22",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcf11BDB63EdD19DE020BC4f03d385CDA75421566",
    version: "v2",
    name: "Test",
    symbol: "TEstet",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x74e64E9DEa0D1E9e34E527100b021Ae2f14e9f4C",
    version: "v2",
    name: "Mega Vault",
    symbol: "mVault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe49611d07055556c965A0f7b8A6940CC8A3b8a54",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x293BEAbA5874A855B3E72d71277F2677b1433320",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x04BFD69AAee72D883B5FF7B3e2cB31099B8f6012",
    version: "v2",
    name: "name",
    symbol: "symbol",
    asset: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xf1348487Ef3eCC053D6029Ed69af9980078BE1fd",
    version: "v2",
    name: "5test67",
    symbol: "3",
    asset: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x9D733465D31F10bF6A932359Bd3aC6A0D80D14f2",
    version: "v2",
    name: "Clearstar Core USDC",
    symbol: "CSCOREUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfe5f659afE2e013691F901F918Ce92BAC97EC568",
    version: "v2",
    name: "BaloUSDCVault",
    symbol: "blUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB15336452d9A816Aa9d3143e417139A6Dd72860b",
    version: "v2",
    name: "test-007",
    symbol: "test-007",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3Ec476359A5647ef1df5435DaF7FcCB1A6DC2D2d",
    version: "v2",
    name: "shamUSDCVault",
    symbol: "shUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x189e47D7F6E912A5E07762eabDAcbC259D268495",
    version: "v2",
    name: "USDC Test",
    symbol: "USDC Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x33093365De50cf314036fCFdA477216c59EeD2Cd",
    version: "v2",
    name: "High Yield Savings",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0C25B5dDCF70eaFF14E9EC39cd1aF42fF6ed7575",
    version: "v2",
    name: "FRDFI Test",
    symbol: "FRDFI",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0bF9D6e40dbfB8e640C51152034B62E95c22d685",
    version: "v2",
    name: "asd",
    symbol: "asdweqe",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3ec685C1f52753d00b2BB703038C59A7EAaEd65e",
    version: "v2",
    name: "test",
    symbol: "xx",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe6F496F1Bca312E60C4EF5dC03b467B136EdfCb7",
    version: "v2",
    name: "test",
    symbol: "xxx",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf5626055Aa5CE9059Bcc5cBCC942bE7FBA22B83b",
    version: "v2",
    name: "AUTOMONARCH",
    symbol: "mUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFFdeADc2c172130Ac4C5Ae48c8D4708BFb40",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptETHturbo",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xea4B56a12d5ff5216727D4c74716Df71aB0fd950",
    version: "v2",
    name: "MTV",
    symbol: "istaUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0e59471b6f74e76b617572D1aAB789F5d4741D48",
    version: "v2",
    name: "Ask Kool Alan",
    symbol: "AKA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfc8bd11FAF9CfA72377b0Db905480Bcf168a25BD",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFabaA481f6fCAC06c8eC329431bb8fb4b18bBc53",
    version: "v2",
    name: "RSC/USDC",
    symbol: "ResearchCoin",
    asset: {
      address: "0xFbB75A59193A3525a8825BeBe7D4b56899E2f7e1",
      symbol: "RSC",
    },
  },
  {
    id: "0xe13A7c34E299a25B6fb7811D6b381A808A56d17e",
    version: "v2",
    name: "WSTest",
    symbol: "WSTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5866C602a98B85b83d7BC558E5Ca1cd2507AADE4",
    version: "v2",
    name: "EURC Stable Yield",
    symbol: "EURCSY",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x5eEF59eE10b0B2a3724BF8d4C37DD72163eA912A",
    version: "v2",
    name: "Blend USDC/GHO",
    symbol: "blend-usdc-gho",
    asset: {
      address: "0x1CE163ACb4E5133e5333cCEd1B6D82FE7daB42F4",
      symbol: "wmooBalancerBasewaBasGHO/waBasUSDC",
    },
  },
  {
    id: "0x247a9474cc0006A1CFb5705DEbBB1e97B484bCfa",
    version: "v2",
    name: "TTM Vault",
    symbol: "VTTM",
    asset: {
      address: "0x1aEb82fab81703a7d0C327e65Cb95F8Cebc9a19d",
      symbol: "TTM",
    },
  },
  {
    id: "0x4f0bB8129cbD387E9C08a8d127Fe020159F27735",
    version: "v2",
    name: "GioTest",
    symbol: "GT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb123082a375dF39B7b2657352Ce1Ce39C7E98F24",
    version: "v2",
    name: "Reallocation Bot Test USDC Vault",
    symbol: "RBOT_USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf54ee4e53cA0C12BA3151906EeDaCb953F8337f1",
    version: "v2",
    name: "Licua",
    symbol: "LiUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd4A219F12af93B054955E1F8d1717be3FAeE260f",
    version: "v2",
    name: "KSM",
    symbol: "KSM",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe1CF810D3D33cC43b1b29bFe0FD785bfC568187f",
    version: "v2",
    name: "My Flo USDC Vault",
    symbol: "FloUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD42380eAD46F2A961D2cf55DE7c35a4225b3cD60",
    version: "v2",
    name: "ryield",
    symbol: "ryield",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4099863367A83d7330341ea3329CE1D78c52bC1a",
    version: "v2",
    name: "Vault DBA USDC v2",
    symbol: "VDBA2-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0e481E814883b58F53de6D635CdB174fcB60061d",
    version: "v2",
    name: "Vault DBA USDC v3",
    symbol: "VDBA3-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCD66B99a09403Bb6ca4E146E7091E224bfffc5BA",
    version: "v2",
    name: "MaxYieldUSDC",
    symbol: "MaxUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x28c66719A024F2e95E7859655cC8AFEC3Ce9Ab66",
    version: "v2",
    name: "Hamsterdam",
    symbol: "hamUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA01f9dc6042ACBB64b1005c6185eee95877FeD60",
    version: "v2",
    name: "testvault1 USDC",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7b10EeEE33990dd8447B5784882CfeAF0d6B127f",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x41cC4fd8DedD2c80435AB9B40D2e00E72F4d3e35",
    version: "v2",
    name: "trial",
    symbol: "aMUSDCUSDCtria",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA495D5C10dA331FFe2e3e5400877D625d0d68f2B",
    version: "v2",
    name: "Auto LX Vault",
    symbol: "LXV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5A5d73F715c68858EFcde5d14c99968D5B7cB167",
    version: "v2",
    name: "Based USDC",
    symbol: "basedUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xce3915634D1fEA7E586d9552c295070b3d056E89",
    version: "v2",
    name: "Vault DBA USDC v4",
    symbol: "VDBA4-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a26dc8b78fB1177De1dC9fE339484ef3e2C40CD",
    version: "v2",
    name: "Lightning Auto USDC",
    symbol: "laUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa39E611951a694F39e7192C3e6c597A33780F651",
    version: "v2",
    name: "Philly Philly",
    symbol: "PP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC038DA5241f6c9A4AE6e58E41d726Ba8b18e9A47",
    version: "v2",
    name: "aa",
    symbol: "aa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x98726307a8a89419ef0Dd8195afB43bAD80898a0",
    version: "v2",
    name: "Vault DBA USDC v5",
    symbol: "VDBA5-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd6B12EfFB4A94cAd995b6e999ea15c649E529701",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3a50313E4326851Aa233EEfdE85A9Bb6c517dAdF",
    version: "v2",
    name: "NotPunk USD",
    symbol: "NPUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x259d22f975c3113Fd4a307b3EcEb26439C25bE2C",
    version: "v2",
    name: "Dafiment",
    symbol: "aDAFI",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcd6E0fbEBaD52E0e339c3069964A39474804B3A9",
    version: "v2",
    name: "USDC",
    symbol: "uSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x02bEE62C4008A9023dD9f22D23586973001850aD",
    version: "v2",
    name: "autousd",
    symbol: "ekisde",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2B06Bc4Ab42Bba6e1cd87FEEB8Bf8a440Aae2576",
    version: "v2",
    name: "dest",
    symbol: "DEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1361d577D213C02D621aC7F4adb34C36Ed8587BE",
    version: "v2",
    name: "DeTrade Morpho USDC Base",
    symbol: "dt-morphoUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa93ec77DD77426f98EFcFfE36848593978DeD1CC",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x62C2afe8738947da91553e21133A55066ef629a5",
    version: "v2",
    name: "0xmizukilendingoptimizer",
    symbol: "mizukivault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF9902DAF6c6F92879F4892a1DB156b902cCC47F9",
    version: "v2",
    name: "Mr auto",
    symbol: "MAusd",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa4f83A9151b6AB73325C9bb5df6537FB13a23153",
    version: "v2",
    name: "PrototypeUSD",
    symbol: "pUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B5d122Ceb263217AbBc14684f0B6a164a9Cd70b",
    version: "v2",
    name: "dd",
    symbol: "dd",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd5cD13DE3721Ecd1B54E1006e16F782Bf6990D23",
    version: "v2",
    name: "RPC Testy",
    symbol: "rpctesty1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA6C05FDfDabD0C4b2E94a993D8B5b9ba83efBEC2",
    version: "v2",
    name: "AutoUSDC Frontier",
    symbol: "MyFrontier",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x933879A4AAfAf1879639647E33eAb81852739a41",
    version: "v2",
    name: "Vault test 123",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF31A608bD0C234f3A32d78D74Ab1C04194369086",
    version: "v2",
    name: "Vault DBA USDC v7",
    symbol: "VDBA7-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6B5645dE580B68B1e71D7F4A4D1C5F5C31034dF6",
    version: "v2",
    name: "Vault DBA USDC v8",
    symbol: "VDBA8-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2bA1E06BA26DBec56DBc1582Eb88E938572e8e35",
    version: "v2",
    name: "Test1",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBb8F39b59f88fc2A7d330cEe35E054560Ca0C963",
    version: "v2",
    name: "Vault DBA USDC v10",
    symbol: "VDB10-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x67439194eae82E79274C7C450F6121Ec770e0A57",
    version: "v2",
    name: "Test Vault Morpho app",
    symbol: "TVMA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7D8Fef9E3CA32408af89CD15642578fd310c5fF9",
    version: "v2",
    name: "Vault DBA USDC v12",
    symbol: "VDBA12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd8A14523Ce489FB10f7Fc86152Ba950C3dC97e34",
    version: "v2",
    name: "Auto High Risk",
    symbol: "aKKKEN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc7E6a1FE84ADaCeC3eEE2FB4feD3c827D7e45bd1",
    version: "v2",
    name: "Vault Aave Adapter",
    symbol: "VAA-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x85353BF076b18d3b6eB428844764e1E030564A0B",
    version: "v2",
    name: "Vault Aave Adapter v2",
    symbol: "VAA2-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xEE846cd74B3000f2eb79052cF684589759914888",
    version: "v2",
    name: "TEST",
    symbol: "TT",
    asset: {
      address: "0xaf69Bf9ea9E0166498c0502aF5B5945980Ed1E0E",
      symbol: "ltPARA",
    },
  },
  {
    id: "0xFbF104A592c25f11363CCb7Ad5e4942D536287C8",
    version: "v2",
    name: "rpcTest",
    symbol: "RT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF0723e9b8206A3D6bEd4Bb9333D26cA470a4b0aC",
    version: "v2",
    name: "Some Vault",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4a88AFC69538D1d8F488f8e80ad5f5605Cc9dE6B",
    version: "v2",
    name: "Kore Solutions USDC Yield",
    symbol: "KoreUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x92CA7cAa982c1e6F49846C47C6791E7b0fF1F0d1",
    version: "v2",
    name: "Test",
    symbol: "TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEfB87c93826D2f3FB43311BE38C766115269024",
    version: "v2",
    name: "Bloom Real Estate Private Equity",
    symbol: "0x-RWA-BLUSDC-EV",
    asset: {
      address: "0x5d81E33bf04162c8fDe897F543b265F3c5B51712",
      symbol: "BLC",
    },
  },
  {
    id: "0x66FF1D1BBAa494cB2935De8d25F6BA9e48D5aB1e",
    version: "v2",
    name: "Oak EURC v2",
    symbol: "OAKEURC2",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x164Bc5FDaf59D6e326A3aAbF5d2b37E7ab8639AC",
    version: "v2",
    name: "JUNHAN",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE34D43CA9152D198B60654868C8cD197196a492f",
    version: "v2",
    name: "Avantgarde USDC Conservative",
    symbol: "AVGUSDCconsb",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD68b6A5a08Ec709264b699CC996Ca02d7dD51A22",
    version: "v2",
    name: "USDCC",
    symbol: "cUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x769d8c8D0Cc015e96097362BE7708B2121320Dc2",
    version: "v2",
    name: "Vault DBA USDC v13",
    symbol: "VDBA13",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8ABd53f52C3301e0CC78AA6261f8dE2535bFD67B",
    version: "v2",
    name: "Steakhouse USDC",
    symbol: "steakhouse-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF75468742b9004688CFF5627C453148BfFC9Ab6F",
    version: "v2",
    name: "Gauntlet USDC",
    symbol: "Gauntlet-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf9005096DEdFf932267010c859Bc215441e86DA7",
    version: "v2",
    name: "PrimeVault USDC ",
    symbol: "primevault-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4D0E7CF849bC315A935F9C6e9Daa75d02b14AdA1",
    version: "v2",
    name: "Deblock x Steakhouse EURC",
    symbol: "steakEURCdeblock",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xBeEFDebfaea8350Ce8C4b3a6B7E5FE629c9e27A8",
    version: "v2",
    name: "Deblock x Steakhouse EURC",
    symbol: "steakEURCdeblock",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xDb8Ea255E56AFB92d11B4cBcee5eC85d141d5AAa",
    version: "v2",
    name: "ACS TEST",
    symbol: "ascUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf251Cad03bbC53D60eF93412567C216A72F167a1",
    version: "v2",
    name: "ACS TEST",
    symbol: "ascUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE1C08E53940279b3B131032C0587e01130A3a4A1",
    version: "v2",
    name: "ACS TEST",
    symbol: "ascUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbD7985d644F1745B4e96Eb7408462A3FEb37D06e",
    version: "v2",
    name: "test",
    symbol: "TST",
    asset: {
      address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
      symbol: "VIRTUAL",
    },
  },
  {
    id: "0xcf917D42148e025c4990d6bbd20be62A8F4c3D71",
    version: "v2",
    name: "TestUSDC",
    symbol: "TUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE000BC5B0715De463D12488aC1a781eF2b851c73",
    version: "v2",
    name: "Test",
    symbol: "tstUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc69D281b1d11C96cFEAF13397060794a19B410A6",
    version: "v2",
    name: "test_11",
    symbol: "test_11",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x256f9d065f825A073358906581D49873022D10cb",
    version: "v2",
    name: "quad",
    symbol: "quad",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x082EF08d70d9694d19F79547F1Af691ef50D1be6",
    version: "v2",
    name: "TestA",
    symbol: "TA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x403f884d99E0a0303A280E340aBDC45287962b97",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B004738bd1867049a03704fee80fcC7E002a8f2",
    version: "v2",
    name: "test j",
    symbol: "USDCju",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7F05672F4958E7Dceaa74874b153Cf47B4fd6138",
    version: "v2",
    name: "Steakhouse USDC",
    symbol: "Steakhouse USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2446309aDA6581657250eF201d592E1c0106AB73",
    version: "v2",
    name: "DeTrade Morpho USDC Base 1",
    symbol: "dt-morphoUSDC-1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2e846Dae8Fe9cEEfB88F8231f12Cad7A01226cFF",
    version: "v2",
    name: "Gauntlet ETH Vault",
    symbol: "Gauntlet-ETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x70919F264E6073ab196f2a9697011B527F9F6Fd4",
    version: "v2",
    name: "PrimeVault ETH",
    symbol: "Primevault-ETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xec8AC0f28800577F8b00c8395Ab989977e0983df",
    version: "v2",
    name: "RWA Private Equity",
    symbol: "RWA Private Equity",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9156B01b98cda3b8FD5C655fE2c2010b6368Af0F",
    version: "v2",
    name: "test-vault",
    symbol: "TV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3eac1E022bf299476158d287b85c1e52Eae2bDd6",
    version: "v2",
    name: "Moonwell cbBTC Vault",
    symbol: "Moonwell-cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x4952482927542E7bf75F024e7e06B239227a6F87",
    version: "v2",
    name: "zzzz",
    symbol: "zzzz",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2b2735DE176d42BA673A468E75B20b30d5B14aF3",
    version: "v2",
    name: "Demo",
    symbol: "Demo11",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcDA5Dbf58a016158ECD4A226109752Cc3A627Ec8",
    version: "v2",
    name: "DeTrade Serenity USDC",
    symbol: "dt-serenityUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x88753C4d95Ee5B724f5b2b67E9bBef76FB5F00D6",
    version: "v2",
    name: "Arc's vault",
    symbol: "arcUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x58b8Fd566B3AbEFfEd8FeE9F9c3f9e85d449f4FA",
    version: "v2",
    name: "Clearstar Morpho V2 Vault",
    symbol: "csMPH-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x904ec0Ea0b79727B9093c78c153f01b49C03597b",
    version: "v2",
    name: "Clearstar Morpho V2 Vault",
    symbol: "csMPH-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9e93f0a3aDCeeB882Bd6EDFB48F3Fc0EE7De2beA",
    version: "v2",
    name: "Clearstar Morpho V2 Vault",
    symbol: "csMPH-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2459C025152d05fdCa960476A76B1eaF7E476E6F",
    version: "v2",
    name: "WoW USDC",
    symbol: "wUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1677250e1595EF1165cA21d820a4Bd8803153E5f",
    version: "v2",
    name: "USD Base",
    symbol: "bUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1797445a7Bc6D47f6155F20431144E6ba5a7e36e",
    version: "v2",
    name: "My Vault",
    symbol: "mUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCf78711716755EA851bA1d62a5920aA332CD9175",
    version: "v2",
    name: "SCAS USDC Conservative",
    symbol: "SCAS-C",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x265A6B919A5Ec0e8aC6804900d7e2E498Ca705EB",
    version: "v2",
    name: "Monarch Autovault shUSD",
    symbol: "shUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDFff9559B64480B3C11Deff6376F492C4BE4322d",
    version: "v2",
    name: "KrtecekCapital USDC Prime",
    symbol: "KC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x061b3aff8e21a9d194ce43cEfc20A0eFf122Ec69",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEUR",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3d6A627d992f717e11353F275a7970AD4af073AC",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURi",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3398445a909eE657e64597d71c3ae15e3712D818",
    version: "v2",
    name: "Gauntlet EURC Core",
    symbol: "gteurcc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xbeef009F28cCf367444a9F79096862920e025DC1",
    version: "v2",
    name: "Steakhouse Prime EURC",
    symbol: "steakEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x2368743270B13Ab0EF5BCD2C2Ec88A661c732616",
    version: "v2",
    name: "USDC High APY Vault",
    symbol: "USDC High APY Vault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeA001994c05cf96F00330193e6e319EF346Fb96f",
    version: "v2",
    name: "Gauntlet EURC Core",
    symbol: "gteurcc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x6593825c158df321c91fCA19D0a63B3D3857E4E9",
    version: "v2",
    name: "Gauntlet EURC Core",
    symbol: "gteurcc",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x94Af495DE1F56Aa5576dEB17986bDCeE5Dd9778D",
    version: "v2",
    name: "Gauntlet EURC Balanced",
    symbol: "gteurcb",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x57e894bC9b19f64c6fF55815401174460cC8e7EC",
    version: "v2",
    name: "Pocky's High Yield WETH V2",
    symbol: "PHYWETHV2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x630a678acc5F5c758D494294ab37658aA403963B",
    version: "v2",
    name: "Pocky's High Yield USDC V2",
    symbol: "PHYUSDCV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4C7b69b4a82e9E5D8ec60E96516f7A0E17CBC55C",
    version: "v2",
    name: "Clearstar Reactor EURC",
    symbol: "CSREURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xbeef00f0A818894a2Cf111644A5098421611100E",
    version: "v2",
    name: "Steakhouse Prime ETH",
    symbol: "steakETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xBCA4E2E24A7cFa776E4282CC8Eb06f04738b71da",
    version: "v2",
    name: "Clearstar Reactor ETH",
    symbol: "CSRETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x116e1A65717A534B73EcB7d4F6543c65DBCd0E46",
    version: "v2",
    name: "Clearstar Reactor USDC",
    symbol: "CSRUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x91C056B6d4311a743614FBc03ac32d4E6A2d3a3c",
    version: "v2",
    name: "Clearstar Yield USDC",
    symbol: "CSYUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0282159ecCaabA941bD1f4C518944D8fDCdc0681",
    version: "v2",
    name: "Clearstar Boring USDC",
    symbol: "CSBUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6963B0872d67A8795E6513bdBF1f2203c933d221",
    version: "v2",
    name: "Maxshot USDC",
    symbol: "mUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x02D43B32fAf27c6844973F051dCb6361325a62F4",
    version: "v2",
    name: "TestVault",
    symbol: "TV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x71EAeC223caa1C648136668B9c5db380c1C52dd6",
    version: "v2",
    name: "0xe99",
    symbol: "0xe99",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcccc1757Fea393c7CDFa41020C34e38763Aa0887",
    version: "v2",
    name: "Steady USD",
    symbol: "sUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x09355c2f2Ef576121899a20E533d51D77f6A33b3",
    version: "v2",
    name: "Treegens Vault",
    symbol: "TGN/USDS",
    asset: {
      address: "0xD75dfa972C6136f1c594Fec1945302f885E1ab29",
      symbol: "TGN",
    },
  },
  {
    id: "0xE17f74537c7ef4035764b6FEBEb1D7Be6b3E659A",
    version: "v2",
    name: "HavenFi High Yield",
    symbol: "HFHY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc83AC69ff1B1eA583d7f77e664ED071df12ba997",
    version: "v2",
    name: "Fr 2",
    symbol: "Fr 2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x75E5D98cdFc767eD976dD86Dae66DD4F0d5A9467",
    version: "v2",
    name: "trio",
    symbol: "trio",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9DB0d14902F3Cd905407671e538a6CB915D343e2",
    version: "v2",
    name: "AutoCompound USDC",
    symbol: "acUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2d1155f87Ddf997cF4af22beCc8A3b4E3eB9b0C0",
    version: "v2",
    name: "tUSD",
    symbol: "tUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x64E4567Cc4C058e27E2820E491cD1489a4C79F07",
    version: "v2",
    name: "DeTrade Serenity EURC",
    symbol: "dt-serenityEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x80B8b7062BF655C475ac62EC9febeFB7173a7d98",
    version: "v2",
    name: "Testing fee",
    symbol: "feeusdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1603068Af86Eeb886F6372F084663C05D0f3943d",
    version: "v2",
    name: "trio",
    symbol: "trio",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF14Fc22914111DBDA79D750CD7ECF514237A1F07",
    version: "v2",
    name: "trio2",
    symbol: "trio2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDbc890056D898c8Bc01C35A6102bEA674694676e",
    version: "v2",
    name: "OUSD Vault V2",
    symbol: "OUSDb-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2Ba14b2e1E7D2189D3550b708DFCA01f899f33c1",
    version: "v2",
    name: "OUSD Vault V2",
    symbol: "OUSDb-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x12fBcA251570D50c17aF804cDe0E452c502BDC5c",
    version: "v2",
    name: "Pangolins USDC",
    symbol: "pUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4B1cB32c61307838ac4b3A435cb8d77115a8e3D2",
    version: "v2",
    name: "trios",
    symbol: "trios",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9F205Da2b1B069337bE22415a4c5F911bf511cb5",
    version: "v2",
    name: "trio4",
    symbol: "trio4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x89a04F020290Fa6a4978B0cC9D56EeA633508fb0",
    version: "v2",
    name: "trio5",
    symbol: "trio5",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe7D0DBE3493830e2Ab62619211A2BfF0Fc60dB42",
    version: "v2",
    name: "Yearn OG USDC V2",
    symbol: "yOG-USDC-V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2EfD54529329AD364B8Df988CE3BAb5Ff256ab3E",
    version: "v2",
    name: "Yearn OG WETH V2",
    symbol: "yOG-WETH-V2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x93b02cDfD4F63D2Fe3c0c5Db410Ef947c75344dA",
    version: "v2",
    name: "AD Curator",
    symbol: "ArbUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x14227a8597588c4D7C77DBE8DE271E2a95e38DC4",
    version: "v2",
    name: "Catalysis Test Covered Vault",
    symbol: "catTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0439B7737741FFd7a136E56CaF6A7244f234b30d",
    version: "v2",
    name: "TEST",
    symbol: "MTFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x135dc8A063c690C1dD7D6edf5A90660d86448850",
    version: "v2",
    name: "MyVault2",
    symbol: "mUSDC2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1FA9279a9cb2f1d61A87f6e2285a03e7aB2dDFcC",
    version: "v2",
    name: "ROOM USD Z",
    symbol: "roomUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc8D854a36b7c72DabBe7c65894b4A059b9c889f1",
    version: "v2",
    name: "Test",
    symbol: "aTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF5b067b56B34a4c45191cbBEf6889D637F6B60E5",
    version: "v2",
    name: "ASDAS",
    symbol: "ASA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3f29342837e11bdcA4e374F5231Cec9DC0F6DeC7",
    version: "v2",
    name: "Dummy",
    symbol: "DUMMY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFFe68dFc2D3BD1ABdAd37c70634973b16478",
    version: "v2",
    name: "Steakhouse High Yield Turbo USDC",
    symbol: "bbqUSDCturbo",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeb61b0d4dCc8cA8B21DC7A5820528a117f5DD935",
    version: "v2",
    name: "mvault",
    symbol: "meta",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeCb31354A9d54ce9BDed3Eb30126736BC436F6a9",
    version: "v2",
    name: "m2",
    symbol: "m2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFcC0417A3550aB43997615A411cD481FF88557b6",
    version: "v2",
    name: "m1",
    symbol: "m1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcc3f5dC98d2B1cF5c9487F03dD0e31e46eB4cd82",
    version: "v2",
    name: "Snow USDC V2",
    symbol: "Snow USDC V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2f27336f77462197b7307c34a9b91815e5620ee",
    version: "v2",
    name: "MYTESTFEEWRAPPER",
    symbol: "TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x17e371F21a3B47CF2723DB4b84c26e285D576Dce",
    version: "v2",
    name: "TMTEST",
    symbol: "TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xed3010274D9cdbd22BFe0757A6d433F48dD1d34a",
    version: "v2",
    name: "Auto Test",
    symbol: "ybUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x48c2911060806a19247a272D588D7C06cBe7c9A0",
    version: "v2",
    name: "V2",
    symbol: "V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE52FF42F71b40DE788A0bceC9a543EbB7fa75F45",
    version: "v2",
    name: "Morpho V2",
    symbol: "Morpho V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB429bd25b98f29032621DF4fCDF23Da9E045FA45",
    version: "v2",
    name: "Morpho V2",
    symbol: "Morpho V2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9C806B18c97cf9B7F79E918F0295528f76aeF1FE",
    version: "v2",
    name: "trio6",
    symbol: "trio6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x63b0F24CeC574eA149c7BEB5e785d499F170A361",
    version: "v2",
    name: "WETH Tst",
    symbol: "WETH-TST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xc46D2fd4474C79A36C73aE1d1763f93F28393E9E",
    version: "v2",
    name: "Test USDC",
    symbol: "USDC-TST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFE315066Bc4714Bd342777027DcB3dB0Ede6618a",
    version: "v2",
    name: "trio8",
    symbol: "trio8",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc04BF0F7ddd2712e03B920FE148758B3F9a26bdA",
    version: "v2",
    name: "trio8",
    symbol: "trio8",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2D77c1ba6B92f525Ab36Bfc5662A4067B434E1a",
    version: "v2",
    name: "bastion",
    symbol: "BTN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x58dCAE547c629093c3F44986E333Be34c4617714",
    version: "v2",
    name: "Legacy beta",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x67E02852a41A7CBAb71EA6869e55A63B170e5129",
    version: "v2",
    name: "One1",
    symbol: "o1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x89BeDBB1C4837444Da215A377275Ff96A84D6f53",
    version: "v2",
    name: "Moonwell Flagship ETH ",
    symbol: "mwETH ",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x48a90E85be5C56b0A669985A12ee7C449fC79965",
    version: "v2",
    name: "Moonwell Flagship USDC",
    symbol: "mwUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5083b1387Ec3d4Ee6467B83890D98f1AF93F7c48",
    version: "v2",
    name: "Moonwell Flagship EURC",
    symbol: "mwEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xdbA76Bc542bb07538e046B40F2e8a215B409F7A8",
    version: "v2",
    name: "Moonwell Frontier cbBTC",
    symbol: "mwcbBTC ",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x1c1b3Ca5894aE80b13d658E252CD7A898d9d3066",
    version: "v2",
    name: "a",
    symbol: "a",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6ffb4C515E16B778471841c2BCEE32D2614D9d92",
    version: "v2",
    name: "Foulk vault",
    symbol: "foulk",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcD26E8AeC8EF24c261EA21219788CFdC0A869273",
    version: "v2",
    name: "jvtestlaunch",
    symbol: "jvtestUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD3dfEd4Fab50AD02787F2da1306C90a74eFD5258",
    version: "v2",
    name: "Modern AI Concepts",
    symbol: "MAIC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4459fdbd693B362620069c4838aAB6CC50BA4e17",
    version: "v2",
    name: "WETH Vault",
    symbol: "WETHV",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xb213261AB6b97Bc0Cb5b49EC8378d4380441EB96",
    version: "v2",
    name: "TEST-BASE",
    symbol: "TB1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd3b59BDEe1250e8a8F735865AF81BE360BC8280a",
    version: "v2",
    name: "Demo Vault USDC",
    symbol: "DEMO_V_USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEF0097FB2D7B7e0DCa28588e0e78591Ba388eE",
    version: "v2",
    name: "TEST",
    symbol: "TEST",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xcAb74eCe6ccB4D2b3eDd41ccb8BD5de9eba6880E",
    version: "v2",
    name: "USDC Vault",
    symbol: "USDCV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2f554D901ad141D22A5A6E5b9F5b7828bA1fb620",
    version: "v2",
    name: "Test USDC Vault",
    symbol: "Test_USDC_Vault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5338c4cFD6c6b4C6C867085167C38c65FBa3E614",
    version: "v2",
    name: "TestPrivyVault",
    symbol: "TPV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x19820F30b2496617A39681F684a0f76fC81B5870",
    version: "v2",
    name: "USDC Test Vault 1",
    symbol: "USDC_Test_Vault_1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9bA096C8e1315D47c46575d3C9121374B5822941",
    version: "v2",
    name: "USDC Test Vault 2",
    symbol: "USDC_Test_Vault_2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1255C948f93c3CDd4FA72CEA0208D09e55Cfb189",
    version: "v2",
    name: "Test RWA",
    symbol: "TEST_RWA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5e03f8965e2957291B3c6990C6Cb9023c36d3d30",
    version: "v2",
    name: "Prime USDC",
    symbol: "primeUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x530aC240f9645bAD8CdFf96d0dA45c1B85b9ccc4",
    version: "v2",
    name: "Auto USDC",
    symbol: "aUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6E33F57a843C669B133A047D0c5B1F27b7444FaC",
    version: "v2",
    name: "USA Pro",
    symbol: "usUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC9AD366b2080009a678ACffC90d72Bc068a2abD7",
    version: "v2",
    name: "trio7",
    symbol: "trio7",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x70220c14634B129c2DcFD53AC3661e48e9787Bd7",
    version: "v2",
    name: "trio7",
    symbol: "trio7",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x85E5B725F268d988a11235eA2154c1F54A220c1a",
    version: "v2",
    name: "trio7",
    symbol: "trio7",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfC8edee3e9adF6989D844a141D0DFce8f5996472",
    version: "v2",
    name: "testUSDC",
    symbol: "tUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2Fc7e2023C7c0624D4C64c761498B6530778026",
    version: "v2",
    name: "Test RWA",
    symbol: "TEST_RWA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBb1EAD1f2953383a1931392120209C03a51cb190",
    version: "v2",
    name: "Test RWA",
    symbol: "TEST_RWA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x25579730361697A34495bE191c1cA0e78500d424",
    version: "v2",
    name: "Bob",
    symbol: "TEST_RWA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6d4ee465B2BaDB6455028228676852b746Bb6647",
    version: "v2",
    name: "TomTestVault",
    symbol: "TTV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x02cB399eBdd54c8AB098456C6b467A5FDfa12e78",
    version: "v2",
    name: "TEST",
    symbol: "TEST",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0xD93C073395740A78C57389eD7075748F464f8ab4",
    version: "v2",
    name: "Pro 2nd try",
    symbol: "secUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB61a6d42139392210E484377dB67A8767F312f58",
    version: "v2",
    name: "JonTest1",
    symbol: "JT1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x253C9286fb48D829D5775bdC4c1E7D9ab3E32055",
    version: "v2",
    name: " Pilot-Vault-536",
    symbol: "536USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf4A3FaDcEf350B2F168F97Cdbaa2221FF29ACBd5",
    version: "v2",
    name: "EFIX Brazilian DI Yield Vault",
    symbol: "efixVault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x85DfBE8C834aE0451613E58604E6E165Abb5c4Db",
    version: "v2",
    name: "fxUSD Agentic Stablecoin",
    symbol: "aiFXUSD",
    asset: {
      address: "0x55380fe7A1910dFf29A47B622057ab4139DA42C5",
      symbol: "FXUSD",
    },
  },
  {
    id: "0x1383B3Cce7c3791aD27239dcaE46485FD1630b14",
    version: "v2",
    name: "Jon Abdication Test",
    symbol: "JATEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x40c5c6B14e55571AC96f416A97e5E5840CeB76f7",
    version: "v2",
    name: "coffeeUSD",
    symbol: "cUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf7FC06083E43214e7C1a165c4B23f85F095c7Af2",
    version: "v2",
    name: " cbBTC Vault",
    symbol: " cbBTCV",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x35C9d16aFE86Fd52A351cC5a8f3882E96EB8dc3C",
    version: "v2",
    name: "IAIUDH",
    symbol: "as",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2e80D5E9B0cE7ED230C0fc6C25E69f6A47c0F279",
    version: "v2",
    name: "Steakhouse USDC Sirloin",
    symbol: "bbqUSDCsirloin",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x25282BcEC380A1a15966629B17d1e73aF38201E3",
    version: "v2",
    name: "RFD USDC Vault ",
    symbol: "drfUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4C8618f6fd8c50A97385394DbD7699eA193fA163",
    version: "v2",
    name: "syrupUSDC Vault",
    symbol: "syrupUSDCV",
    asset: {
      address: "0x660975730059246A68521a3e2FBD4740173100f5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xEE684B48D9BE2Df89Af3E2Ab0c09aa206b4508C8",
    version: "v2",
    name: "USDC Testvault",
    symbol: "USDC-V1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1d5ebdEc0b474dd0A2E2cdb9cA2561AAa2bc4439",
    version: "v2",
    name: "Morpho_Optimizer",
    symbol: "moUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd01ea19f096e31C43DB791C82C5910dC16Dd5C83",
    version: "v2",
    name: "jon test 22",
    symbol: "JTEST2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2Ad599c260067005f1471a8220D210b729984511",
    version: "v2",
    name: "JonTest3",
    symbol: "JT3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x70C5d5dE2Cb9F5C277C9A79A49F5508A5597200a",
    version: "v2",
    name: "Steakhouse USDC Sirloin",
    symbol: "bbqUSDCsirloin",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7177c9f5F081E6FE4df8615C5a5C9E780f673AE7",
    version: "v2",
    name: "JonTest4",
    symbol: "JT4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8c809BEF9541de0aA267B74800be036ACA434301",
    version: "v2",
    name: "Steakhouse USDC Sirloin",
    symbol: "bbqUSDCsirloin",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5e1837E1aDC19f7D0ce977395DFa5A1a82B4E6c6",
    version: "v2",
    name: "Steakhouse USDC Sirloin",
    symbol: "bbqUSDCsirloin",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3Ba79E07A7B020C21d430bD7caB80D4Db32911BB",
    version: "v2",
    name: "Test Vault V1",
    symbol: "tv1USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB29606fC00FcD6Cb73F96e12E7Ef8e357D1587f7",
    version: "v2",
    name: "Still Building",
    symbol: "SB",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFAD8d6e7782FE9244f69e713950C47Be6F7f131a",
    version: "v2",
    name: "0xb12",
    symbol: "0xb12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD154c94E9f853dcD5C1d19edc0b6AB82f2D399B3",
    version: "v2",
    name: "x",
    symbol: "ueTLC-STD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x56e78Bd65A85E4c29f0dA668cC58F951b506e2b6",
    version: "v2",
    name: "kawmUSDC",
    symbol: "kawmUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8f1f15E71C40F0b35ad0Cb0A560D8f6b831E0743",
    version: "v2",
    name: "UnblockEquity TLC — Standard",
    symbol: "ueTLC-STD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1D530642d8163AEFD1b9B7Aa759063f3945C8500",
    version: "v2",
    name: "x",
    symbol: "ueTLC-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5781d6e5E9e959C00AA06dA565743ed161dB263F",
    version: "v2",
    name: "x",
    symbol: "ueTLC-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2c5b5ebcBb5Ff7fD89a806Dc81fBa424C73180b2",
    version: "v2",
    name: "x",
    symbol: "ueTLC-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE8Ec999F62a176c291726bEAcC096a34E86F74f6",
    version: "v2",
    name: "Silverback Yield USDC",
    symbol: "sbUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1B5C1Cf3742917f129Ffd4daa0f15728fc0Af424",
    version: "v2",
    name: "groovyroom",
    symbol: "GRVM",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x146B584a209F64d3e9D85847FD453A423D3a6778",
    version: "v2",
    name: "Momentum USDC",
    symbol: "mUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF5ef6D3627836F798fa3e6E93E1E490b6f3c72EB",
    version: "v2",
    name: "TEST",
    symbol: "tst",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x04F22296E9846854a7b72Bf9AB6Aa2527DC174b3",
    version: "v2",
    name: "Test USDC Vault",
    symbol: "tUSDC",
    asset: {
      address: "0xFEAfd68F913664C87340390f1eB13d288dC19fD0",
      symbol: "test_USDC",
    },
  },
  {
    id: "0xf4B07ae232a62595767d1cB61973DD90fecd7142",
    version: "v2",
    name: "Base Test 1",
    symbol: "BT1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF9A01389e9830A27F437C891e2249E1aaEe83f0F",
    version: "v2",
    name: "Brazilian Power House",
    symbol: "BPH",
    asset: {
      address: "0xE9185Ee218cae427aF7B9764A011bb89FeA761B4",
      symbol: "BRZ",
    },
  },
  {
    id: "0x53fd4DA35638b86E377dfF3022F5969F90A9d61a",
    version: "v2",
    name: "BaseMorpho AutoUSDC",
    symbol: "gUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x694514d9074247737fd924186ee356A5DF481dB2",
    version: "v2",
    name: "Goat Lend V2",
    symbol: "GLV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x10158847742E51e7A2B3e08f2b7599895207aD08",
    version: "v2",
    name: "Test USDC Vault",
    symbol: "tUSDC",
    asset: {
      address: "0xFEAfd68F913664C87340390f1eB13d288dC19fD0",
      symbol: "test_USDC",
    },
  },
  {
    id: "0x6Eb0753F2A24c87Ac15F9A4a8Efe541CD258B33f",
    version: "v2",
    name: "Vault DBA USDC v25",
    symbol: "FloUSDC25",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE5968022Ae4DB85b3EdA4B1C99b54131d6F4B06D",
    version: "v2",
    name: "Vault DBA USDC v26",
    symbol: "FloUSDC26",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3BA880aEbbda22d5a8F154C48F4B74A5506698eF",
    version: "v2",
    name: "Vault DBA USDC v27",
    symbol: "FloUSDC27",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7Dc182dd844C000Ca192Df17F9ccBDa99F325A2c",
    version: "v2",
    name: "Jason Vault V2",
    symbol: "JV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDe80A52352F33f6a006520552f0E1ef154D8d3B7",
    version: "v2",
    name: "Kucoin v1",
    symbol: "KCV1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x41A145BA738bcF5f7fd61EECfcA96c47F8F7462C",
    version: "v2",
    name: "ForceExit Vault V2",
    symbol: "FEV2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x722ae3c4efa0015BCAB6e5bA24A07fC1319EA7b5",
    version: "v2",
    name: "Test E2E",
    symbol: "testE2E",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x24e727f2a48877646B6EC32a73AB5099382c0b89",
    version: "v2",
    name: "USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB448b8EA93bE63099D75144B60c46d2AF4a1610D",
    version: "v2",
    name: "USDC_Test Vault",
    symbol: "TST-USDC",
    asset: {
      address: "0xFEAfd68F913664C87340390f1eB13d288dC19fD0",
      symbol: "test_USDC",
    },
  },
  {
    id: "0xCAcf91c58F3C5a708f850CD31ED860e7941d962a",
    version: "v2",
    name: "Reallocation Bot Test USDC",
    symbol: "rbtUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2dB50b2aFcc582e01fE42c31e5547789B7663317",
    version: "v2",
    name: "Rich USD",
    symbol: "richUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf0AF1C85e3B2f537038100f40A774F77d095370B",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x02ce3647472eBCFc91a5A3Fbb06032c4bD3Df59d",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x500c19ec7447439AC298f3db1e10551f5EdDE153",
    version: "v2",
    name: "everest",
    symbol: "EVER",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2f3dbc4a019a5C9BFF0ca51Ae54e87B5f5F4650",
    version: "v2",
    name: "everest",
    symbol: "EVER",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcd060d37dA15E19b5165725483c48496b195C086",
    version: "v2",
    name: "singapore",
    symbol: "SING",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9b7785B74d6cD9e33067743B79cd46Ee4aE0a89B",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA8A14eAB5Dc3c0b93b5213CAc8DFe29BC4538675",
    version: "v2",
    name: "RR Expeditions",
    symbol: "rrUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEF00283d2b26a55F56B9f8c283b25e9a22E95b",
    version: "v2",
    name: "Riva x Steakhouse USDC",
    symbol: "rivaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEf003c7df2AB8dEF9Fbfc4B233CC13f83D1dA5",
    version: "v2",
    name: "Riva x Steakhouse EURC",
    symbol: "rivaEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x6b648A1619149D64B6687a006785328421F32C56",
    version: "v2",
    name: "JonTest5",
    symbol: "JT5",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5436eE4f025C8a356d588429fF6fF6fB8649B122",
    version: "v2",
    name: "JonTest6",
    symbol: "JT6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x63F965252eF04c56110dc84A23269382639f275b",
    version: "v2",
    name: "EUSD automonarch",
    symbol: "AutoMeusd",
    asset: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
  },
  {
    id: "0x3f6fce7C19A03c2BFf0E44e346EF0639c954822b",
    version: "v2",
    name: "PLACEHOLDER GATED",
    symbol: "PLHG",
    asset: {
      address: "0x5B1820DAcf20f10f8772FfEf50B913A7FA94DaA8",
      symbol: "ArUSDC",
    },
  },
  {
    id: "0xae2efE058e92CD0ddBb4d0E558FCF475a3D29e6b",
    version: "v2",
    name: "Abilabs USDC Core",
    symbol: "abiUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8f675D684AA7849c1Acb147AfbC7cAD1cff55b96",
    version: "v2",
    name: "USDC Optimizer",
    symbol: "ajUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbDf82E3Bf8b526576F496AAC45a90f6Cb7FD2951",
    version: "v2",
    name: "auto-usdc",
    symbol: "aUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x240975D660826CD1Ba09F8Aad53E56669d0F5648",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD4Cb3B04686D947F3951641Db621CC777f816505",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x303C1B61E50Ec4a4dE6114c65daB926228EaAAF8",
    version: "v2",
    name: "BillFW",
    symbol: "BillFWS",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x86bb89BE8466B1e189986e5623d6C2F30119A24a",
    version: "v2",
    name: "hUSDC",
    symbol: "hUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x893a755278060F713a9DE35d1b62d24c84B48042",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper 2",
    symbol: "vaultUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B54DE37Ce9a8EF57F94Af722c804B0ACaa11d48",
    version: "v2",
    name: "TESTO",
    symbol: "TST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAD78165edB2e6Ab67AB61b1ce75a4A126Fc5507E",
    version: "v2",
    name: "USDC First Time Vault Testing",
    symbol: "USDCTEST",
    asset: {
      address: "0xFEAfd68F913664C87340390f1eB13d288dC19fD0",
      symbol: "test_USDC",
    },
  },
  {
    id: "0x7788c080B63b112708EA8Bc532cF806400c2C208",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf2261090CaF1A1E728805eC7709CB648434260e9",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper DEMO",
    symbol: "vaultUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4286Cd2D6FA9695F3B1f2D327CbbEE0Ac95D184B",
    version: "v2",
    name: "TestVault123",
    symbol: "TVL123",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x194b601876Aa4F47825785B7822773F4e3624ff8",
    version: "v2",
    name: "TESTO2",
    symbol: "TST2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1612387265ffE2880f364F841485C0980cc1D57a",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4556476852BF7059d3D515204291D4282E4b0299",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEeF006fb43820C864894892db0eCFEee3FdF587",
    version: "v2",
    name: "Riva x Steakhouse USDC",
    symbol: "rivaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEf00890534C736186f3126187Da80c961EdCa1",
    version: "v2",
    name: "Riva x Steakhouse EURC",
    symbol: "rivaEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x856f3341d40709C8BEfab7a6508F4d55A3F1e886",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9e957195e884DFAeD748C1e0C13299f71E8bEfDf",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x845d3b04464868E5aa42D5460ce991249b7649ee",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd6B89EEa0f6eA2b1B1e9976525632052e190E467",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x57D7Be897A1009f340e123FcBfB508fF3A48f045",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb7D0B66288F288BFa99E3f5dFD05cC61C87624A5",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA960Ff2abc4312dD2228aBfA17ea88C5cb0ad579",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x718dA548C7a4aFa51082C6E34F9220cB99788D4e",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc83659886C2Bc084BB859741BB04490991F4f207",
    version: "v2",
    name: "trios9",
    symbol: "trios9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA2b2FcA193e884c20A0C7242012FF0B6b89c347d",
    version: "v2",
    name: "test",
    symbol: "T",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x52Cd1fc69c79d4760f53d6467bC1a20344A65E7f",
    version: "v2",
    name: "AutoStable",
    symbol: "crazyUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd597848dF97A0C84872fF97D97273c99927dD3DB",
    version: "v2",
    name: "AngryVault",
    symbol: "aUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x06151Ea7368beE14FE2bE90aeea19fC9Ebd9b55d",
    version: "v2",
    name: "Reservoir",
    symbol: "RESERV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb42390A5b9B13636c0653eCB440c67ECf10692c2",
    version: "v2",
    name: "Supervault",
    symbol: "cash",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4724DA8428E6885fFD78DEF5c0626aC12a35aac0",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper DEMO 2",
    symbol: "vaultUSDC2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4313F2e39aE688a008dcF911522a384C431558b8",
    version: "v2",
    name: "Blue Chip Yield",
    symbol: "BCY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaaaC7eaa39A1Ca1520306d440A0494e9Ad24D3cC",
    version: "v2",
    name: "USDC Yielder",
    symbol: "USY",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcC219bD9A0b79c6Be8d5EE41ccE4e11061234069",
    version: "v2",
    name: "TRACK 1 - K (PROD X AK)",
    symbol: "K - TRACK 1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCde70f9cA87AdE02D529D360a05C3696D6Dd7CFf",
    version: "v2",
    name: "track 2 - jv x jd (prod. bb)",
    symbol: "t2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf72af0169DbcA884e3FB00909Ab9354AdDca948E",
    version: "v2",
    name: "BillFWFW",
    symbol: "FWFWFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2861ABE7AB28484Fb8375def4A7eb56C8F53fE8F",
    version: "v2",
    name: "Test",
    symbol: "TTT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAc8C6e8779Dddc60F5cEF7701DcE70eCBa5ef518",
    version: "v2",
    name: "Test Deploy Vault USDC",
    symbol: "tdVUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xABecC32B2CB67baDA358f82aE21cB598d56C2F41",
    version: "v2",
    name: "USDC Tester",
    symbol: "USDC_TEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x890e57019109531F3a6723Ea43b2DB20DBaBA54B",
    version: "v2",
    name: "Specie Base USDC",
    symbol: "specie-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7443C077b6bA8c30b25B832dbB6C4c21bf2e055a",
    version: "v2",
    name: "Brookwell Base USDC",
    symbol: "brookwell-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x01Fb7F4f156256bc0084421330305bA50a83501B",
    version: "v2",
    name: "Basecamp",
    symbol: "CAMP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD386C6cB273Fa4F3f95f279bAb9BE5fdcf5280C3",
    version: "v2",
    name: "OWL CAPITAL",
    symbol: "OWLcap",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x72f4dDb38Cb29037C83C25DA2072893a18f3E346",
    version: "v2",
    name: "the testing vault",
    symbol: "testUSDChehe",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC61d281b5f3DbE6f0963d5999A6B676B135b987E",
    version: "v2",
    name: "Galathil Precious Metals Vault",
    symbol: "GPMV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb3C01c4a3F89768686aD149c872b38Ad1b4AAa22",
    version: "v2",
    name: "x",
    symbol: "ueVL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x11F48A71906F30aE492b11FBCEd30Dd327838c05",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc5eb3C0c9A3478D0d0CbF10aE6c497754E049429",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD77a96aA1c5A2e04aEE974c120cd796083F29D64",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfE731Cce5BcfaC7c5DebBe9e9f6162bEd163F4a1",
    version: "v2",
    name: "x",
    symbol: "ueVF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x96a86b0904F6D169a426020f74D479Bd0015B2BE",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9f7104e5FbF66a3024D514be69b6a1c6B4C19C7B",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7432881299b794E6f26346345D638e51Cab512eE",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc006EA80aeDa14121933C5Be8d00304Af9647C54",
    version: "v2",
    name: "x",
    symbol: "uePL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD731Eb22e9cA01059F7F68564ce482Dd688d5fD6",
    version: "v2",
    name: "x",
    symbol: "uePL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x18801432601AFc3Fe711750b29244073DeA3C498",
    version: "v2",
    name: "x",
    symbol: "uePL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6aaFE7B4cE81BCCb2a00187914797398F8fc32c4",
    version: "v2",
    name: "x",
    symbol: "uePL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4b505232765dC4E7a6DeD9d2751258f926b0cd1e",
    version: "v2",
    name: "x",
    symbol: "uePF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD7B78d778c010B4c710CE045Ecac7Da10c6a9438",
    version: "v2",
    name: "x",
    symbol: "uePF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x82FC34743c0b0212A8D79fE203C295bcB02f92fA",
    version: "v2",
    name: "x",
    symbol: "uePF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x40A5EE68043C471D433affeD84Da0f9EFBed5433",
    version: "v2",
    name: "x",
    symbol: "uePF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xca9Bf7F30da2B7170E8E7C4aC2f9ec4C684C0577",
    version: "v2",
    name: "x",
    symbol: "ueSL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB23D30DEA12088FB76296734De8EEd6a782d7F3E",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeF00CB9e80a82c8984CF9e9229cC1329f760E91b",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x429cf35F73D9F0eD02Ea54b9D0FD0927bFD612b0",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4067f26B72B007363A241B9473B7447b2ceB4f70",
    version: "v2",
    name: "x",
    symbol: "ueSF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x67e442b0a373E99Da1601BA8F364010e9FE1B962",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x13A6e93E1B0cEe912549c2D36d374Fa6DfD2fE45",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8839BdFC74b1DD0FD27CCB7ca1d1d9506f1B042D",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe42A9C78253E2d78c1Dc44EFAD2D7f6f6B5Ca9c3",
    version: "v2",
    name: "WETH Autovault",
    symbol: "WETHa",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xdeF7f2e345defd4DADFd38a3233601418b60d4e2",
    version: "v2",
    name: "sdf",
    symbol: "adadf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9A3aeFE2cE328446Fa14e1b97878CFF46E6b9511",
    version: "v2",
    name: "InstantRefreshFW",
    symbol: "IRFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4fF3deDe31b04233D0eE9bE14a16222aCFB16946",
    version: "v2",
    name: "InstantRefresh2Renamed",
    symbol: "IR2Renamed",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6b1Fd1AbfF57829cBc86F38FFeDf0C1FBd37c3eA",
    version: "v2",
    name: "adjflkj",
    symbol: "jkljlk",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCb4804F519330295Fe0Fc952A30e69549b73f92b",
    version: "v2",
    name: "Base USDC",
    symbol: "base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfA1c6fb2de98FE9e1bC4d0A0d5f9A7f028c0A5B9",
    version: "v2",
    name: "Archer Base Boosted USDC",
    symbol: "archer-base-boosted-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x306a8E806F4f0c19069d1d76B2579Dd6E87cdC34",
    version: "v2",
    name: "Archer Base USDC",
    symbol: "archer-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCF75D2d4e561991FD1E1606A4fa793781d5f141d",
    version: "v2",
    name: "Abdicated",
    symbol: "ABD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA118400b05B1CbE6Fe2511d592a1C531004d5f60",
    version: "v2",
    name: "x",
    symbol: "ueVL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaB221Cfb3D3181C1Ac5B98a141889498dcBe064f",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x96d1d599FC18BAaB0cc47C78446EDF2e3E66bf7F",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x53003BdE4a4A10D7d3B8A61085398e7d16834636",
    version: "v2",
    name: "x",
    symbol: "ueVL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x17aB40c1F875087b5040A0Bb0977021ecEB1BD0a",
    version: "v2",
    name: "x",
    symbol: "ueVF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x20481183ad04875E82D41FE8A2Fd0EF6C2A3036d",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x84C2f281c6bf69cc62C2485402f996c8c201b5DE",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x660D9908879093aC7ec8B58346013FE951F81366",
    version: "v2",
    name: "x",
    symbol: "ueVF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdfD712adAeF95DedB9dbf1be427d4f9dF97B1D6F",
    version: "v2",
    name: "x",
    symbol: "uePL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE5f60D50F8c7b447CB594e806C6F570e117235D4",
    version: "v2",
    name: "x",
    symbol: "uePL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9565681736016E0D2cEB67221322fdaCAf0D9EBd",
    version: "v2",
    name: "x",
    symbol: "uePL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA0Bd8393B7A351dDf305fb0178fEB72232F7Fb2A",
    version: "v2",
    name: "x",
    symbol: "uePL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9032d2576271745DA1B0D589297e14f7ABeD1369",
    version: "v2",
    name: "x",
    symbol: "uePF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x54BBf796A34C49155135739B6B2479f4406174a1",
    version: "v2",
    name: "x",
    symbol: "uePF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb58b3f9ca91594586102809F7B25CAf7fCcA27f4",
    version: "v2",
    name: "x",
    symbol: "uePF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x221Aa2dCd43Fc75E0bC4961fc5Ef81cc9d8D6d73",
    version: "v2",
    name: "x",
    symbol: "uePF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B53F515961A3D5a84F6083D6cc4600A810CE08B",
    version: "v2",
    name: "x",
    symbol: "ueSL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc069CF3B061Ffd92e2b4105463a2FC5FF526e248",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x04eB11Ac7F75cE0B72ec75556bFf48f6462aF6FF",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0f9078E6B116b6FcC5885268407F73D1fBDb80A2",
    version: "v2",
    name: "x",
    symbol: "ueSL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb95731306031A09e0Dcaba7518E08813202f73e5",
    version: "v2",
    name: "x",
    symbol: "ueSF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xccFfb6e3219Ba3570c1811E33c49bA24c9755E33",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD875f214B6f89f26F055460A0df51047c5536870",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBAC8fb4b2d60d501C2DF4f70eE77077b1885De75",
    version: "v2",
    name: "x",
    symbol: "ueSF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x287397Fd29aBCdb1f514179099121895A2f5bEAF",
    version: "v2",
    name: "UE Verified Lien-Only",
    symbol: "ueVL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x376736A69B8F9c350F76E0b2802466Eaee7E058f",
    version: "v2",
    name: "UE Verified Lien-Only BR3",
    symbol: "ueVL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd6313868B5CeBAd6fDc3aE48F80917B385C01c71",
    version: "v2",
    name: "UE Verified Lien-Only BR6",
    symbol: "ueVL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2FFcbDEa42311515E3dB1F873A1Cea0D463B5Ced",
    version: "v2",
    name: "UE Verified Lien-Only BR12",
    symbol: "ueVL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0eD4c2cfff2Ec06079e723F51aeFC8cdF073ea68",
    version: "v2",
    name: "UE Verified Foreclosure",
    symbol: "ueVF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x34dDd63FEA2868EeF439279D6FeCa7d5AcFc4F53",
    version: "v2",
    name: "UE Verified Foreclosure BR3",
    symbol: "ueVF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc24C630D27CBF1Da6A78B09821212eb9c5e1be40",
    version: "v2",
    name: "UE Verified Foreclosure BR6",
    symbol: "ueVF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8E246a89a7F8ffD4efD7d037bD585F7741C0C482",
    version: "v2",
    name: "UE Verified Foreclosure BR12",
    symbol: "ueVF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x13D2E770cefB62A8Aa4e3393d59F88707AbD4dd5",
    version: "v2",
    name: "UE Prime Lien-Only",
    symbol: "uePL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCc19805E91C66Ca6a3dd437E8F6d579ca9727804",
    version: "v2",
    name: "UE Prime Lien-Only BR3",
    symbol: "uePL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2018963CA1e5ACeb88B7fA8738e4AEC846beD752",
    version: "v2",
    name: "UE Prime Lien-Only BR6",
    symbol: "uePL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x618fFcf6fF74dC3766B892B7913BF5074B913eF2",
    version: "v2",
    name: "UE Prime Lien-Only BR12",
    symbol: "uePL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x12d6bA2c11Bbb96F8f91b0412593b87dB4E2ABE2",
    version: "v2",
    name: "UE Prime Foreclosure",
    symbol: "uePF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFC274721AFdd37dB10419d08bd0db59E5Fcfb219",
    version: "v2",
    name: "UE Prime Foreclosure BR3",
    symbol: "uePF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x098A23332008Cffaf283E3b0e8EcDEcfDeb6849c",
    version: "v2",
    name: "UE Prime Foreclosure BR6",
    symbol: "uePF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf6EA5C33F0D33B56AAda9AF7Dd1C4203BB83C82F",
    version: "v2",
    name: "UE Prime Foreclosure BR12",
    symbol: "uePF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2BE1d9ddBbd70E7b148E8AdE884600268a0B28BD",
    version: "v2",
    name: "UE Standard Lien-Only",
    symbol: "ueSL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x060b5d11B1303FaB362bAF100EB37601F04C2AFD",
    version: "v2",
    name: "UE Standard Lien-Only BR3",
    symbol: "ueSL-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8Dfc0CaF025E62C634Ea179Ce04015f3ae51938a",
    version: "v2",
    name: "UE Standard Lien-Only BR6",
    symbol: "ueSL-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbfc2B2ECF46b9b585199920d95F972E42DD23e51",
    version: "v2",
    name: "UE Standard Lien-Only BR12",
    symbol: "ueSL-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xef7EEeed223a45EB09808F98cA2B15cA16C7306D",
    version: "v2",
    name: "UE Standard Foreclosure",
    symbol: "ueSF",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4d390F54327b8d4ca6DFaF8db58BCFdF0270697b",
    version: "v2",
    name: "UE Standard Foreclosure BR3",
    symbol: "ueSF-BR3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE6dfc9b8057135165B1aAAA741FbbBe0aF416104",
    version: "v2",
    name: "UE Standard Foreclosure BR6",
    symbol: "ueSF-BR6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x01EB25A573F1e86f46326B0DD1b4AB344ccB168E",
    version: "v2",
    name: "UE Standard Foreclosure BR12",
    symbol: "ueSF-BR12",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7b73A72952E99df7e8759cd0eDaC5811693e63f4",
    version: "v2",
    name: "Test",
    symbol: "TESTFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x329c1a214f1A27e0B65BbF120536c4179F49a656",
    version: "v2",
    name: "FeeWrapperTest",
    symbol: "FWT",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x585971863BbD1e03951809Ca892539819c2694f3",
    version: "v2",
    name: "Test",
    symbol: "TEST1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAfEd504B47036E5988B44bc2489A8d1306425514",
    version: "v2",
    name: "BaseJumpFeeWrapper",
    symbol: "BJFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1789e105B3507ad7142Ad6196e1418453e0C7972",
    version: "v2",
    name: "Safe Lend",
    symbol: "sfUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9470c9c42892bE7d286697404f29B1d5Bbf8015E",
    version: "v2",
    name: "Test2",
    symbol: "T2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x30f226eD59FFc2fb5F7B2c73C9EaD8437cB02839",
    version: "v2",
    name: "Test3",
    symbol: "T3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x66E40D0A5847006e8621a30eC1770925A0e81010",
    version: "v2",
    name: "hahohihifrance",
    symbol: "hahohihi",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE680C6D9772EEC17FCA6907dA839D1974Ca6A815",
    version: "v2",
    name: "hihihi",
    symbol: "haho",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9ad99078dfFd8Bca7247AE971152B799604EfC3B",
    version: "v2",
    name: "Morpho Vault",
    symbol: "TVLT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf790483861Dc1893CBeD70B5DAc755BECf5156BC",
    version: "v2",
    name: "i got bands",
    symbol: "bandsssssssssss",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdC33Da979D178409ec362028Be106d827905961f",
    version: "v2",
    name: "Yield Hunter USDC",
    symbol: "yhUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfF8BfdC9ADD5A8c10DB10A2557FbaB0520306b50",
    version: "v2",
    name: "SurfDAO KTA",
    symbol: "sdKTA",
    asset: {
      address: "0xc0634090F2Fe6c6d75e61Be2b949464aBB498973",
      symbol: "KTA",
    },
  },
  {
    id: "0x04871D1Fae8f6e1d133DbDdEED8d52Ca2497E048",
    version: "v2",
    name: "UE Standard Lien-Only BR12 Genesis",
    symbol: "ueSL-BR12-G",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xFa66acd1c6b34A32e9920AcC27fE35AEBBA2Bb24",
    version: "v2",
    name: "ARGt Vault",
    symbol: "mvARGt",
    asset: {
      address: "0xf016413834E6D1A14F3D628B11D6Ef725a6bdbDD",
      symbol: "ARGt",
    },
  },
  {
    id: "0x012f6f383F13BD437DFBfCBe94D1A8C5fC40E650",
    version: "v2",
    name: "UE Standard Lien-Only BR12 Genesis",
    symbol: "ueSL-BR12-G",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCae36b7074A958b72b2aB779313E250d4EabD871",
    version: "v2",
    name: "Base Test 2",
    symbol: "BT2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9cc96169060278f46C0459fF5b17db56e62142B0",
    version: "v2",
    name: "Mr autoEth",
    symbol: "AutoEth",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD2540BDCD2C14B618456B9fAeEbd3F57d808cDA6",
    version: "v2",
    name: "Vaara USDC",
    symbol: "vUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfE9bB7dC460f3DA266BE71D607728238962c89B7",
    version: "v2",
    name: "DDFeeWrapper",
    symbol: "DDFW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xceb217f3c45b4bf163EDc1cC46ac335C78ff4754",
    version: "v2",
    name: "dsfg",
    symbol: "wfsf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xc47B2BC94698FFbf692F6f0702Ea2BcbBBdf1B1d",
    version: "v2",
    name: "Demo",
    symbol: "DEMO",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x51E99d65861b9738E37C9813f106F67F2aeDC9c3",
    version: "v2",
    name: "test",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC2CCbD791566600A0EE879714cE2966471A3FD53",
    version: "v2",
    name: "ZTest",
    symbol: "ZT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x550101d2BE9edE413d4d320e42b331f9b2688Fd6",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURsam",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3D02061bbde0280689D6724599BBEc596eBeDD87",
    version: "v2",
    name: "Test",
    symbol: "testSMBL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa44e663efb955e1424db307F60da9e23320efeFc",
    version: "v2",
    name: "WETHFW",
    symbol: "WFW",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1Ca3014eA8846b4A5E4DA9FC580e6788fd010226",
    version: "v2",
    name: "Molecular research",
    symbol: "MRC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4f8372B6f05D787D44e4523595430f76c81D6C15",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURisam",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3f2dD9eBD0D7228D49473f6d2A14da261Ad96316",
    version: "v2",
    name: "PLACEHOLDER I",
    symbol: "PLHI",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x05F899Dfd83cA2d9E6F0Eb1aD27E4e8260E664fD",
    version: "v2",
    name: "Zen USDC",
    symbol: "zenUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD3dEaaFA70cDC371d60D5d31307C0EB043E722b2",
    version: "v2",
    name: "Test4",
    symbol: "T4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF5AA714eBbDb81B288143d178acf522C07C2e60e",
    version: "v2",
    name: "Test5",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB6f88d148d2c68F49d3D87813801C1E7f5cb8854",
    version: "v2",
    name: "Test6",
    symbol: "T6",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF295395E29CE71236a0735e44Be6FA93314b6d32",
    version: "v2",
    name: "Test7",
    symbol: "T7",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x911B1Ab0b21b6ad40AeFAeaD7A18C4d4886828b6",
    version: "v2",
    name: "Test8",
    symbol: "T8",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1c1D2CAD612ec4F289581B501302De07b7b37480",
    version: "v2",
    name: "Test9",
    symbol: "T9",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x80424540F76dD514a225f12802DF74f03d38448c",
    version: "v2",
    name: "Test10",
    symbol: "T10",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8f1ec747D88f31d18708a36061e955c47e91e24A",
    version: "v2",
    name: "Test11",
    symbol: "T11",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x59Ce9688fd6802b862E9e42eE3Bc07955D87b714",
    version: "v2",
    name: "Test12Edited",
    symbol: "T12Edited",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3694D768C84e3364C8A8a807BBdb7688A7fA6BCc",
    version: "v2",
    name: "Test13",
    symbol: "T13",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x07B95F937618dDd3e46d10d0Fd5f8192B3b8EaA9",
    version: "v2",
    name: "JonTestWrapper",
    symbol: "JTW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x541e0d05cc603256646897E2211d95024906121f",
    version: "v2",
    name: "Fee Wrapper",
    symbol: "FW",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf599E029A88e37171635a39c38763c6584DF7e3a",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaC4D47a2ba41EE175eB27Ef400050102D9ad6d59",
    version: "v2",
    name: "WTest",
    symbol: "WT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x701C3d592FfB1EfF8F71DD1c756CF05601C8869c",
    version: "v2",
    name: "OtherOwner",
    symbol: "OO",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1e6d4691B1633e201df9488b7213F7439663359f",
    version: "v2",
    name: "Monarch High Yield USD",
    symbol: "hyUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x10A84648fC6F7f1a2e7a602CB3b2b3924fEb8022",
    version: "v2",
    name: "00",
    symbol: "00",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbB803FeA9082EaFff036c38E1894b2f17AD35B25",
    version: "v2",
    name: "00",
    symbol: "00",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe17288A0DaBcBbaAb3C44D9C0B47E03f84d2E308",
    version: "v2",
    name: "GW",
    symbol: "GW",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xE15160AcE629b10AA35C7CC52D6D2A407BB2E67e",
    version: "v2",
    name: "TT",
    symbol: "TTT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x14e8eD81E138790F8e982D0ef7b317667c5e209e",
    version: "v2",
    name: "TTTT",
    symbol: "TTT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3ACE0C9B90CEf3A29C8459B1D4fD485476cE134D",
    version: "v2",
    name: "TEST12",
    symbol: "TEST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5a4a23C82B749E1B46e563762C1e728d095B4d09",
    version: "v2",
    name: "FastFW",
    symbol: "FFW",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6fBC06E968aC62455212cd5AdA9F2687Da27dbbD",
    version: "v2",
    name: "Test15",
    symbol: "T15",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5D212405C82c0d4ABD3eF537Fa0B6196d4C3bE90",
    version: "v2",
    name: "FastFW2",
    symbol: "FFW2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0F9ee43211F786761ACac8064c3ebf103FE0B3Ed",
    version: "v2",
    name: "TestTest21",
    symbol: "TT21",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x98f6abFCAa45d0c6D340F569454510FEC5223265",
    version: "v2",
    name: "test",
    symbol: "TT2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe40CCFc7C03DdE69b697C606D17c8D8E73a9f883",
    version: "v2",
    name: "DT",
    symbol: "DT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3e85810BE79c2E4E613f0023033d107A4Df82e98",
    version: "v2",
    name: "Base Test 3",
    symbol: "BT3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x405dC9C3Df961b23D1B5c8DCd935171DFa6Ad9C1",
    version: "v2",
    name: "Vault Name ",
    symbol: "exSymbol",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x45D3761449C3365294cd462f70997B8A918bb40f",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0e7717D3ea653cEec669d099C6b7FaF63Ec50ca8",
    version: "v2",
    name: "TJLKj",
    symbol: "jkljlksf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x28D0a445B348A29d41F17eb1c2ABbCd9Df80F356",
    version: "v2",
    name: "sdfklj",
    symbol: "ljlkjlk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xb04C07b3AaDEfbBB0Ec2E04F52e38c261BCEC386",
    version: "v2",
    name: "FJkljl",
    symbol: "jkljlk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd887F5d912a18177c9aD5A644e983C10fEE53458",
    version: "v2",
    name: "FJKLJKL",
    symbol: "JKLJLK",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6E203c64cFa072FfC4bAA898708f777AA9447fCA",
    version: "v2",
    name: "APXUSD",
    symbol: "RBC-APXUSD",
    asset: {
      address: "0xD993935E13851dd7517af10687EC7e5022127228",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x79900ce738cd2448AB9E1496AC833a7254681F2C",
    version: "v2",
    name: "Fee_Wrapper_Test",
    symbol: "FWT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1C23B34Cf401086eAC7E7271e281e112E08F22C4",
    version: "v2",
    name: "fdv",
    symbol: "fdfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xDe9c1885f2ECF26D7768096ABAD5EE9bb9628180",
    version: "v2",
    name: "adasd",
    symbol: "dsdsd",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0f8C303e9f964717a7A7c2afA79309290359DeC5",
    version: "v2",
    name: "rdfg",
    symbol: "gfgdfg",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x82fEF9C9D233730e6E50d806e7bc6B5b15bAaaAD",
    version: "v2",
    name: "Amolis-APXUSD",
    symbol: "AM-APXUSD",
    asset: {
      address: "0xD993935E13851dd7517af10687EC7e5022127228",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x4C0cC7a03396b6E43037ed5C83efA11f25D78981",
    version: "v2",
    name: "VTAO",
    symbol: "VTAO",
    asset: {
      address: "0x960717277E6cA67aD9E8cb262b787fEd0E03bbC7",
      symbol: "VTAO",
    },
  },
  {
    id: "0xef1E25CbB1672C180D0362e6c1AFe531154B099f",
    version: "v2",
    name: "Avvio Base USDC",
    symbol: "avvio-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1D8094DBcB389579873AA19335F7B021827084d4",
    version: "v2",
    name: "Encrypto Base USDC",
    symbol: "encrypto-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x743eebb02Ccf40fd6BDf575C13847Be4DE261f49",
    version: "v2",
    name: "Ditobanx Base USDC",
    symbol: "ditobanx-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8B61eb5Ec63957Cb7AeF563018a74ba87474845f",
    version: "v2",
    name: "Test",
    symbol: "stset",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9509eB851E80dB6278c7A61420e9765Da4b9616D",
    version: "v2",
    name: "Fjkj",
    symbol: "SDfFd",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x80DE8411982A1A5667f66AFC9F8433aDb8567610",
    version: "v2",
    name: "FinalTest",
    symbol: "FT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x8E3867AB50113dFE068435a53700114F6c61fAc2",
    version: "v2",
    name: "Test",
    symbol: "LiveTest",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4cb4c31Dc280034889f204A307C633C8e03De515",
    version: "v2",
    name: "safetest1",
    symbol: "SAFETEST1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xddf83A02690f8Cd6Fb2950fe55d4988d24C36b83",
    version: "v2",
    name: "jlkj",
    symbol: "kljlkjl",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x815751af387157572ba71A6D13c2fFBb89bf9B07",
    version: "v2",
    name: "sdf",
    symbol: "fdfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x2Aa897b23C8b4079445b2D5d258d3f0bA93D7430",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEUReri",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xcaB87A163c99AE0bc91A41A2E1672B084483E591",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURieri",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xB9d32A418BeeeCcB363dA42007F7d71E79F990E2",
    version: "v2",
    name: "FJLKjl",
    symbol: "jkljkldsf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x153330f072BcCE30f2565cE5919716E24541d62b",
    version: "v2",
    name: "jsdlfkjslk",
    symbol: "jlksdfjlk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf8ff67B8c2031421bdDe51F1e889E5e32bBB9Fef",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5A3d202DE29BdD44fF485683E99EaC56BfB8EDB5",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x71377eef6889D6a10f32ee223e82eAbEe5632500",
    version: "v2",
    name: "sdfsdf",
    symbol: "sdfsdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1eda5615D23FDcbA40DcE2c590C1A88e13CA29b7",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3f8BBf5a506AC089247E09e05B9353c4B641Ef82",
    version: "v2",
    name: "SDFDF",
    symbol: "DSFSDF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x26949DCea5944363470C60cbAc8f504cc78E82c7",
    version: "v2",
    name: "USDC Secured Crypto Lending",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x98d8c085161A0F813068ee77E361B1EBd202f3C0",
    version: "v2",
    name: "JKLJKL",
    symbol: "SDFF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x00941F64c4397b67e1acDBeb576637de81aC57A7",
    version: "v2",
    name: "SDF",
    symbol: "SDFSDF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3f45C2BAC13233b4759903D48BED128a43DE2f65",
    version: "v2",
    name: "ddfd",
    symbol: "fdfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x7873069c5476D54FdA6bC567134AAE4e6097EC7D",
    version: "v2",
    name: "sdf",
    symbol: "dsfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xEEA2B235e190F37530ee1B93466aba1E19Fd07aF",
    version: "v2",
    name: "SDFF",
    symbol: "SDFSDF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaf3F5D43e99A0F32C3BC00F11EAa4982D79D8d8d",
    version: "v2",
    name: "jknjk",
    symbol: "yiuyiu",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x28193f6986a77675b4B46c96747e018FAcaf9F73",
    version: "v2",
    name: "FDSF",
    symbol: "DFDF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x023532696D4DE0816Cb575B7f5CC705A30612D82",
    version: "v2",
    name: "Test Fee Wrapper 4",
    symbol: "TFW4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCbA8dDF90AE7624D9019039DE9868E2C3d2CB417",
    version: "v2",
    name: "sdf",
    symbol: "dff",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xbb2A05712d932182E6901157D4FccC9c6391e183",
    version: "v2",
    name: "sdf",
    symbol: "fdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd8c9bf5A7E0476d2a1EF5E8e1796860415D7a8BD",
    version: "v2",
    name: "sdf",
    symbol: "dfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4bed40eCeFb9485B2487c2288c6e18712C46c208",
    version: "v2",
    name: "TETS",
    symbol: "SDFF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xA2984B74c4Fe9beEDDB27126Aeb33Cc08aDDEAd8",
    version: "v2",
    name: "PCUSDC",
    symbol: "PCUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfd558f370540bcD3411d4877F4398350f1f6a05D",
    version: "v2",
    name: "Shift Base USDC Low Risk",
    symbol: "shift-base-usdc-low-risk",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAaD4Bd9deF14d85BF9Cc775afDbd9ed862CFE5A3",
    version: "v2",
    name: "Shift Test Dev",
    symbol: "shift-test-dev",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x15904fbf5bddc9BB8eC9f3f310C2A65633f8BA0E",
    version: "v2",
    name: "Philidor USDC Prime Base",
    symbol: "philidor-usdc-prime-base",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa44deeE8511aa395fe9f69596a2533857D422982",
    version: "v2",
    name: "Kravata GO Claro Base USDC",
    symbol: "kravata-go-claro-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x37Ef573A74a4176Bd04fE2A4D7d12253FB6ffA66",
    version: "v2",
    name: "Pagga Base USDC",
    symbol: "pagga-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4f42835632240f27eef6B6f5daCFc44c0dF9DD28",
    version: "v2",
    name: "TestSidebar",
    symbol: "TS",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD9dbAABA705Db2D2f1a75b46b0bA5a35e07e3e7E",
    version: "v2",
    name: "TestSidebar1",
    symbol: "TS2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x108E90f8Dc62e6dCCde7bf2491D85896b68851d1",
    version: "v2",
    name: "TestSidebar3",
    symbol: "TS3",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x02068ec196a7324B8106B790575E44149482c821",
    version: "v2",
    name: "TestCross",
    symbol: "TC",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x827c001E8314f98Fe5FA936ddf89e09f1b8ea847",
    version: "v2",
    name: "rETH isolated wETH",
    symbol: "0x420000000000000000",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x62edD47Be194233f72c7d492F00368F7A40E009f",
    version: "v2",
    name: "TESTTEST",
    symbol: "TEST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x14d574983fE2D205B654939E88F47d3C3249B1f9",
    version: "v2",
    name: "USDC Fundamental",
    symbol: "USDC_FUNDAMENTAL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5229B9b69C948D1aA90a13A17E551cFB138f75E6",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xBF9EC3a864B222BeC3DaC47C8Cf01dbbAEF2a409",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xF8b7EFfe9332aA8399751CdDc6Cfcc40233B4DDe",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x13dc47de205f968310792d4e09BDCEccc60379d6",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9b939BE68658998efD2aA2589E34f1b49D6b0C5f",
    version: "v2",
    name: "USDC Core",
    symbol: "USDC_CORE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xd2f48dd8726cBF6E2ABbDF5ae15a8Bf0C4739749",
    version: "v2",
    name: "et",
    symbol: "test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD8A052F64161aEC6fD749cd5da8b3fb6378DC8C9",
    version: "v2",
    name: "Aexora",
    symbol: "axUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe69DAb42c2bf09257303C1955F2cE7D6E805B30a",
    version: "v2",
    name: "trio00",
    symbol: "trios00",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF1262ECaB5b05599C98bBd732412863d3B66f2a3",
    version: "v2",
    name: "Test Steakhouse USDC Prime",
    symbol: "tstSHUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA8798EdCF64b4622d079BbE5b312AFF06A5885d3",
    version: "v2",
    name: "Test Steakhouse USDC Prime",
    symbol: "tstSHUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe254F7485D52BfB376656aE92fAF738cda090198",
    version: "v2",
    name: "Test Steakhouse USDC Prime",
    symbol: "tstSHUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB719Bc46cf17e9a3D9d1dE440b71796755060aE2",
    version: "v2",
    name: "Test Steakhouse USDC Prime",
    symbol: "tstSHUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x60eBb250C8Ff92895A19639c011Ec42F9cbf73c1",
    version: "v2",
    name: "TestNew",
    symbol: "TN",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaD7A545771463235DE081149eaF317D06b5c075E",
    version: "v2",
    name: "TestNew2",
    symbol: "TN2",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xF120dd3531eFDe0ED45555c3fb8beC7486b38241",
    version: "v2",
    name: "test123",
    symbol: "test123",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x59a0c89a9373F4bC09083A557Fd50c17c9550137",
    version: "v2",
    name: "CKTestVault",
    symbol: "CKTestVault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x710E4E0F2f9c6671aDA8A3D65a0f5Acf6277EC2f",
    version: "v2",
    name: "AgentSonya USDC Prime",
    symbol: "AGEN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAC3E4CFa66facbF7a6aB12F4B3F6652426fA7017",
    version: "v2",
    name: "Meow USD",
    symbol: "meowUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaB2b7055CBAf015125035f7279aae4BDDf1eFFDA",
    version: "v2",
    name: "trio5",
    symbol: "trio5",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3B79193512835D90fe9f891F959f6A4b75170F37",
    version: "v2",
    name: "Gitso Vault",
    symbol: "gtso",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAbAA4e014781793cD22Db965c408cB780B97D338",
    version: "v2",
    name: "test",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x93a4504eaf3e1a13B4412cfa141CfA90730faC85",
    version: "v2",
    name: "hl USDC Stable",
    symbol: "hlUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x40752409A262EA140e0F0713C7C298FeFDe85BcB",
    version: "v2",
    name: "hp-test",
    symbol: "hpt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9fB670Fec6F9C173909E05d2D2bcF55740687A31",
    version: "v2",
    name: "sdjfklsdjflk",
    symbol: "jkljlkjlk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x716314D302F9e38D689A6CB286F62Aebb553a3e0",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURlef",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x8Fdd499a96641f3DCcadA5a0dB9C1B7d8472BBa4",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURilef",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3A97553fc60b0df15A341b11101F551E4527f0fF",
    version: "v2",
    name: "dsf",
    symbol: "sdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x20318790369f465D6a24D1bC1d65A45fC5fc4d67",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1e9e47583f15D45a10Df48c0b1846E0492c795D7",
    version: "v2",
    name: "Galaxy USDC Quality",
    symbol: "gUSDCq",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x485Ac78fCB4369e987766e15B74B68270E2DbF0E",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6b301Beab8023304eCA82d435eb60e1CD702476C",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4Fc7A52F6201DB635A4C3B15c68B5BEe47c1b083",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x452263C3092E686a65FCcA006D10aDcE267e23eA",
    version: "v2",
    name: "Tenor WETH/USDC Vault",
    symbol: "tvWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x012AA671fB820c52D1A1eC41AA23303597988175",
    version: "v2",
    name: "Tenor wstETH/WETH Vault",
    symbol: "tvwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa65ad1D165166A3A9fA2cC238f1d763a4855c054",
    version: "v2",
    name: "Tenor WETH/EURC Vault",
    symbol: "tvWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x3A742E6806BEDA22ec7DA818aDc03d8fE72cf872",
    version: "v2",
    name: "Tenor cbBTC/USDC Lend Renewal",
    symbol: "tlrcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaa768548c84B68018B989ee1d876e0be3005549F",
    version: "v2",
    name: "Tenor WETH/USDC Lend Renewal",
    symbol: "tlrWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x92F7c0A8D74bc8F272E1fc6bC6cCEEE66b1926a7",
    version: "v2",
    name: "Tenor wstETH/WETH Lend Renewal",
    symbol: "tlrwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x21965ce59247FE4Ef9c3Dd18AfA9A51870D69A93",
    version: "v2",
    name: "Tenor WETH/EURC Lend Renewal",
    symbol: "tlrWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x302c6994010ba83e86EfB55647D0C47f72A60710",
    version: "v2",
    name: "kljlk",
    symbol: "bhjjhhjk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1F86A633f60d1f094Dd6E76Ffb110059d2CA9845",
    version: "v2",
    name: "jkljlkj",
    symbol: "lkjkl",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x44dd77d51629987d9555c762bF09903928c70206",
    version: "v2",
    name: "Alpha USDC Prime V2",
    symbol: "alphaUSDCPrime",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA710a3821F2F2b0517A745F3c6a5E585A7621C00",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURing",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x22617fddD6935250746f2d31a25e6D7ae13C94f0",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURiing",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x5EDF6BbE30afF4aaaDB5b6178590Bce446100EBe",
    version: "v2",
    name: "Infrastructure Value I",
    symbol: "infraV1USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x201a50916bf7f027fF6D4e587f18Dc0f488BE926",
    version: "v2",
    name: "FSD",
    symbol: "SDFSDF",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd542fe71de0814AE87Be600FE5a6832B45551B60",
    version: "v2",
    name: "fdf",
    symbol: "df",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff2490FEffa212faC2f6553682C219E6a8845",
    version: "v2",
    name: "Steakhouse High Yield USDC Edition",
    symbol: "sirloinUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8De7088C575F40875a8e6E6c53883dAa312741cf",
    version: "v2",
    name: "Bloom Base USDC",
    symbol: "BLOOMBASEUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdadbDe477B9267c559674DCFAa6972F1cba9aBE6",
    version: "v2",
    name: "sinc-USDC",
    symbol: "SINC-usdc",
    asset: {
      address: "0x49E392de962Fa835B862F59E78611c69E930b5C4",
      symbol: "SINC",
    },
  },
  {
    id: "0xB96A11F8147e90F6B114B9bb98B0E912B216868c",
    version: "v2",
    name: "ShortYourCash",
    symbol: "Fixed Income Portfo",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe2a7635acdffA714f5930EAB11401551682B69b0",
    version: "v2",
    name: "sdf",
    symbol: "sdfdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6556e20d9267705712B379b750bf48A402bA372d",
    version: "v2",
    name: "[DEPRECATED] ByzPrime USD Sandbox",
    symbol: "byzEURsdx",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb7F226A02e7a725C2DA8E5DF4561E0eD5B04E351",
    version: "v2",
    name: "ByzPrime USD Sandbox",
    symbol: "byzUSDsdx",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7aA6B0aff73E3E0416CdfCD64F51E5cFa910ad01",
    version: "v2",
    name: "ByzPrime EUR Sandbox",
    symbol: "byzEURsdx",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xf122fD0116c56AB53d0dad9Ce1c04484D61662D5",
    version: "v2",
    name: "NewFW",
    symbol: "NF@",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x644951B29ed3A2CF8AD0489fa852025Cf0A10611",
    version: "v2",
    name: "TestBasic",
    symbol: "TB",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0437570E6D0E61c20693b3e63269318502f6E687",
    version: "v2",
    name: "USDC → Trade-Receivables RWA",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA1168D47Fc27775153f210c663BdCb3761070c8F",
    version: "v2",
    name: "Fiber USDC Base",
    symbol: "FUSDCB",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB67347b107475bA9E7B0640a3Dc4fb9A0CE9f720",
    version: "v2",
    name: "TEST",
    symbol: "TEST",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xEE424c355f0db6b85d6923F77F479c7487171B5f",
    version: "v2",
    name: "GBLIN PROTOCOL USDC",
    symbol: "GBLIN-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x291c9BBA34B776C2fbeA6c22018a8946AeED6974",
    version: "v2",
    name: "hp-test-new",
    symbol: "HPTN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDBd4615d6375bfaD53480d6e76a78bF3D7d06bD2",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC7CA3DdFD0B9e319e8ee323FA1c618BC7e352C25",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x39E18c066187c83e860801Befe45aE8ecd021575",
    version: "v2",
    name: "Bitso USDC Prime",
    symbol: "bitusdcp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xeacf05F54a2424ADf0d21cc1CE99b077D837664c",
    version: "v2",
    name: "sesdf",
    symbol: "dsfsdf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x24C37C19D48de09A016D40F74d992fEc00975B98",
    version: "v2",
    name: "sdf",
    symbol: "sdfsdf",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD80538228D6F14551EfF7d9f8a36CFc163Cec301",
    version: "v2",
    name: "Base",
    symbol: "Base",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x20dF8f2eB0E885640466C42030B6cdB1d7CfCD36",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xaeC90e0558B500008d5788C149032F8d76bc2d77",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2f6bAf4a9F09D947aB55D39cC394c08E2A47eCc7",
    version: "v2",
    name: "Test",
    symbol: "T",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4F77d31b1C82810A720C32Ac8551283832321757",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x89fB553b70230580032c054E7A1159b962dd3146",
    version: "v2",
    name: "WETH",
    symbol: "WERT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x09DD31a126c64014f8435Ed93a3c488F17708d33",
    version: "v2",
    name: "USDC",
    symbol: "US",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe1E5f44877673019195360C35AAA1aB8d2c37942",
    version: "v2",
    name: "Test",
    symbol: "TEst",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x409C0892a8532C546203A07D68de680a1933be6e",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xcca34c96F5Ace8BeB0cCd9B9DCbEb0Df419D28f8",
    version: "v2",
    name: "Test",
    symbol: "TE",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x071FF6bBc5848fc542FA68d45E13854C2d01bE8E",
    version: "v2",
    name: "WVAULT",
    symbol: "WV",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x959cB20D3ecE76D56aD4509242faBe34aF3e85ac",
    version: "v2",
    name: "sdf",
    symbol: "sdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xc2CCb38CEb58E3599f9aCEC8B6b7D34Bb41BB4af",
    version: "v2",
    name: "VaultName",
    symbol: "VN",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xB293651EA8e3Dbe7FDE4Bc56D46FAfcf6dC68747",
    version: "v2",
    name: "Base Test 2",
    symbol: "BT2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0413aBDf389BB291a539BAEa8D225E758EBb99ef",
    version: "v2",
    name: "ZB Testing 3",
    symbol: "test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1F0a7De01EfD9391C4C59F5575f416d20Ab7D822",
    version: "v2",
    name: "Testing Live",
    symbol: "testLIVE",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x533613c45c4F67bc11A4F75773cd40021d38fD33",
    version: "v2",
    name: "Test",
    symbol: "testUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1c2f5C628bBbFEAe7e3FAeB8a8E9059291787FBc",
    version: "v2",
    name: "HELOC Pool",
    symbol: "HELOCPool",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x439F8e6cCe7CF217eB88b7BeD2A819F62dA85103",
    version: "v2",
    name: "sdfsdfsdf",
    symbol: "jkljlkj",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC8d124BED428D11208aE0d7F427ffEaBa703eA8D",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaa22a7b3487309E1C785a5B5B9a35eD9DC75aEeA",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0b3ffE68449ED71Fc7b50Ed73783F38f3B4fDaCD",
    version: "v2",
    name: "Tenor WETH/USDC Vault",
    symbol: "tvWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB0530fc4bb4d7793F997Ad6Efc4062330da96EDe",
    version: "v2",
    name: "Tenor wstETH/WETH Vault",
    symbol: "tvwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3619d540ab709747f1D1455a29465147deB5EEdB",
    version: "v2",
    name: "Tenor WETH/EURC Vault",
    symbol: "tvWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x53E6cD0AAA35692d0daFf552641759354A1979A5",
    version: "v2",
    name: "Tenor cbBTC/USDC Lend Renewal",
    symbol: "tlrcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB0DEFb72bAa2385c1793f9A177EA1aedDD343d07",
    version: "v2",
    name: "Tenor WETH/USDC Lend Renewal",
    symbol: "tlrWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x560BEb7a505F443c6629a79B54770a5e9C098192",
    version: "v2",
    name: "Tenor wstETH/WETH Lend Renewal",
    symbol: "tlrwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x590a9460Ec8cd97D253636B6A9e175E5f6E1e01a",
    version: "v2",
    name: "Tenor WETH/EURC Lend Renewal",
    symbol: "tlrWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x28a30766EF6eCA9e295E9995cAFb44b733144B8a",
    version: "v2",
    name: "TE",
    symbol: "tset",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDEF753047FB2954a1E7B90f3aeD0248063A055bC",
    version: "v2",
    name: "In progress Vault",
    symbol: "gf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xE662e6DffB5BF0332736d51C828d65D9d6f20EfC",
    version: "v2",
    name: "624",
    symbol: "wah",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD21581B01e7E8F7db7A8C0187C9f6CF0d5e966A9",
    version: "v2",
    name: "654",
    symbol: "654",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xC41d956Fc650F0cB71fDa283EB4afc868646451F",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe6f335bf338CDdE73f22BA9883647E82b196cF02",
    version: "v2",
    name: "Final Test",
    symbol: "finalTest",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0d5cda4c67B75D6F18c3Ac0Db276411b046ebe4e",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0Cc08425c81442581EEFD22c2D8d81b45008A1a5",
    version: "v2",
    name: "WethTest",
    symbol: "WT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x59f4e9cEa3Fe4BEe01dB564E248D8774E0b9B0B3",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4265899E4EAF89e86970159D56Fa5C2DCFb5d4A2",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xb9248a05A656f3fC080dCAfe46434D29d19Cff5A",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7bE0ebD1ad8f41B156564B02F62D0AA923Ae9762",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe6C195ed52b66A5978035ECe2fBa3e4Bd12e7594",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0A41B515EE34aD5e6f798DbAE1F86088Ed48FfdB",
    version: "v2",
    name: "Palm sweaty",
    symbol: "knees weak",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x680B3bD338fF9ABd6fE41AaAc1ee6CB98F0fA109",
    version: "v2",
    name: "Base Test 3",
    symbol: "BT3",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x73df90E3FaA1eB7290909941D58609735622d241",
    version: "v2",
    name: "Base Test 4",
    symbol: "BT4",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xB901EC70C0F5B8E30E3A5E350B5dE0fC4fd27cdE",
    version: "v2",
    name: "LayerCover Prime",
    symbol: "LP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x078A3C2e03051267C85caD968994055e80e04733",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x46A48Ca3F63aeA15c26dC931BA89495eE379389D",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xBF409a0c36C9d4819e7739227802e61AD664CEE2",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x2a1E42562140D1cdBed663155a4Dbe02fEE9055d",
    version: "v2",
    name: "USDC",
    symbol: "USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xC687AD86F9c392610E126fe5bE542F4399C63531",
    version: "v2",
    name: "PumpleBee USDC Premium",
    symbol: "pbUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x926EB14A9a4d5fB13aE2d0135C0212758F039B90",
    version: "v2",
    name: "WETG",
    symbol: "WW",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf0eab97d528cFF04B109757Ea65CAe666996fE16",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xF667E8A3C92b06f8DC2CfEE7166CB152611F1717",
    version: "v2",
    name: "Tenor cbBTC/USDC Vault",
    symbol: "tvcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x8C8D836dbA1A75060655457f3F311f8f2888ebaF",
    version: "v2",
    name: "Tenor WETH/USDC Vault",
    symbol: "tvWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbCFDB472d2c598A1E3337A99B42b5bd0f5fC4e3F",
    version: "v2",
    name: "Tenor wstETH/WETH Vault",
    symbol: "tvwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xAA7B32f7c11bcE13F0e7A652bCBFbE2775D50736",
    version: "v2",
    name: "Tenor WETH/EURC Vault",
    symbol: "tvWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xaeEf2473F5D048e3ccc50F9C3497C83A7F1598dB",
    version: "v2",
    name: "Tenor cbBTC/USDC Lend Renewal",
    symbol: "tlrcbBTC-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xf2bCAC82e30befe4e56d69cBe5e30Dbb50e0Fc2D",
    version: "v2",
    name: "Tenor WETH/USDC Lend Renewal",
    symbol: "tlrWETH-USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9E87a081976D5d7e9D5fA823872552AB3a1d021d",
    version: "v2",
    name: "Tenor wstETH/WETH Lend Renewal",
    symbol: "tlrwstETH-WETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xBe261af137Aab1B1Ee0f73C0A3A0f57d556327C9",
    version: "v2",
    name: "Tenor WETH/EURC Lend Renewal",
    symbol: "tlrWETH-EURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xd5F98083437ab785FF17146C351B6f81B6deCBFe",
    version: "v2",
    name: "Dipatrade Conservative USDC",
    symbol: "dipatrade-conservative-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA156f4DE5f8576DB5e6f1220adeCb3b5931ae755",
    version: "v2",
    name: "Dipatrade Moderate Base USDC",
    symbol: "dipatrade-moderate-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xbB3C58664F8831a394f4C50016dAc27DE5Eb93E2",
    version: "v2",
    name: "Dipatrade Aggressive Base USDC",
    symbol: "dipatrade-aggressive-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2552057feeF0337afA4bBC7a699663F627261F2b",
    version: "v2",
    name: "SurgePay Base USDC",
    symbol: "surgepay-base-usdc",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x53D065Ac881A33F5F296959556c209C6099fb92C",
    version: "v2",
    name: "CBHP Vault",
    symbol: "CBHPV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x08cc279532f159BdB450eBc0bAf6562f585Ded58",
    version: "v2",
    name: "Juno MXNB Prime",
    symbol: "bitmxnbp",
    asset: {
      address: "0xF197FFC28c23E0309B5559e7a166f2c6164C80aA",
      symbol: "MXNB",
    },
  },
  {
    id: "0xffFA6F26D45E39418749D1a1163E9315Df63b931",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x274D82de3DaEd2601e11Bf412b926F2A00904C75",
    version: "v2",
    name: "USDC",
    symbol: "TT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x111177d7411fBeA4806aE3A04bE4a5F58c3d9E16",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B2bAfBf97b77A6cE5b440Bf6036AAF36D5731D0",
    version: "v2",
    name: "sdf",
    symbol: "sdf",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9c980b4941e76c4149468CA7F90BaCefd24B8C7F",
    version: "v2",
    name: "basic",
    symbol: "basic",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xF4DcA2762C03378Cf638607230C44c4c0EAd1777",
    version: "v2",
    name: "Log test vault",
    symbol: "LogUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xDA66b200f121530bB7979358fc9B6184085fC146",
    version: "v2",
    name: "Test Log",
    symbol: "logUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x40653FB00724EA3c5d752A482D2Bde8187c0704b",
    version: "v2",
    name: "sanying",
    symbol: "Sanying",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x45969042b5Cc6741F1e8aDa62FCE34724E3583b3",
    version: "v2",
    name: "HELOC Pool",
    symbol: "HP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4a03aA4D2e52388ca4eCA5F4f6c610f82BA8C2bD",
    version: "v2",
    name: "albist WETH",
    symbol: "albistw",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa5F8e8630A86A587e04a18b5a5E39D19b23b4867",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURman",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x1a26d7a0FC0A1Bd07e544189Fd0Ba0b79cA84A33",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURiman",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0x2C7Cae57B31b5Db62189a82D1dEaEcac43bc5D0A",
    version: "v2",
    name: "wsteTH-USDC-NEW",
    symbol: "WUN",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x087D8D3611cD2fD5B71b4E23320a01cfB9B590Ef",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf012ff732685e968B7981f9285E86eD64198bAE2",
    version: "v2",
    name: "Devin Test Vault",
    symbol: "DTV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xD8781e6A05DA51762CB31727918436c3DDc8A025",
    version: "v2",
    name: "WETH-USDC_NEW2",
    symbol: "WUDT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xaf831A4D3d7c847F2355793600478E05F62Fd0F8",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf95C05Dbc0EcAeDBf5Fc536F1d585Aa964E36017",
    version: "v2",
    name: "Gneiss Pioneer USDC",
    symbol: "gnpiUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x53F88B107f958cd7a58Ef54E58F92F414c31A50F",
    version: "v2",
    name: "Test Vault",
    symbol: "CBHP Test",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x05be6f02cee64E1706fc06b7f1C7458f8e8c641B",
    version: "v2",
    name: "Test",
    symbol: "TT",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xA9285961ccb31ac9973B65E0679217F8a03FBC09",
    version: "v2",
    name: "DEADBOX USDeAD Cash Vault",
    symbol: "DeADVault USD",
    asset: {
      address: "0x9Bc2C28DF6560C343d3fa9c152Bed80D4511DEAd",
      symbol: "USDeAD",
    },
  },
  {
    id: "0x2a521F0e4715F9131e5550C8F2672d201dcA6E8b",
    version: "v2",
    name: "aa aa",
    symbol: "aa",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa19034F2dB093b1951D1023A8B3A9b801E22647C",
    version: "v2",
    name: "CBHP Vault",
    symbol: "CBHP_Vault",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x49d0Ae41Dd33A30879b457eb60535417846CbcdC",
    version: "v2",
    name: "weeee",
    symbol: "riskUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x07F066099F1F7aB549126FC499Fc03AF51DD39aB",
    version: "v2",
    name: "poop",
    symbol: "poopUSD",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xE101c3f6f5910B69c3e0E75cFf0cE7D9Fd83461e",
    version: "v2",
    name: "yieldfarming",
    symbol: "yieldfarming",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x88514B4003D154AF72A3457d6a3E2c903fe62d28",
    version: "v2",
    name: "testit baby",
    symbol: "tstbaby",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x29A6b60dD73A857d9d4DFf4AfE7f215Dbf4186c7",
    version: "v2",
    name: "Base Test 5",
    symbol: "BT5",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x04B9Dfd99640B76bdaFb2B7ab226e5B2781c3Fb0",
    version: "v2",
    name: "DEADBOX USDC Cash Vault Sub-Prime Gains",
    symbol: "DeADVault USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xAE4181CFB5aaA08bbE77d269c6B595672b9F9Edc",
    version: "v2",
    name: "RockawayX Midas USDC Prime",
    symbol: "mpUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x55c002822819c0f6033A78CD32E385550860609a",
    version: "v2",
    name: "Test",
    symbol: "setset",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x77216Df283c8F7a5950273e05E2a91C032E33833",
    version: "v2",
    name: "test",
    symbol: "njkhk",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9C3F738C06855F0330Aa79dFf2106c6008151f27",
    version: "v2",
    name: "Smooth EURC",
    symbol: "sbEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xf0C6da335770aAB2aB06802D1EC11783D38a8b42",
    version: "v2",
    name: "FeeFill",
    symbol: "feeToFil",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xA9e057b6d6cEF15B2CE6f30FE8f6B500A4a31466",
    version: "v2",
    name: "Smooth USDC",
    symbol: "sbUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xe273D384CB3024362Abea2064Ad0007B6C772c90",
    version: "v2",
    name: "LayerCover RWA",
    symbol: "LC-RWA",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5e6fc406960a1C2d9Ab6813fF1c914c6836bC53E",
    version: "v2",
    name: "Trezor Steakhouse USDC Prime",
    symbol: "trSHUSDCp",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4EDC6aB1964e25eb2C202AB9F201E9548BAa53dF",
    version: "v2",
    name: "Trezor Steakhouse ETH Prime",
    symbol: "trSHETHp",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xA678e586258047B3f299FaEf06fCDA3867eB07D3",
    version: "v2",
    name: "SingularV base ETH",
    symbol: "bsvETH",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x5F7f1C400B82E2c21F552EccbE45Ad181EAD9Be9",
    version: "v2",
    name: "Rent",
    symbol: "rentUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa342EF1d7F235FB9E50Ed63Cc9CfA5a9844CB2D4",
    version: "v2",
    name: "Test EURC",
    symbol: "tEURC",
    asset: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
  },
  {
    id: "0xB9CA76f0D8F538004B0a40614d1d1Ee32B3F7974",
    version: "v2",
    name: "HELOC Vault",
    symbol: "CBHP",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x66057b6bf3f891844D657C5651B56D387a23794A",
    version: "v2",
    name: "0x4200000000000000000000000000000000000006",
    symbol: "hjkhkj",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe5dBDFE635Cf104255dFd1fcc205E03D5ec2c22D",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x59eC7A35fa89d5f21E3100a2638772beF7e029d7",
    version: "v2",
    name: "USDbist",
    symbol: "bibist",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xcc4219460799Ca31d698fF78C418e5694b926Fae",
    version: "v2",
    name: "tet",
    symbol: "setst",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x60754e8780C1ca04Dbd2943e1B60D48fB3f10Ec7",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xD084572fFd96cFC514ED353cD0389DFF40119886",
    version: "v2",
    name: "crtest",
    symbol: "crrt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a229531Bd1d90b5EA0354c097bdAf5d42B091f5",
    version: "v2",
    name: "Northlake USDC 803041",
    symbol: "NLU0605",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x0a0d0061d760BEe503875BCdD4c514529C88c01c",
    version: "v2",
    name: "bearUSDC",
    symbol: "bUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x7ac0786fd8147919F6f51Ab20F10f7A65605a634",
    version: "v2",
    name: "BearBTC",
    symbol: "bBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7F9029c67A82C6663CfFA5f9d84fc9780C7bF7b9",
    version: "v2",
    name: "Northlake Growth 810606",
    symbol: "NLG810606",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x62687dc2F10F8255C5130ED1C91A95a549CeA19A",
    version: "v2",
    name: "Billionaires Crypto Club",
    symbol: "BCC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xa222C0310AD3920D9d5b8826Ccf5C60871946A39",
    version: "v2",
    name: "ZenDollar",
    symbol: "zDOL",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x869b8f3ED4F43BCBB20812f90684B894020aF101",
    version: "v2",
    name: "prova",
    symbol: "PRV",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb26fD309274478c665cE2Cd20872c41b87BeDDD5",
    version: "v2",
    name: "test",
    symbol: "TST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xfEFe6756142deBeb838dEb9600573Abe89A4Ac65",
    version: "v2",
    name: "Test",
    symbol: "TST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xdDF2020DE2c8315EE296B59e13DeB2F72d67cC6A",
    version: "v2",
    name: "Custom",
    symbol: "CSTM",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4B95e9431B7d5C60a0548dce739835d77b7B795b",
    version: "v2",
    name: "cache-007",
    symbol: "c007",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x4680d01422f09a432298b4DaD47cAb59144C8148",
    version: "v2",
    name: "Live Testing",
    symbol: "liveTEST",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x667c2a25A37A5271b61c42b150810C438D32403A",
    version: "v2",
    name: "TestMOR",
    symbol: "TestMOR",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x66c45643A4Be38d4e7Fe06A7922287C45b730bb0",
    version: "v2",
    name: "REIT Ciclo Nova USDC Vault V2",
    symbol: "rcnUSDCv2",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xCAEf8EccEA758daA227B17127B58D11C21A8D32e",
    version: "v2",
    name: "Better USDC",
    symbol: "bUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEfF0be997Cca5B1c13A7433c2004637975739e",
    version: "v2",
    name: "Ethena x Steakhouse USDC",
    symbol: "ethenaUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x040E49e8E4Aa9E962E26077272029C4fAD304b79",
    version: "v2",
    name: "USD1",
    symbol: "USD1",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x794A6D76c231d6CDC4DB9844F798301b59FdD662",
    version: "v2",
    name: "Super Morpho",
    symbol: "SM USDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x5d94c9f2da924A548eE7252903624AB902E5F734",
    version: "v2",
    name: "tttt",
    symbol: "ttttt",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x46FF1De5156F866dd8700a8b8DF896095EeD5189",
    version: "v2",
    name: "Client oTAO Vault",
    symbol: "oTAO",
    asset: {
      address: "0xa6784D8c96C20c0429f5231BBDCBb4c67Ad3F24E",
      symbol: "vTAO-Test",
    },
  },
  {
    id: "0x15B95e0efd4a68e1233156bab7b1B98dcB5332Ef",
    version: "v2",
    name: "monarch vault",
    symbol: "uUSDC",
    asset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
] as const
